export default [
  {
    "name": "3D-Cursor",
    "label": "3D cursor",
    "path": "32/watson-health/3D-Cursor.svg"
  },
  {
    "name": "3D-cursor--alt",
    "label": "3D cursor alt",
    "path": "32/watson-health/3D-cursor--alt.svg"
  },
  {
    "name": "3D-curve--auto-colon",
    "label": "3D curve auto colon",
    "path": "32/watson-health/3D-curve--auto-colon.svg"
  },
  {
    "name": "3D-curve--auto-vessels",
    "label": "3D curve auto vessels",
    "path": "32/watson-health/3D-curve--auto-vessels.svg"
  },
  {
    "name": "3D-curve--manual",
    "label": "3D curve manual",
    "path": "32/watson-health/3D-curve--manual.svg"
  },
  {
    "name": "3D-iCa",
    "label": "3D ICA",
    "path": "32/watson-health/3D-iCa.svg"
  },
  {
    "name": "3D-MPR-Toggle",
    "label": "3D MPR toggle",
    "path": "32/watson-health/3D-MPR-Toggle.svg"
  },
  {
    "name": "3D-print-mesh",
    "label": "3D print mesh",
    "path": "32/watson-health/3D-print-mesh.svg"
  },
  {
    "name": "3D-software",
    "label": "3D software",
    "path": "32/watson-health/3D-software.svg"
  },
  {
    "name": "3rd-party-connected",
    "label": "Third-party connect",
    "path": "32/watson-health/3rd-party-connected.svg"
  },
  {
    "name": "4K",
    "label": "4K",
    "path": "32/4K.svg"
  },
  {
    "name": "4K--filled",
    "label": "4K filled",
    "path": "32/4K--filled.svg"
  },
  {
    "name": "accessibility",
    "label": "Accessibility",
    "path": "32/accessibility.svg"
  },
  {
    "name": "accessibility--alt",
    "label": "Accessibility alt",
    "path": "32/accessibility--alt.svg"
  },
  {
    "name": "accessibility--color",
    "label": "Accessibility color",
    "path": "32/accessibility--color.svg"
  },
  {
    "name": "accessibility--color--filled",
    "label": "Accessibility color filled",
    "path": "32/accessibility--color--filled.svg"
  },
  {
    "name": "account",
    "label": "Account",
    "path": "32/account.svg"
  },
  {
    "name": "accumulation--ice",
    "label": "Accumulation ice",
    "path": "32/accumulation--ice.svg"
  },
  {
    "name": "accumulation--precipitation",
    "label": "Accumulation precipitation",
    "path": "32/accumulation--precipitation.svg"
  },
  {
    "name": "accumulation--rain",
    "label": "Accumulation rain",
    "path": "32/accumulation--rain.svg"
  },
  {
    "name": "accumulation--snow",
    "label": "Accumulation snow",
    "path": "32/accumulation--snow.svg"
  },
  {
    "name": "activity",
    "label": "Activity",
    "path": "32/activity.svg"
  },
  {
    "name": "add",
    "label": "Add",
    "path": "32/add.svg"
  },
  {
    "name": "add--alt",
    "label": "Add alt",
    "path": "32/add--alt.svg"
  },
  {
    "name": "add--filled",
    "label": "Add filled",
    "path": "32/add--filled.svg"
  },
  {
    "name": "add--large",
    "label": "Add large",
    "path": "32/add--large.svg"
  },
  {
    "name": "add-comment",
    "label": "Add comment",
    "path": "32/add-comment.svg"
  },
  {
    "name": "agriculture-analytics",
    "label": "Agriculture analytics",
    "path": "32/agriculture-analytics.svg"
  },
  {
    "name": "AI",
    "label": "AI",
    "path": "32/AI.svg"
  },
  {
    "name": "ai-governance--lifecycle",
    "label": "AI governance lifecycle",
    "path": "32/ai-governance--lifecycle.svg"
  },
  {
    "name": "ai-governance--tracked",
    "label": "AI governance tracked",
    "path": "32/ai-governance--tracked.svg"
  },
  {
    "name": "ai-governance--untracked",
    "label": "AI governance untracked",
    "path": "32/ai-governance--untracked.svg"
  },
  {
    "name": "ai-launch",
    "label": "Launch AI",
    "path": "32/ai-launch.svg"
  },
  {
    "name": "ai-results",
    "label": "AI results",
    "path": "32/watson-health/ai-results.svg"
  },
  {
    "name": "ai-results--high",
    "label": "AI results high",
    "path": "32/watson-health/ai-results--high.svg"
  },
  {
    "name": "ai-results--low",
    "label": "AI results low",
    "path": "32/watson-health/ai-results--low.svg"
  },
  {
    "name": "ai-results--medium",
    "label": "AI results medium",
    "path": "32/watson-health/ai-results--medium.svg"
  },
  {
    "name": "ai-results--urgent",
    "label": "AI results urgent",
    "path": "32/watson-health/ai-results--urgent.svg"
  },
  {
    "name": "ai-results--very-high",
    "label": "AI results very high",
    "path": "32/watson-health/ai-results--very-high.svg"
  },
  {
    "name": "ai-status",
    "label": "AI status",
    "path": "32/watson-health/ai-status.svg"
  },
  {
    "name": "ai-status--complete",
    "label": "AI status complete",
    "path": "32/watson-health/ai-status--complete.svg"
  },
  {
    "name": "ai-status--failed",
    "label": "AI status failed",
    "path": "32/watson-health/ai-status--failed.svg"
  },
  {
    "name": "ai-status--in-progress",
    "label": "AI status in progress",
    "path": "32/watson-health/ai-status--in-progress.svg"
  },
  {
    "name": "ai-status--queued",
    "label": "AI status queued",
    "path": "32/watson-health/ai-status--queued.svg"
  },
  {
    "name": "ai-status--rejected",
    "label": "AI status rejected",
    "path": "32/watson-health/ai-status--rejected.svg"
  },
  {
    "name": "airline--digital-gate",
    "label": "Airline digital gate",
    "path": "32/airline--digital-gate.svg"
  },
  {
    "name": "airline--manage-gates",
    "label": "Airline manage gates",
    "path": "32/airline--manage-gates.svg"
  },
  {
    "name": "airline--passenger-care",
    "label": "Airline passenger care",
    "path": "32/airline--passenger-care.svg"
  },
  {
    "name": "airline--rapid-board",
    "label": "Airline rapid board",
    "path": "32/airline--rapid-board.svg"
  },
  {
    "name": "airplay",
    "label": "Airplay",
    "path": "32/airplay.svg"
  },
  {
    "name": "airplay--filled",
    "label": "Airplay filled",
    "path": "32/airplay--filled.svg"
  },
  {
    "name": "airport--01",
    "label": "Airport 01",
    "path": "32/airport--01.svg"
  },
  {
    "name": "airport--02",
    "label": "Airport 02",
    "path": "32/airport--02.svg"
  },
  {
    "name": "airport-location",
    "label": "Airport location",
    "path": "32/airport-location.svg"
  },
  {
    "name": "alarm",
    "label": "Alarm",
    "path": "32/alarm.svg"
  },
  {
    "name": "alarm--add",
    "label": "Alarm add",
    "path": "32/alarm--add.svg"
  },
  {
    "name": "alarm--subtract",
    "label": "Alarm subtract",
    "path": "32/alarm--subtract.svg"
  },
  {
    "name": "align--horizontal-center",
    "label": "Align horizontal center",
    "path": "32/align--horizontal-center.svg"
  },
  {
    "name": "align--horizontal-left",
    "label": "Align horizontal left",
    "path": "32/align--horizontal-left.svg"
  },
  {
    "name": "align--horizontal-right",
    "label": "Align horizontal right",
    "path": "32/align--horizontal-right.svg"
  },
  {
    "name": "align--vertical-bottom",
    "label": "Align vertical bottom",
    "path": "32/align--vertical-bottom.svg"
  },
  {
    "name": "align--vertical-center",
    "label": "Align vertical center",
    "path": "32/align--vertical-center.svg"
  },
  {
    "name": "align--vertical-top",
    "label": "Align vertical top",
    "path": "32/align--vertical-top.svg"
  },
  {
    "name": "align-box--bottom-center",
    "label": "Align box bottom center",
    "path": "32/align-box--bottom-center.svg"
  },
  {
    "name": "align-box--bottom-left",
    "label": "Align box bottom left",
    "path": "32/align-box--bottom-left.svg"
  },
  {
    "name": "align-box--bottom-right",
    "label": "Align box bottom right",
    "path": "32/align-box--bottom-right.svg"
  },
  {
    "name": "align-box--middle-center",
    "label": "Align box middle center",
    "path": "32/align-box--middle-center.svg"
  },
  {
    "name": "align-box--middle-left",
    "label": "Align box middle left",
    "path": "32/align-box--middle-left.svg"
  },
  {
    "name": "align-box--middle-right",
    "label": "Align box middle right",
    "path": "32/align-box--middle-right.svg"
  },
  {
    "name": "align-box--top-center",
    "label": "Align box top center",
    "path": "32/align-box--top-center.svg"
  },
  {
    "name": "align-box--top-left",
    "label": "Align box top left",
    "path": "32/align-box--top-left.svg"
  },
  {
    "name": "align-box--top-right",
    "label": "Align box top right",
    "path": "32/align-box--top-right.svg"
  },
  {
    "name": "analytics",
    "label": "Analytics",
    "path": "32/analytics.svg"
  },
  {
    "name": "analytics--custom",
    "label": "Analytics custom",
    "path": "32/analytics--custom.svg"
  },
  {
    "name": "analytics--reference",
    "label": "Analytics reference",
    "path": "32/analytics--reference.svg"
  },
  {
    "name": "angle",
    "label": "Angle",
    "path": "32/watson-health/angle.svg"
  },
  {
    "name": "annotation-visibility",
    "label": "Annotation visibility",
    "path": "32/watson-health/annotation-visibility.svg"
  },
  {
    "name": "aperture",
    "label": "Aperture",
    "path": "32/aperture.svg"
  },
  {
    "name": "api",
    "label": "API",
    "path": "32/api.svg"
  },
  {
    "name": "API--1",
    "label": "API 1",
    "path": "32/API--1.svg"
  },
  {
    "name": "app",
    "label": "App",
    "path": "32/app.svg"
  },
  {
    "name": "app-connectivity",
    "label": "App connectivity",
    "path": "32/app-connectivity.svg"
  },
  {
    "name": "apple",
    "label": "Apple",
    "path": "32/apple.svg"
  },
  {
    "name": "apple--dash",
    "label": "Apple dash",
    "path": "32/apple--dash.svg"
  },
  {
    "name": "application",
    "label": "Application",
    "path": "32/application.svg"
  },
  {
    "name": "application--mobile",
    "label": "Application mobile",
    "path": "32/application--mobile.svg"
  },
  {
    "name": "application--virtual",
    "label": "Application virtual",
    "path": "32/application--virtual.svg"
  },
  {
    "name": "application--web",
    "label": "Application web",
    "path": "32/application--web.svg"
  },
  {
    "name": "apps",
    "label": "Apps",
    "path": "32/apps.svg"
  },
  {
    "name": "archive",
    "label": "Archive",
    "path": "32/archive.svg"
  },
  {
    "name": "area",
    "label": "Area",
    "path": "32/area.svg"
  },
  {
    "name": "area--custom",
    "label": "Area custom",
    "path": "32/area--custom.svg"
  },
  {
    "name": "arithmetic-mean",
    "label": "Arithmetic mean",
    "path": "32/arithmetic-mean.svg"
  },
  {
    "name": "arithmetic-median",
    "label": "Arithmetic median",
    "path": "32/arithmetic-median.svg"
  },
  {
    "name": "arrival",
    "label": "Arrival",
    "path": "32/arrival.svg"
  },
  {
    "name": "arrow--annotation",
    "label": "Arrow annotation",
    "path": "32/watson-health/arrow--annotation.svg"
  },
  {
    "name": "arrow--down",
    "label": "Arrow down",
    "path": "32/arrow--down.svg"
  },
  {
    "name": "arrow--down-left",
    "label": "Arrow down left",
    "path": "32/arrow--down-left.svg"
  },
  {
    "name": "arrow--down-right",
    "label": "Arrow down right",
    "path": "32/arrow--down-right.svg"
  },
  {
    "name": "arrow--left",
    "label": "Arrow left",
    "path": "32/arrow--left.svg"
  },
  {
    "name": "arrow--right",
    "label": "Arrow right",
    "path": "32/arrow--right.svg"
  },
  {
    "name": "arrow--up",
    "label": "Arrow up",
    "path": "32/arrow--up.svg"
  },
  {
    "name": "arrow--up-left",
    "label": "Arrow up left",
    "path": "32/arrow--up-left.svg"
  },
  {
    "name": "arrow--up-right",
    "label": "Arrow up right",
    "path": "32/arrow--up-right.svg"
  },
  {
    "name": "arrow-shift-down",
    "label": "Arrow shift down",
    "path": "32/arrow-shift-down.svg"
  },
  {
    "name": "arrows--horizontal",
    "label": "Arrows horizontal",
    "path": "32/arrows--horizontal.svg"
  },
  {
    "name": "arrows--vertical",
    "label": "Arrows vertical",
    "path": "32/arrows--vertical.svg"
  },
  {
    "name": "asleep",
    "label": "Asleep",
    "path": "32/asleep.svg"
  },
  {
    "name": "asleep--filled",
    "label": "Asleep filled",
    "path": "32/asleep--filled.svg"
  },
  {
    "name": "assembly",
    "label": "Assembly",
    "path": "32/assembly.svg"
  },
  {
    "name": "assembly--cluster",
    "label": "Assembly cluster",
    "path": "32/assembly--cluster.svg"
  },
  {
    "name": "assembly--reference",
    "label": "Assembly reference",
    "path": "32/assembly--reference.svg"
  },
  {
    "name": "asset",
    "label": "Asset",
    "path": "32/asset.svg"
  },
  {
    "name": "asset--confirm",
    "label": "Asset confirm",
    "path": "32/asset--confirm.svg"
  },
  {
    "name": "asset--digital-twin",
    "label": "Asset digital twin",
    "path": "32/asset--digital-twin.svg"
  },
  {
    "name": "asset--view",
    "label": "Asset view",
    "path": "32/asset--view.svg"
  },
  {
    "name": "asterisk",
    "label": "Asterisk",
    "path": "32/asterisk.svg"
  },
  {
    "name": "async",
    "label": "async",
    "path": "32/async.svg"
  },
  {
    "name": "at",
    "label": "At",
    "path": "32/at.svg"
  },
  {
    "name": "attachment",
    "label": "Attachment",
    "path": "32/attachment.svg"
  },
  {
    "name": "audio-console",
    "label": "Audio console",
    "path": "32/audio-console.svg"
  },
  {
    "name": "augmented-reality",
    "label": "Augmented reality",
    "path": "32/augmented-reality.svg"
  },
  {
    "name": "auto-scroll",
    "label": "Auto scroll",
    "path": "32/watson-health/auto-scroll.svg"
  },
  {
    "name": "automatic",
    "label": "Automatic",
    "path": "32/automatic.svg"
  },
  {
    "name": "autoscaling",
    "label": "IBM Cloud® autoscaling",
    "path": "32/autoscaling.svg"
  },
  {
    "name": "awake",
    "label": "Awake",
    "path": "32/awake.svg"
  },
  {
    "name": "badge",
    "label": "Badge",
    "path": "32/badge.svg"
  },
  {
    "name": "baggage-claim",
    "label": "Baggage claim",
    "path": "32/baggage-claim.svg"
  },
  {
    "name": "bar",
    "label": "Bar",
    "path": "32/bar.svg"
  },
  {
    "name": "barcode",
    "label": "Barcode",
    "path": "32/barcode.svg"
  },
  {
    "name": "bare-metal-server",
    "label": "Bare metal server",
    "path": "32/bare-metal-server.svg"
  },
  {
    "name": "bare-metal-server--01",
    "label": "Bare metal server 01",
    "path": "32/bare-metal-server--01.svg"
  },
  {
    "name": "bare-metal-server--02",
    "label": "Bare metal server 02",
    "path": "32/bare-metal-server--02.svg"
  },
  {
    "name": "barrier",
    "label": "Barrier",
    "path": "32/Q/barrier.svg"
  },
  {
    "name": "basketball",
    "label": "Basketball",
    "path": "32/basketball.svg"
  },
  {
    "name": "bastion-host",
    "label": "Bastion-Host",
    "path": "32/bastion-host.svg"
  },
  {
    "name": "bat",
    "label": "Bat",
    "path": "32/bat.svg"
  },
  {
    "name": "batch-job",
    "label": "Batch job",
    "path": "32/batch-job.svg"
  },
  {
    "name": "batch-job--step",
    "label": "Batch job step",
    "path": "32/batch-job--step.svg"
  },
  {
    "name": "battery--charging",
    "label": "Battery charging",
    "path": "32/battery--charging.svg"
  },
  {
    "name": "battery--empty",
    "label": "Battery empty",
    "path": "32/battery--empty.svg"
  },
  {
    "name": "battery--full",
    "label": "Battery full",
    "path": "32/battery--full.svg"
  },
  {
    "name": "battery--half",
    "label": "Battery half",
    "path": "32/battery--half.svg"
  },
  {
    "name": "battery--low",
    "label": "Battery low",
    "path": "32/battery--low.svg"
  },
  {
    "name": "battery--quarter",
    "label": "Battery quarter",
    "path": "32/battery--quarter.svg"
  },
  {
    "name": "bee",
    "label": "Bee",
    "path": "32/bee.svg"
  },
  {
    "name": "bee-bat",
    "label": "Bee bat",
    "path": "32/bee-bat.svg"
  },
  {
    "name": "beta",
    "label": "Beta",
    "path": "32/beta.svg"
  },
  {
    "name": "bicycle",
    "label": "Bicycle",
    "path": "32/bicycle.svg"
  },
  {
    "name": "binoculars",
    "label": "Binoculars",
    "path": "32/binoculars.svg"
  },
  {
    "name": "bloch-sphere",
    "label": "Bloch sphere",
    "path": "32/Q/bloch-sphere.svg"
  },
  {
    "name": "block-storage",
    "label": "IBM Cloud® Block Storage for VPC",
    "path": "32/block-storage.svg"
  },
  {
    "name": "block-storage--alt",
    "label": "Block storage alt",
    "path": "32/block-storage--alt.svg"
  },
  {
    "name": "blockchain",
    "label": "Blockchain",
    "path": "32/blockchain.svg"
  },
  {
    "name": "blog",
    "label": "Blog",
    "path": "32/blog.svg"
  },
  {
    "name": "bluetooth",
    "label": "Bluetooth",
    "path": "32/bluetooth.svg"
  },
  {
    "name": "bluetooth--off",
    "label": "Bluetooth off",
    "path": "32/bluetooth--off.svg"
  },
  {
    "name": "book",
    "label": "Book",
    "path": "32/book.svg"
  },
  {
    "name": "bookmark",
    "label": "Bookmark",
    "path": "32/bookmark.svg"
  },
  {
    "name": "bookmark--add",
    "label": "Bookmark add",
    "path": "32/bookmark--add.svg"
  },
  {
    "name": "bookmark--filled",
    "label": "Bookmark filled",
    "path": "32/bookmark--filled.svg"
  },
  {
    "name": "boolean",
    "label": "Boolean",
    "path": "32/boolean.svg"
  },
  {
    "name": "boot",
    "label": "Boot",
    "path": "32/boot.svg"
  },
  {
    "name": "boot-volume",
    "label": "Boot volume",
    "path": "32/boot-volume.svg"
  },
  {
    "name": "boot-volume--alt",
    "label": "Boot volume alt",
    "path": "32/boot-volume--alt.svg"
  },
  {
    "name": "border--bottom",
    "label": "Border bottom",
    "path": "32/border--bottom.svg"
  },
  {
    "name": "border--full",
    "label": "Border full",
    "path": "32/border--full.svg"
  },
  {
    "name": "border--left",
    "label": "Border left",
    "path": "32/border--left.svg"
  },
  {
    "name": "border--none",
    "label": "Border none",
    "path": "32/border--none.svg"
  },
  {
    "name": "border--right",
    "label": "Border right",
    "path": "32/border--right.svg"
  },
  {
    "name": "border--top",
    "label": "Border top",
    "path": "32/border--top.svg"
  },
  {
    "name": "bot",
    "label": "Bot",
    "path": "32/bot.svg"
  },
  {
    "name": "bottles--01",
    "label": "Bottles 01",
    "path": "32/bottles--01.svg"
  },
  {
    "name": "bottles--01--dash",
    "label": "Bottles 01 dash",
    "path": "32/bottles--01--dash.svg"
  },
  {
    "name": "bottles--02",
    "label": "Bottles 02",
    "path": "32/bottles--02.svg"
  },
  {
    "name": "bottles--02--dash",
    "label": "Bottles 02 dash",
    "path": "32/bottles--02--dash.svg"
  },
  {
    "name": "bottles--container",
    "label": "Bottles container",
    "path": "32/bottles--container.svg"
  },
  {
    "name": "box",
    "label": "Box",
    "path": "32/box.svg"
  },
  {
    "name": "box--extra-large",
    "label": "Box extra large",
    "path": "32/box--extra-large.svg"
  },
  {
    "name": "box--large",
    "label": "Box extra large",
    "path": "32/box--large.svg"
  },
  {
    "name": "box--medium",
    "label": "Box medium",
    "path": "32/box--medium.svg"
  },
  {
    "name": "box--small",
    "label": "Box small",
    "path": "32/box--small.svg"
  },
  {
    "name": "box-plot",
    "label": "Box plot",
    "path": "32/box-plot.svg"
  },
  {
    "name": "branch",
    "label": "Branch",
    "path": "32/branch.svg"
  },
  {
    "name": "breaking-change",
    "label": "Breaking change",
    "path": "32/breaking-change.svg"
  },
  {
    "name": "brightness-contrast",
    "label": "Brightness contrast",
    "path": "32/brightness-contrast.svg"
  },
  {
    "name": "bring-forward",
    "label": "Bring forward",
    "path": "32/bring-forward.svg"
  },
  {
    "name": "bring-to-front",
    "label": "Bring to front",
    "path": "32/bring-to-front.svg"
  },
  {
    "name": "brush-freehand",
    "label": "Brush freehand",
    "path": "32/watson-health/brush-freehand.svg"
  },
  {
    "name": "brush-polygon",
    "label": "Brush polygon",
    "path": "32/watson-health/brush-polygon.svg"
  },
  {
    "name": "build-tool",
    "label": "Build tool",
    "path": "32/build-tool.svg"
  },
  {
    "name": "building",
    "label": "Building",
    "path": "32/building.svg"
  },
  {
    "name": "building--insights-1",
    "label": "Building insights 1",
    "path": "32/building--insights-1.svg"
  },
  {
    "name": "building--insights-2",
    "label": "Building insights 2",
    "path": "32/building--insights-2.svg"
  },
  {
    "name": "building--insights-3",
    "label": "Building insights 3",
    "path": "32/building--insights-3.svg"
  },
  {
    "name": "bullhorn",
    "label": "Bullhorn",
    "path": "32/bullhorn.svg"
  },
  {
    "name": "buoy",
    "label": "Buoy",
    "path": "32/buoy.svg"
  },
  {
    "name": "bus",
    "label": "Bus",
    "path": "32/bus.svg"
  },
  {
    "name": "business-processes",
    "label": "Business processes",
    "path": "32/business-processes.svg"
  },
  {
    "name": "button--centered",
    "label": "Button centered",
    "path": "32/button--centered.svg"
  },
  {
    "name": "button--flush-left",
    "label": "Button flush-left",
    "path": "32/button--flush-left.svg"
  },
  {
    "name": "cabin-care",
    "label": "Cabin care",
    "path": "32/cabin-care.svg"
  },
  {
    "name": "cabin-care--alert",
    "label": "Cabin care alert",
    "path": "32/cabin-care--alert.svg"
  },
  {
    "name": "cabin-care--alt",
    "label": "Cabin care alt",
    "path": "32/cabin-care--alt.svg"
  },
  {
    "name": "CAD",
    "label": "CAD",
    "path": "32/CAD.svg"
  },
  {
    "name": "cafe",
    "label": "Cafe",
    "path": "32/cafe.svg"
  },
  {
    "name": "calculation",
    "label": "Calculation",
    "path": "32/calculation.svg"
  },
  {
    "name": "calculation--alt",
    "label": "Calculation alt",
    "path": "32/calculation--alt.svg"
  },
  {
    "name": "calculator",
    "label": "Calculator",
    "path": "32/calculator.svg"
  },
  {
    "name": "calculator--check",
    "label": "Calculator check",
    "path": "32/calculator--check.svg"
  },
  {
    "name": "calendar",
    "label": "Calendar",
    "path": "32/calendar.svg"
  },
  {
    "name": "calendar--add",
    "label": "Calendar add",
    "path": "32/calendar--add.svg"
  },
  {
    "name": "calendar--add--alt",
    "label": "Calendar add alt",
    "path": "32/calendar--add--alt.svg"
  },
  {
    "name": "calendar--heat-map",
    "label": "Calendar heat map",
    "path": "32/calendar--heat-map.svg"
  },
  {
    "name": "calendar--settings",
    "label": "Calendar settings",
    "path": "32/calendar--settings.svg"
  },
  {
    "name": "calendar--tools",
    "label": "Calendar tools",
    "path": "32/calendar--tools.svg"
  },
  {
    "name": "calibrate",
    "label": "Calibrate",
    "path": "32/calibrate.svg"
  },
  {
    "name": "calls",
    "label": "Calls",
    "path": "32/calls.svg"
  },
  {
    "name": "calls--all",
    "label": "Calls all",
    "path": "32/calls--all.svg"
  },
  {
    "name": "calls--incoming",
    "label": "Calls incoming",
    "path": "32/calls--incoming.svg"
  },
  {
    "name": "camera",
    "label": "Camera",
    "path": "32/camera.svg"
  },
  {
    "name": "camera--action",
    "label": "Camera action",
    "path": "32/camera--action.svg"
  },
  {
    "name": "campsite",
    "label": "Campsite",
    "path": "32/campsite.svg"
  },
  {
    "name": "car",
    "label": "Car",
    "path": "32/car.svg"
  },
  {
    "name": "car--front",
    "label": "Car front",
    "path": "32/car--front.svg"
  },
  {
    "name": "carbon",
    "label": "Carbon",
    "path": "32/carbon.svg"
  },
  {
    "name": "carbon--ui-builder",
    "label": "Carbon UI builder",
    "path": "32/carbon--ui-builder.svg"
  },
  {
    "name": "carbon-accounting",
    "label": "Carbon accounting",
    "path": "32/carbon-accounting.svg"
  },
  {
    "name": "carbon-for-ibm-dotcom",
    "label": "Carbon for IBM dotcom",
    "path": "32/carbon-for-ibm-dotcom.svg"
  },
  {
    "name": "carbon-for-ibm-product",
    "label": "Carbon for IBM product",
    "path": "32/carbon-for-ibm-product.svg"
  },
  {
    "name": "carbon-for-mobile",
    "label": "Carbon for mobile",
    "path": "32/carbon-for-mobile.svg"
  },
  {
    "name": "carbon-for-salesforce",
    "label": "Carbon for Salesforce",
    "path": "32/carbon-for-salesforce.svg"
  },
  {
    "name": "caret--down",
    "label": "Caret down",
    "path": "32/caret--down.svg"
  },
  {
    "name": "caret--left",
    "label": "Caret left",
    "path": "32/caret--left.svg"
  },
  {
    "name": "caret--right",
    "label": "Caret right",
    "path": "32/caret--right.svg"
  },
  {
    "name": "caret--sort",
    "label": "Caret sort",
    "path": "32/caret--sort.svg"
  },
  {
    "name": "caret--sort--down",
    "label": "Caret sort down",
    "path": "32/caret--sort--down.svg"
  },
  {
    "name": "caret--sort--up",
    "label": "Caret sort up",
    "path": "32/caret--sort--up.svg"
  },
  {
    "name": "caret--up",
    "label": "Caret up",
    "path": "32/caret--up.svg"
  },
  {
    "name": "carousel--horizontal",
    "label": "Carousel horizontal",
    "path": "32/carousel--horizontal.svg"
  },
  {
    "name": "carousel--vertical",
    "label": "Carousel vertical",
    "path": "32/carousel--vertical.svg"
  },
  {
    "name": "catalog",
    "label": "Catalog",
    "path": "32/catalog.svg"
  },
  {
    "name": "catalog--publish",
    "label": "Catalog publish",
    "path": "32/catalog--publish.svg"
  },
  {
    "name": "categories",
    "label": "Categories",
    "path": "32/categories.svg"
  },
  {
    "name": "category",
    "label": "Category",
    "path": "32/category.svg"
  },
  {
    "name": "category--add",
    "label": "Category add",
    "path": "32/category--add.svg"
  },
  {
    "name": "category--and",
    "label": "Category and",
    "path": "32/category--and.svg"
  },
  {
    "name": "category--new",
    "label": "Category new",
    "path": "32/category--new.svg"
  },
  {
    "name": "category--new-each",
    "label": "Category new each",
    "path": "32/category--new-each.svg"
  },
  {
    "name": "caution",
    "label": "Caution",
    "path": "caution.svg"
  },
  {
    "name": "caution-inverted",
    "label": "Caution inverted",
    "path": "caution-inverted.svg"
  },
  {
    "name": "ccX",
    "label": "ccX",
    "path": "32/Q/ccX.svg"
  },
  {
    "name": "cd--archive",
    "label": "CD archive",
    "path": "32/watson-health/cd--archive.svg"
  },
  {
    "name": "cd--create-archive",
    "label": "CD create archive",
    "path": "32/watson-health/cd--create-archive.svg"
  },
  {
    "name": "cd--create-exchange",
    "label": "CD create exchange",
    "path": "32/watson-health/cd--create-exchange.svg"
  },
  {
    "name": "CDA",
    "label": "CDA",
    "path": "32/CDA.svg"
  },
  {
    "name": "cell-tower",
    "label": "Cell tower",
    "path": "32/cell-tower.svg"
  },
  {
    "name": "center--circle",
    "label": "Center circle",
    "path": "32/center--circle.svg"
  },
  {
    "name": "center--square",
    "label": "Center square",
    "path": "32/center--square.svg"
  },
  {
    "name": "center-to-fit",
    "label": "Center to fit",
    "path": "32/center-to-fit.svg"
  },
  {
    "name": "certificate",
    "label": "Certificate",
    "path": "32/certificate.svg"
  },
  {
    "name": "certificate--check",
    "label": "Certificate check",
    "path": "32/certificate--check.svg"
  },
  {
    "name": "change-catalog",
    "label": "Change catalog",
    "path": "32/change-catalog.svg"
  },
  {
    "name": "character--decimal",
    "label": "Character decimal",
    "path": "32/character--decimal.svg"
  },
  {
    "name": "character--fraction",
    "label": "Character fraction",
    "path": "32/character--fraction.svg"
  },
  {
    "name": "character--integer",
    "label": "Character integer",
    "path": "32/character--integer.svg"
  },
  {
    "name": "character--lower-case",
    "label": "Character lowercase",
    "path": "32/character--lower-case.svg"
  },
  {
    "name": "character--negative-number",
    "label": "Character negative number",
    "path": "32/character--negative-number.svg"
  },
  {
    "name": "character--sentence-case",
    "label": "Character sentence case",
    "path": "32/character--sentence-case.svg"
  },
  {
    "name": "character--upper-case",
    "label": "Character uppercase",
    "path": "32/character--upper-case.svg"
  },
  {
    "name": "character--whole-number",
    "label": "Character whole number",
    "path": "32/character--whole-number.svg"
  },
  {
    "name": "character-patterns",
    "label": "Character patterns",
    "path": "32/character-patterns.svg"
  },
  {
    "name": "charging-station",
    "label": "Charging station",
    "path": "32/charging-station.svg"
  },
  {
    "name": "charging-station--filled",
    "label": "Charging station filled",
    "path": "32/charging-station--filled.svg"
  },
  {
    "name": "chart--3D",
    "label": "Chart 3D",
    "path": "32/chart--3D.svg"
  },
  {
    "name": "chart--area",
    "label": "Chart area",
    "path": "32/chart--area.svg"
  },
  {
    "name": "chart--area-smooth",
    "label": "Chart area smooth",
    "path": "32/chart--area-smooth.svg"
  },
  {
    "name": "chart--area-stepper",
    "label": "Chart area stepper",
    "path": "32/chart--area-stepper.svg"
  },
  {
    "name": "chart--average",
    "label": "Chart average",
    "path": "32/chart--average.svg"
  },
  {
    "name": "chart--bar",
    "label": "Chart bar",
    "path": "32/chart--bar.svg"
  },
  {
    "name": "chart--bar-floating",
    "label": "Chart bar floating",
    "path": "32/chart--bar-floating.svg"
  },
  {
    "name": "chart--bar-overlay",
    "label": "Chart bar overlay",
    "path": "32/chart--bar-overlay.svg"
  },
  {
    "name": "chart--bar-stacked",
    "label": "Chart bar stacked",
    "path": "32/chart--bar-stacked.svg"
  },
  {
    "name": "chart--bar-target",
    "label": "Chart bar target",
    "path": "32/chart--bar-target.svg"
  },
  {
    "name": "chart--bubble",
    "label": "Chart bubble",
    "path": "32/chart--bubble.svg"
  },
  {
    "name": "chart--bubble-packed",
    "label": "Chart Bubble-packed",
    "path": "32/chart--bubble-packed.svg"
  },
  {
    "name": "chart--bullet",
    "label": "Chart bullet",
    "path": "32/chart--bullet.svg"
  },
  {
    "name": "chart--candlestick",
    "label": "Chart candlestick",
    "path": "32/chart--candlestick.svg"
  },
  {
    "name": "chart--cluster-bar",
    "label": "Chart cluster bar",
    "path": "32/chart--cluster-bar.svg"
  },
  {
    "name": "chart--column",
    "label": "Chart column",
    "path": "32/chart--column.svg"
  },
  {
    "name": "chart--column-floating",
    "label": "Chart column floating",
    "path": "32/chart--column-floating.svg"
  },
  {
    "name": "chart--column-target",
    "label": "Chart column target",
    "path": "32/chart--column-target.svg"
  },
  {
    "name": "chart--combo",
    "label": "Chart combo",
    "path": "32/chart--combo.svg"
  },
  {
    "name": "chart--combo-stacked",
    "label": "Chart combo stacked",
    "path": "32/chart--combo-stacked.svg"
  },
  {
    "name": "chart--custom",
    "label": "Chart custom",
    "path": "32/chart--custom.svg"
  },
  {
    "name": "chart--dual-y-axis",
    "label": "Chart dual y axis",
    "path": "32/chart--dual-y-axis.svg"
  },
  {
    "name": "chart--error-bar",
    "label": "Chart error bar",
    "path": "32/chart--error-bar.svg"
  },
  {
    "name": "chart--error-bar--alt",
    "label": "Chart error bar alt",
    "path": "32/chart--error-bar--alt.svg"
  },
  {
    "name": "chart--evaluation",
    "label": "Chart evaluation",
    "path": "32/chart--evaluation.svg"
  },
  {
    "name": "chart--high-low",
    "label": "Chart high low",
    "path": "32/chart--high-low.svg"
  },
  {
    "name": "chart--histogram",
    "label": "Chart histogram",
    "path": "32/chart--histogram.svg"
  },
  {
    "name": "chart--line",
    "label": "Chart line",
    "path": "32/chart--line.svg"
  },
  {
    "name": "chart--line--data",
    "label": "Chart line data",
    "path": "32/chart--line--data.svg"
  },
  {
    "name": "chart--line-smooth",
    "label": "Chart line smooth",
    "path": "32/chart--line-smooth.svg"
  },
  {
    "name": "chart--logistic-regression",
    "label": "Chart logistic regression",
    "path": "32/chart--logistic-regression.svg"
  },
  {
    "name": "chart--marimekko",
    "label": "Chart Marimekko",
    "path": "32/chart--marimekko.svg"
  },
  {
    "name": "chart--maximum",
    "label": "Chart maximum",
    "path": "32/chart--maximum.svg"
  },
  {
    "name": "chart--median",
    "label": "Chart median",
    "path": "32/chart--median.svg"
  },
  {
    "name": "chart--minimum",
    "label": "Chart minimum",
    "path": "32/chart--minimum.svg"
  },
  {
    "name": "chart--multi-line",
    "label": "Chart multi-line",
    "path": "32/chart--multi-line.svg"
  },
  {
    "name": "chart--multitype",
    "label": "Chart multitype",
    "path": "32/chart--multitype.svg"
  },
  {
    "name": "chart--network",
    "label": "Chart network",
    "path": "32/chart--network.svg"
  },
  {
    "name": "chart--parallel",
    "label": "Chart parallel",
    "path": "32/chart--parallel.svg"
  },
  {
    "name": "chart--pie",
    "label": "Chart pie",
    "path": "32/chart--pie.svg"
  },
  {
    "name": "chart--planning-waterfall",
    "label": "Chart planning waterfall",
    "path": "32/chart--planning-waterfall.svg"
  },
  {
    "name": "chart--point",
    "label": "Chart point",
    "path": "32/chart--point.svg"
  },
  {
    "name": "chart--population",
    "label": "Chart population",
    "path": "32/chart--population.svg"
  },
  {
    "name": "chart--radar",
    "label": "Chart radar",
    "path": "32/chart--radar.svg"
  },
  {
    "name": "chart--radial",
    "label": "Chart radial",
    "path": "32/chart--radial.svg"
  },
  {
    "name": "chart--relationship",
    "label": "Chart relationship",
    "path": "32/chart--relationship.svg"
  },
  {
    "name": "chart--ring",
    "label": "Chart ring",
    "path": "32/chart--ring.svg"
  },
  {
    "name": "chart--river",
    "label": "Chart river",
    "path": "32/chart--river.svg"
  },
  {
    "name": "chart--rose",
    "label": "Chart rose",
    "path": "32/chart--rose.svg"
  },
  {
    "name": "chart--scatter",
    "label": "Chart scatter",
    "path": "32/chart--scatter.svg"
  },
  {
    "name": "chart--spiral",
    "label": "Chart spiral",
    "path": "32/chart--spiral.svg"
  },
  {
    "name": "chart--stacked",
    "label": "Chart stacked",
    "path": "32/chart--stacked.svg"
  },
  {
    "name": "chart--stepper",
    "label": "Chart stepper",
    "path": "32/chart--stepper.svg"
  },
  {
    "name": "chart--sunburst",
    "label": "Chart sunburst",
    "path": "32/chart--sunburst.svg"
  },
  {
    "name": "chart--t-sne",
    "label": "Chart t-sne",
    "path": "32/chart--t-sne.svg"
  },
  {
    "name": "chart--treemap",
    "label": "Chart treemap",
    "path": "32/chart--treemap.svg"
  },
  {
    "name": "chart--venn-diagram",
    "label": "Chart Venn diagram",
    "path": "32/chart--venn-diagram.svg"
  },
  {
    "name": "chart--violin-plot",
    "label": "Chart violin-plot",
    "path": "32/chart--violin-plot.svg"
  },
  {
    "name": "chart--waterfall",
    "label": "Chart waterfall",
    "path": "32/chart--waterfall.svg"
  },
  {
    "name": "chart--win-loss",
    "label": "Chart win-loss",
    "path": "32/chart--win-loss.svg"
  },
  {
    "name": "chat",
    "label": "Chat",
    "path": "32/chat.svg"
  },
  {
    "name": "chat--launch",
    "label": "Chat launch",
    "path": "32/chat--launch.svg"
  },
  {
    "name": "chat--off",
    "label": "Chat off",
    "path": "32/chat--off.svg"
  },
  {
    "name": "chat--operational",
    "label": "Chat operational",
    "path": "32/chat--operational.svg"
  },
  {
    "name": "chat-bot",
    "label": "Chat bot",
    "path": "32/chat-bot.svg"
  },
  {
    "name": "checkbox",
    "label": "Checkbox",
    "path": "32/checkbox.svg"
  },
  {
    "name": "checkbox--checked",
    "label": "Checkbox checked",
    "path": "32/checkbox--checked.svg"
  },
  {
    "name": "checkbox--checked--filled",
    "label": "Checkbox checked filled",
    "path": "32/checkbox--checked--filled.svg"
  },
  {
    "name": "checkbox--indeterminate",
    "label": "Checkbox indeterminate",
    "path": "32/checkbox--indeterminate.svg"
  },
  {
    "name": "checkbox--indeterminate--filled",
    "label": "Checkbox indeterminate filled",
    "path": "32/checkbox--indeterminate--filled.svg"
  },
  {
    "name": "checkmark",
    "label": "Checkmark",
    "path": "32/checkmark.svg"
  },
  {
    "name": "checkmark--filled",
    "label": "Checkmark filled",
    "path": "32/checkmark--filled.svg"
  },
  {
    "name": "checkmark--filled--error",
    "label": "Checkmark filled error",
    "path": "32/checkmark--filled--error.svg"
  },
  {
    "name": "checkmark--filled--warning",
    "label": "Checkmark filled warning",
    "path": "32/checkmark--filled--warning.svg"
  },
  {
    "name": "checkmark--outline",
    "label": "Checkmark outline",
    "path": "32/checkmark--outline.svg"
  },
  {
    "name": "checkmark--outline--error",
    "label": "Checkmark outline error",
    "path": "32/checkmark--outline--error.svg"
  },
  {
    "name": "checkmark--outline--warning",
    "label": "Checkmark outline warning",
    "path": "32/checkmark--outline--warning.svg"
  },
  {
    "name": "chemistry",
    "label": "Chemistry",
    "path": "32/chemistry.svg"
  },
  {
    "name": "chemistry--reference",
    "label": "Chemistry reference",
    "path": "32/chemistry--reference.svg"
  },
  {
    "name": "chevron--down",
    "label": "Chevron down",
    "path": "32/chevron--down.svg"
  },
  {
    "name": "chevron--down--outline",
    "label": "Chevron down outline",
    "path": "32/chevron--down--outline.svg"
  },
  {
    "name": "chevron--left",
    "label": "Chevron left",
    "path": "32/chevron--left.svg"
  },
  {
    "name": "chevron--mini",
    "label": "Chevron mini",
    "path": "32/chevron--mini.svg"
  },
  {
    "name": "chevron--right",
    "label": "Chevron right",
    "path": "32/chevron--right.svg"
  },
  {
    "name": "chevron--sort",
    "label": "Chevron sort",
    "path": "32/chevron--sort.svg"
  },
  {
    "name": "chevron--sort--down",
    "label": "Chevron sort down",
    "path": "32/chevron--sort--down.svg"
  },
  {
    "name": "chevron--sort--up",
    "label": "Chevron sort up",
    "path": "32/chevron--sort--up.svg"
  },
  {
    "name": "chevron--up",
    "label": "Chevron up",
    "path": "32/chevron--up.svg"
  },
  {
    "name": "chevron--up--outline",
    "label": "Chevron up outline",
    "path": "32/chevron--up--outline.svg"
  },
  {
    "name": "chip",
    "label": "Chip",
    "path": "32/chip.svg"
  },
  {
    "name": "choices",
    "label": "Choices",
    "path": "32/choices.svg"
  },
  {
    "name": "choose-item",
    "label": "Choose item",
    "path": "32/choose-item.svg"
  },
  {
    "name": "choropleth-map",
    "label": "Chart choropleth-map",
    "path": "32/choropleth-map.svg"
  },
  {
    "name": "cics--cmas",
    "label": "IBM® CICS® CMAS",
    "path": "32/cics--cmas.svg"
  },
  {
    "name": "cics--db2-connection",
    "label": "IBM® CICS® Db2® connection",
    "path": "32/cics--db2-connection.svg"
  },
  {
    "name": "cics--explorer",
    "label": "IBM® CICS Explorer®",
    "path": "32/cics--explorer.svg"
  },
  {
    "name": "cics--program",
    "label": "IBM® CICS® program",
    "path": "32/cics--program.svg"
  },
  {
    "name": "cics--sit",
    "label": "IBM® CICS® SIT",
    "path": "32/cics--sit.svg"
  },
  {
    "name": "cics--sit-overrides",
    "label": "IBM® CICS® SIT overrides",
    "path": "32/cics--sit-overrides.svg"
  },
  {
    "name": "cics--system-group",
    "label": "IBM® CICS® system group",
    "path": "32/cics--system-group.svg"
  },
  {
    "name": "cics--transaction-server-zos",
    "label": "IBM® CICS® Transaction Server for z/OS®",
    "path": "32/cics--transaction-server-zos.svg"
  },
  {
    "name": "cics--wui-region",
    "label": "IBM® CICS® WUI region",
    "path": "32/cics--wui-region.svg"
  },
  {
    "name": "cics-region",
    "label": "IBM® CICS® region",
    "path": "32/cics-region.svg"
  },
  {
    "name": "cics-region--alt",
    "label": "IBM® CICS® region alt",
    "path": "32/cics-region--alt.svg"
  },
  {
    "name": "cics-region--routing",
    "label": "IBM® CICS® region routing",
    "path": "32/cics-region--routing.svg"
  },
  {
    "name": "cics-region--target",
    "label": "IBM® CICS® region target",
    "path": "32/cics-region--target.svg"
  },
  {
    "name": "cicsplex",
    "label": "IBM® CICSPlex®",
    "path": "32/cicsplex.svg"
  },
  {
    "name": "circle--filled",
    "label": "Circle filled",
    "path": "32/circle--filled.svg"
  },
  {
    "name": "circle--outline",
    "label": "Circle outline",
    "path": "32/circle--outline.svg"
  },
  {
    "name": "circle--solid",
    "label": "Circle solid",
    "path": "32/circle--solid.svg"
  },
  {
    "name": "circle-dash",
    "label": "Circle dash",
    "path": "32/circle-dash.svg"
  },
  {
    "name": "circle-fill",
    "label": "Circle fill",
    "path": "circle-fill.svg"
  },
  {
    "name": "circle-measurement",
    "label": "Circle measurement",
    "path": "32/watson-health/circle-measurement.svg"
  },
  {
    "name": "circle-packing",
    "label": "Circle packing",
    "path": "32/circle-packing.svg"
  },
  {
    "name": "circle-stroke",
    "label": "Circle stroke",
    "path": "circle-stroke.svg"
  },
  {
    "name": "circuit-composer",
    "label": "Circuit composer",
    "path": "32/Q/circuit-composer.svg"
  },
  {
    "name": "classification",
    "label": "Classification",
    "path": "32/classification.svg"
  },
  {
    "name": "classifier--language",
    "label": "Classifier language",
    "path": "32/classifier--language.svg"
  },
  {
    "name": "clean",
    "label": "Clean",
    "path": "32/clean.svg"
  },
  {
    "name": "close",
    "label": "Close",
    "path": "32/close.svg"
  },
  {
    "name": "close--filled",
    "label": "Close filled",
    "path": "32/close--filled.svg"
  },
  {
    "name": "close--large",
    "label": "Close large",
    "path": "32/close--large.svg"
  },
  {
    "name": "close--outline",
    "label": "Close outline",
    "path": "32/close--outline.svg"
  },
  {
    "name": "closed-caption",
    "label": "Closed caption",
    "path": "32/closed-caption.svg"
  },
  {
    "name": "closed-caption--alt",
    "label": "Closed caption alt",
    "path": "32/closed-caption--alt.svg"
  },
  {
    "name": "closed-caption--filled",
    "label": "Closed caption filled",
    "path": "32/closed-caption--filled.svg"
  },
  {
    "name": "cloud",
    "label": "Cloud",
    "path": "32/cloud.svg"
  },
  {
    "name": "cloud--alerting",
    "label": "Cloud alerting",
    "path": "32/cloud--alerting.svg"
  },
  {
    "name": "cloud--auditing",
    "label": "IBM Cloud® Activity Tracker",
    "path": "32/cloud--auditing.svg"
  },
  {
    "name": "cloud--data-ops",
    "label": "Cloud data-ops",
    "path": "32/cloud--data-ops.svg"
  },
  {
    "name": "cloud--download",
    "label": "Cloud download",
    "path": "32/cloud--download.svg"
  },
  {
    "name": "cloud--logging",
    "label": "IBM Cloud® Log Analysis",
    "path": "32/cloud--logging.svg"
  },
  {
    "name": "cloud--monitoring",
    "label": "IBM Cloud® Monitoring",
    "path": "32/cloud--monitoring.svg"
  },
  {
    "name": "cloud--offline",
    "label": "Cloud offline",
    "path": "32/cloud--offline.svg"
  },
  {
    "name": "cloud--service-management",
    "label": "Cloud service management",
    "path": "32/cloud--service-management.svg"
  },
  {
    "name": "cloud--upload",
    "label": "Cloud upload",
    "path": "32/cloud--upload.svg"
  },
  {
    "name": "cloud-app",
    "label": "Cloud app",
    "path": "32/cloud-app.svg"
  },
  {
    "name": "cloud-ceiling",
    "label": "Cloud ceiling",
    "path": "32/cloud-ceiling.svg"
  },
  {
    "name": "cloud-foundry--1",
    "label": "IBM Cloud® Foundry",
    "path": "32/cloud-foundry--1.svg"
  },
  {
    "name": "cloud-foundry--2",
    "label": "IBM Cloud® Foundry 2",
    "path": "32/cloud-foundry--2.svg"
  },
  {
    "name": "cloud-registry",
    "label": "IBM Cloud® Container Registry",
    "path": "32/cloud-registry.svg"
  },
  {
    "name": "cloud-satellite",
    "label": "IBM Cloud Satellite®",
    "path": "32/cloud-satellite.svg"
  },
  {
    "name": "cloud-satellite--config",
    "label": "IBM Cloud Satellite® config",
    "path": "32/cloud-satellite--config.svg"
  },
  {
    "name": "cloud-satellite--link",
    "label": "IBM Cloud Satellite® link",
    "path": "32/cloud-satellite--link.svg"
  },
  {
    "name": "cloud-satellite--services",
    "label": "IBM Cloud Satellite® services",
    "path": "32/cloud-satellite--services.svg"
  },
  {
    "name": "cloud-services",
    "label": "Cloud services",
    "path": "32/cloud-services.svg"
  },
  {
    "name": "cloudy",
    "label": "Cloudy",
    "path": "32/cloudy.svg"
  },
  {
    "name": "cobb-angle",
    "label": "Cobb angle",
    "path": "32/watson-health/cobb-angle.svg"
  },
  {
    "name": "code",
    "label": "Code",
    "path": "32/code.svg"
  },
  {
    "name": "code--hide",
    "label": "Code hide",
    "path": "32/code--hide.svg"
  },
  {
    "name": "code--reference",
    "label": "Code reference",
    "path": "32/code--reference.svg"
  },
  {
    "name": "code-signing-service",
    "label": "Code signing service",
    "path": "32/code-signing-service.svg"
  },
  {
    "name": "cognitive",
    "label": "Cognitive",
    "path": "32/cognitive.svg"
  },
  {
    "name": "collaborate",
    "label": "Collaborate",
    "path": "32/collaborate.svg"
  },
  {
    "name": "collapse-all",
    "label": "Collapse all",
    "path": "32/collapse-all.svg"
  },
  {
    "name": "collapse-categories",
    "label": "Collapse categories",
    "path": "32/collapse-categories.svg"
  },
  {
    "name": "color-palette",
    "label": "Color palette",
    "path": "32/color-palette.svg"
  },
  {
    "name": "color-switch",
    "label": "Color switch",
    "path": "32/color-switch.svg"
  },
  {
    "name": "column",
    "label": "Column",
    "path": "32/column.svg"
  },
  {
    "name": "column--delete",
    "label": "Column delete",
    "path": "32/column--delete.svg"
  },
  {
    "name": "column--insert",
    "label": "Column insert",
    "path": "32/column--insert.svg"
  },
  {
    "name": "column-dependency",
    "label": "Column dependency",
    "path": "32/column-dependency.svg"
  },
  {
    "name": "commit",
    "label": "Commit",
    "path": "32/commit.svg"
  },
  {
    "name": "communication--unified",
    "label": "Communication unified",
    "path": "32/communication--unified.svg"
  },
  {
    "name": "compare",
    "label": "Compare",
    "path": "32/compare.svg"
  },
  {
    "name": "compass",
    "label": "Compass",
    "path": "32/compass.svg"
  },
  {
    "name": "composer-edit",
    "label": "Composer edit",
    "path": "32/Q/composer-edit.svg"
  },
  {
    "name": "concept",
    "label": "Concept",
    "path": "32/concept.svg"
  },
  {
    "name": "condition--point",
    "label": "Condition point",
    "path": "32/condition--point.svg"
  },
  {
    "name": "condition--wait-point",
    "label": "Condition wait point",
    "path": "32/condition--wait-point.svg"
  },
  {
    "name": "connect",
    "label": "Connect",
    "path": "32/connect.svg"
  },
  {
    "name": "connect--recursive",
    "label": "Connect recursive",
    "path": "32/connect--recursive.svg"
  },
  {
    "name": "connect--reference",
    "label": "Connect reference",
    "path": "32/connect--reference.svg"
  },
  {
    "name": "connect--source",
    "label": "Connect source",
    "path": "32/connect--source.svg"
  },
  {
    "name": "connect--target",
    "label": "Connect target",
    "path": "32/connect--target.svg"
  },
  {
    "name": "connection--receive",
    "label": "Connection receive",
    "path": "32/connection--receive.svg"
  },
  {
    "name": "connection--send",
    "label": "Connection send",
    "path": "32/connection--send.svg"
  },
  {
    "name": "connection--two-way",
    "label": "Connection two-way",
    "path": "32/connection--two-way.svg"
  },
  {
    "name": "connection-signal",
    "label": "Connection signal",
    "path": "32/connection-signal.svg"
  },
  {
    "name": "connection-signal--off",
    "label": "Connection signal off",
    "path": "32/connection-signal--off.svg"
  },
  {
    "name": "construction",
    "label": "Construction",
    "path": "32/construction.svg"
  },
  {
    "name": "container-registry",
    "label": "Container registry",
    "path": "32/container-registry.svg"
  },
  {
    "name": "container-services",
    "label": "Container services",
    "path": "32/container-services.svg"
  },
  {
    "name": "container-software",
    "label": "Container software",
    "path": "32/container-software.svg"
  },
  {
    "name": "content-delivery-network",
    "label": "IBM Cloud® Content Delivery Network",
    "path": "32/content-delivery-network.svg"
  },
  {
    "name": "content-view",
    "label": "Content view",
    "path": "32/content-view.svg"
  },
  {
    "name": "continue",
    "label": "Continue",
    "path": "32/continue.svg"
  },
  {
    "name": "continue--filled",
    "label": "Continue filled",
    "path": "32/continue--filled.svg"
  },
  {
    "name": "continuous-deployment",
    "label": "Continuous deployment",
    "path": "32/continuous-deployment.svg"
  },
  {
    "name": "continuous-integration",
    "label": "Continuous integration",
    "path": "32/continuous-integration.svg"
  },
  {
    "name": "contour--draw",
    "label": "Contour draw",
    "path": "32/watson-health/contour--draw.svg"
  },
  {
    "name": "contour--edit",
    "label": "Contour edit",
    "path": "32/watson-health/contour--edit.svg"
  },
  {
    "name": "contour-finding",
    "label": "Contour finding",
    "path": "32/watson-health/contour-finding.svg"
  },
  {
    "name": "contrast",
    "label": "Contrast",
    "path": "32/contrast.svg"
  },
  {
    "name": "convert-to-cloud",
    "label": "Convert to cloud",
    "path": "32/convert-to-cloud.svg"
  },
  {
    "name": "cookie",
    "label": "Cookie",
    "path": "32/cookie.svg"
  },
  {
    "name": "copy",
    "label": "Copy",
    "path": "32/copy.svg"
  },
  {
    "name": "copy--file",
    "label": "Copy file",
    "path": "32/copy--file.svg"
  },
  {
    "name": "copy--link",
    "label": "Copy link",
    "path": "32/copy--link.svg"
  },
  {
    "name": "corn",
    "label": "Corn",
    "path": "32/corn.svg"
  },
  {
    "name": "corner",
    "label": "Corner",
    "path": "32/corner.svg"
  },
  {
    "name": "coronavirus",
    "label": "Coronavirus",
    "path": "32/coronavirus.svg"
  },
  {
    "name": "cost",
    "label": "Cost",
    "path": "32/cost.svg"
  },
  {
    "name": "cost--total",
    "label": "Cost total",
    "path": "32/cost--total.svg"
  },
  {
    "name": "cough",
    "label": "Cough",
    "path": "32/cough.svg"
  },
  {
    "name": "course",
    "label": "Course",
    "path": "32/course.svg"
  },
  {
    "name": "covariate",
    "label": "Covariate",
    "path": "32/covariate.svg"
  },
  {
    "name": "credentials",
    "label": "Credentials",
    "path": "32/credentials.svg"
  },
  {
    "name": "critical",
    "label": "Critical",
    "path": "critical.svg"
  },
  {
    "name": "critical-severity",
    "label": "Critical severity",
    "path": "critical-severity.svg"
  },
  {
    "name": "crop",
    "label": "Crop",
    "path": "32/crop.svg"
  },
  {
    "name": "crop-growth",
    "label": "Crop growth",
    "path": "32/crop-growth.svg"
  },
  {
    "name": "crop-health",
    "label": "Crop health",
    "path": "32/crop-health.svg"
  },
  {
    "name": "cross-reference",
    "label": "Cross reference",
    "path": "32/watson-health/cross-reference.svg"
  },
  {
    "name": "cross-tab",
    "label": "Cross tab",
    "path": "32/cross-tab.svg"
  },
  {
    "name": "crossroads",
    "label": "Crossroads",
    "path": "32/crossroads.svg"
  },
  {
    "name": "crowd-report",
    "label": "Crowd report",
    "path": "32/crowd-report.svg"
  },
  {
    "name": "crowd-report--filled",
    "label": "Crowd report filled",
    "path": "32/crowd-report--filled.svg"
  },
  {
    "name": "CSV",
    "label": "CSV",
    "path": "32/CSV.svg"
  },
  {
    "name": "cU1",
    "label": "cU1",
    "path": "32/Q/cU1.svg"
  },
  {
    "name": "cU3",
    "label": "cU3",
    "path": "32/Q/cU3.svg"
  },
  {
    "name": "cube",
    "label": "Cube",
    "path": "32/cube.svg"
  },
  {
    "name": "cube-view",
    "label": "Cube view",
    "path": "32/cube-view.svg"
  },
  {
    "name": "currency",
    "label": "Currency",
    "path": "32/currency.svg"
  },
  {
    "name": "currency--baht",
    "label": "Currency baht",
    "path": "32/currency--baht.svg"
  },
  {
    "name": "currency--dollar",
    "label": "Currency dollar",
    "path": "32/currency--dollar.svg"
  },
  {
    "name": "currency--euro",
    "label": "Currency euro",
    "path": "32/currency--euro.svg"
  },
  {
    "name": "currency--lira",
    "label": "Currency lira",
    "path": "32/currency--lira.svg"
  },
  {
    "name": "currency--pound",
    "label": "Currency pound",
    "path": "32/currency--pound.svg"
  },
  {
    "name": "currency--ruble",
    "label": "Currency ruble",
    "path": "32/currency--ruble.svg"
  },
  {
    "name": "currency--rupee",
    "label": "Currency rupee",
    "path": "32/currency--rupee.svg"
  },
  {
    "name": "currency--shekel",
    "label": "Currency shekel",
    "path": "32/currency--shekel.svg"
  },
  {
    "name": "currency--won",
    "label": "Currency won",
    "path": "32/currency--won.svg"
  },
  {
    "name": "currency--yen",
    "label": "Currency yen",
    "path": "32/currency--yen.svg"
  },
  {
    "name": "cursor--1",
    "label": "Cursor 1",
    "path": "32/cursor--1.svg"
  },
  {
    "name": "cursor--2",
    "label": "Cursor 2",
    "path": "32/cursor--2.svg"
  },
  {
    "name": "customer",
    "label": "Customer",
    "path": "32/customer.svg"
  },
  {
    "name": "customer-service",
    "label": "Customer service",
    "path": "32/customer-service.svg"
  },
  {
    "name": "cut",
    "label": "Cut",
    "path": "32/cut.svg"
  },
  {
    "name": "cut-in-half",
    "label": "Cut in half",
    "path": "32/watson-health/cut-in-half.svg"
  },
  {
    "name": "cut-out",
    "label": "Cut out",
    "path": "32/cut-out.svg"
  },
  {
    "name": "cY",
    "label": "cY",
    "path": "32/Q/cY.svg"
  },
  {
    "name": "cyclist",
    "label": "Cyclist",
    "path": "32/cyclist.svg"
  },
  {
    "name": "cZ",
    "label": "cZ",
    "path": "32/Q/cZ.svg"
  },
  {
    "name": "dashboard",
    "label": "Dashboard",
    "path": "32/dashboard.svg"
  },
  {
    "name": "dashboard--reference",
    "label": "Dashboard reference",
    "path": "32/dashboard--reference.svg"
  },
  {
    "name": "data--1",
    "label": "Data 1",
    "path": "32/data--1.svg"
  },
  {
    "name": "data--2",
    "label": "Data 2",
    "path": "32/data--2.svg"
  },
  {
    "name": "data--base",
    "label": "Data base",
    "path": "32/data--base.svg"
  },
  {
    "name": "data--base--alt",
    "label": "Data base alt",
    "path": "32/data--base--alt.svg"
  },
  {
    "name": "data--categorical",
    "label": "Data categorical",
    "path": "32/data--categorical.svg"
  },
  {
    "name": "data--center",
    "label": "Data center",
    "path": "32/data--center.svg"
  },
  {
    "name": "data--check",
    "label": "Data check",
    "path": "32/data--check.svg"
  },
  {
    "name": "data--connected",
    "label": "Data connected",
    "path": "32/data--connected.svg"
  },
  {
    "name": "data--error",
    "label": "Data error",
    "path": "32/data--error.svg"
  },
  {
    "name": "data--format",
    "label": "Data format",
    "path": "32/data--format.svg"
  },
  {
    "name": "data--reference",
    "label": "Data reference",
    "path": "32/data--reference.svg"
  },
  {
    "name": "data--regular",
    "label": "Data regular",
    "path": "32/data--regular.svg"
  },
  {
    "name": "data--set",
    "label": "Data set",
    "path": "32/data--set.svg"
  },
  {
    "name": "data--structured",
    "label": "Data structured",
    "path": "32/data--structured.svg"
  },
  {
    "name": "data--unreal",
    "label": "Data unreal",
    "path": "32/data--unreal.svg"
  },
  {
    "name": "data--unstructured",
    "label": "Data unstructured",
    "path": "32/data--unstructured.svg"
  },
  {
    "name": "data--view",
    "label": "Data view",
    "path": "32/data--view.svg"
  },
  {
    "name": "data--view--alt",
    "label": "Data view alt",
    "path": "32/data--view--alt.svg"
  },
  {
    "name": "data-accessor",
    "label": "Data accessor",
    "path": "32/data-accessor.svg"
  },
  {
    "name": "data-analytics",
    "label": "Data analytics",
    "path": "32/data-analytics.svg"
  },
  {
    "name": "data-backup",
    "label": "Data backup",
    "path": "32/data-backup.svg"
  },
  {
    "name": "data-bin",
    "label": "Data bin",
    "path": "32/data-bin.svg"
  },
  {
    "name": "data-blob",
    "label": "Data blob",
    "path": "32/data-blob.svg"
  },
  {
    "name": "data-class",
    "label": "Data class",
    "path": "32/data-class.svg"
  },
  {
    "name": "data-collection",
    "label": "Data collection",
    "path": "32/data-collection.svg"
  },
  {
    "name": "data-definition",
    "label": "Data definition",
    "path": "32/data-definition.svg"
  },
  {
    "name": "data-diode",
    "label": "Data diode",
    "path": "32/data-diode.svg"
  },
  {
    "name": "data-enrichment",
    "label": "Data enrichment",
    "path": "32/data-enrichment.svg"
  },
  {
    "name": "data-enrichment--add",
    "label": "Data enrichment add",
    "path": "32/data-enrichment--add.svg"
  },
  {
    "name": "data-player",
    "label": "Data player",
    "path": "32/data-player.svg"
  },
  {
    "name": "data-quality-definition",
    "label": "Data quality definition",
    "path": "32/data-quality-definition.svg"
  },
  {
    "name": "data-refinery",
    "label": "Data refinery",
    "path": "32/data-refinery.svg"
  },
  {
    "name": "data-refinery--reference",
    "label": "Data refinery reference",
    "path": "32/data-refinery--reference.svg"
  },
  {
    "name": "data-share",
    "label": "Data share",
    "path": "32/data-share.svg"
  },
  {
    "name": "data-table",
    "label": "Data table",
    "path": "32/data-table.svg"
  },
  {
    "name": "data-table--reference",
    "label": "Data table reference",
    "path": "32/data-table--reference.svg"
  },
  {
    "name": "data-vis--1",
    "label": "Data visualization 1",
    "path": "32/data-vis--1.svg"
  },
  {
    "name": "data-vis--2",
    "label": "Data visualization 2",
    "path": "32/data-vis--2.svg"
  },
  {
    "name": "data-vis--3",
    "label": "Data visualization 3",
    "path": "32/data-vis--3.svg"
  },
  {
    "name": "data-vis--4",
    "label": "Data visualization 4",
    "path": "32/data-vis--4.svg"
  },
  {
    "name": "data-volume",
    "label": "Data volume",
    "path": "32/data-volume.svg"
  },
  {
    "name": "data-volume--alt",
    "label": "Data volume alt",
    "path": "32/data-volume--alt.svg"
  },
  {
    "name": "database--datastax",
    "label": "IBM Cloud® Databases for DataStax",
    "path": "32/database--datastax.svg"
  },
  {
    "name": "database--elastic",
    "label": "IBM Cloud® Databases for Elasticsearch",
    "path": "32/database--elastic.svg"
  },
  {
    "name": "database--enterprise-db2",
    "label": "IBM Cloud® Databases for EnterpriseDB",
    "path": "32/database--enterprise-db2.svg"
  },
  {
    "name": "database--enterprisedb",
    "label": "Database Enterprisedb",
    "path": "32/database--enterprisedb.svg"
  },
  {
    "name": "database--etcd",
    "label": "IBM Cloud® Databases for etcd",
    "path": "32/database--etcd.svg"
  },
  {
    "name": "database--messaging",
    "label": "Database messaging",
    "path": "32/database--messaging.svg"
  },
  {
    "name": "database--mongodb",
    "label": "IBM Cloud® Databases for MongoDB",
    "path": "32/database--mongodb.svg"
  },
  {
    "name": "database--postgreSQL",
    "label": "IBM Cloud® Databases for PostgreSQL",
    "path": "32/database--postgreSQL.svg"
  },
  {
    "name": "database--rabbit",
    "label": "IBM Cloud® Databases for Rabbit",
    "path": "32/database--rabbit.svg"
  },
  {
    "name": "database--redis",
    "label": "IBM Cloud® Databases for Redis",
    "path": "32/database--redis.svg"
  },
  {
    "name": "datastore",
    "label": "Data store",
    "path": "32/datastore.svg"
  },
  {
    "name": "db2--buffer-pool",
    "label": "IBM® Db2® buffer pool",
    "path": "32/db2--buffer-pool.svg"
  },
  {
    "name": "db2--data-sharing-group",
    "label": "IBM® Db2® data sharing group",
    "path": "32/db2--data-sharing-group.svg"
  },
  {
    "name": "db2--database",
    "label": "IBM® Db2® Database",
    "path": "32/db2--database.svg"
  },
  {
    "name": "debug",
    "label": "Debug",
    "path": "32/debug.svg"
  },
  {
    "name": "decision-tree",
    "label": "Decision tree",
    "path": "32/decision-tree.svg"
  },
  {
    "name": "delete",
    "label": "Delete",
    "path": "32/delete.svg"
  },
  {
    "name": "delivery",
    "label": "Delivery",
    "path": "32/delivery.svg"
  },
  {
    "name": "delivery--add",
    "label": "Delivery add",
    "path": "32/delivery--add.svg"
  },
  {
    "name": "delivery--parcel",
    "label": "Delivery parcel",
    "path": "32/delivery--parcel.svg"
  },
  {
    "name": "delivery-truck",
    "label": "Delivery truck",
    "path": "32/delivery-truck.svg"
  },
  {
    "name": "demo",
    "label": "Demo",
    "path": "32/demo.svg"
  },
  {
    "name": "denominate",
    "label": "Denominate",
    "path": "32/watson-health/denominate.svg"
  },
  {
    "name": "departure",
    "label": "Departure",
    "path": "32/departure.svg"
  },
  {
    "name": "deploy",
    "label": "Deploy",
    "path": "32/deploy.svg"
  },
  {
    "name": "deploy-rules",
    "label": "Deploy rules",
    "path": "32/deploy-rules.svg"
  },
  {
    "name": "deployment-pattern",
    "label": "Deployment pattern",
    "path": "32/deployment-pattern.svg"
  },
  {
    "name": "deployment-policy",
    "label": "Deployment policy",
    "path": "32/deployment-policy.svg"
  },
  {
    "name": "deployment-unit--data",
    "label": "Deployment unit data",
    "path": "32/deployment-unit--data.svg"
  },
  {
    "name": "deployment-unit--execution",
    "label": "Deployment unit execution",
    "path": "32/deployment-unit--execution.svg"
  },
  {
    "name": "deployment-unit--installation",
    "label": "Deployment unit installation",
    "path": "32/deployment-unit--installation.svg"
  },
  {
    "name": "deployment-unit--presentation",
    "label": "Deployment unit presentation",
    "path": "32/deployment-unit--presentation.svg"
  },
  {
    "name": "deployment-unit--technical--data",
    "label": "Deployment unit technical data",
    "path": "32/deployment-unit--technical--data.svg"
  },
  {
    "name": "deployment-unit--technical--execution",
    "label": "Deployment unit technical execution",
    "path": "32/deployment-unit--technical--execution.svg"
  },
  {
    "name": "deployment-unit--technical--installation",
    "label": "Deployment unit technical installation",
    "path": "32/deployment-unit--technical--installation.svg"
  },
  {
    "name": "deployment-unit--technical--presentation",
    "label": "Deployment unit technical presentation",
    "path": "32/deployment-unit--technical--presentation.svg"
  },
  {
    "name": "desk--adjustable",
    "label": "Desk adjustable",
    "path": "32/desk--adjustable.svg"
  },
  {
    "name": "development",
    "label": "Development",
    "path": "32/development.svg"
  },
  {
    "name": "devices",
    "label": "Devices",
    "path": "32/devices.svg"
  },
  {
    "name": "devices--apps",
    "label": "Devices apps",
    "path": "32/devices--apps.svg"
  },
  {
    "name": "dew-point",
    "label": "Dew point",
    "path": "32/dew-point.svg"
  },
  {
    "name": "dew-point--filled",
    "label": "Dew point filled",
    "path": "32/dew-point--filled.svg"
  },
  {
    "name": "diagram",
    "label": "Diagram",
    "path": "32/diagram.svg"
  },
  {
    "name": "diagram--reference",
    "label": "Diagram reference",
    "path": "32/diagram--reference.svg"
  },
  {
    "name": "diamond--outline",
    "label": "Diamond outline",
    "path": "32/diamond--outline.svg"
  },
  {
    "name": "diamond--solid",
    "label": "Diamond solid",
    "path": "32/diamond--solid.svg"
  },
  {
    "name": "diamond-fill",
    "label": "Diamond fill",
    "path": "diamond-fill.svg"
  },
  {
    "name": "dicom--6000",
    "label": "DICOM 6000",
    "path": "32/watson-health/dicom--6000.svg"
  },
  {
    "name": "dicom--overlay",
    "label": "DICOM overlay",
    "path": "32/watson-health/dicom--overlay.svg"
  },
  {
    "name": "direct-link",
    "label": "IBM Cloud® Direct Link 2.0",
    "path": "32/direct-link.svg"
  },
  {
    "name": "direction--bear-right--01",
    "label": "Direction bear right 01",
    "path": "32/direction--bear-right--01.svg"
  },
  {
    "name": "direction--bear-right--01--filled",
    "label": "Direction bear right 01 filled",
    "path": "32/direction--bear-right--01--filled.svg"
  },
  {
    "name": "direction--bear-right--02",
    "label": "Direction bear right 02",
    "path": "32/direction--bear-right--02.svg"
  },
  {
    "name": "direction--bear-right--02--filled",
    "label": "Direction bear right 02 filled",
    "path": "32/direction--bear-right--02--filled.svg"
  },
  {
    "name": "direction--curve",
    "label": "Direction curve",
    "path": "32/direction--curve.svg"
  },
  {
    "name": "direction--curve--filled",
    "label": "Direction curve filled",
    "path": "32/direction--curve--filled.svg"
  },
  {
    "name": "direction--fork",
    "label": "Direction fork",
    "path": "32/direction--fork.svg"
  },
  {
    "name": "direction--fork--filled",
    "label": "Direction fork filled",
    "path": "32/direction--fork--filled.svg"
  },
  {
    "name": "direction--loop-left",
    "label": "Direction loop left",
    "path": "32/direction--loop-left.svg"
  },
  {
    "name": "direction--loop-left--filled",
    "label": "Direction loop left filled",
    "path": "32/direction--loop-left--filled.svg"
  },
  {
    "name": "direction--loop-right",
    "label": "Direction loop right",
    "path": "32/direction--loop-right.svg"
  },
  {
    "name": "direction--loop-right--filled",
    "label": "Direction loop right filled",
    "path": "32/direction--loop-right--filled.svg"
  },
  {
    "name": "direction--merge",
    "label": "Direction merge",
    "path": "32/direction--merge.svg"
  },
  {
    "name": "direction--merge--filled",
    "label": "Direction merge filled",
    "path": "32/direction--merge--filled.svg"
  },
  {
    "name": "direction--right--01",
    "label": "Direction right 01",
    "path": "32/direction--right--01.svg"
  },
  {
    "name": "direction--right--01--filled",
    "label": "Direction right 01 filled",
    "path": "32/direction--right--01--filled.svg"
  },
  {
    "name": "direction--right--02",
    "label": "Direction right 02",
    "path": "32/direction--right--02.svg"
  },
  {
    "name": "direction--right--02--filled",
    "label": "Direction right 02 filled",
    "path": "32/direction--right--02--filled.svg"
  },
  {
    "name": "direction--rotary--first-right",
    "label": "Direction rotary first right",
    "path": "32/direction--rotary--first-right.svg"
  },
  {
    "name": "direction--rotary--first-right--filled",
    "label": "Direction rotary first right filled",
    "path": "32/direction--rotary--first-right--filled.svg"
  },
  {
    "name": "direction--rotary--right",
    "label": "Direction rotary right",
    "path": "32/direction--rotary--right.svg"
  },
  {
    "name": "direction--rotary--right--filled",
    "label": "Direction rotary right filled",
    "path": "32/direction--rotary--right--filled.svg"
  },
  {
    "name": "direction--rotary--straight",
    "label": "Direction rotary straight",
    "path": "32/direction--rotary--straight.svg"
  },
  {
    "name": "direction--rotary--straight--filled",
    "label": "Direction rotary straight filled",
    "path": "32/direction--rotary--straight--filled.svg"
  },
  {
    "name": "direction--sharp-turn",
    "label": "Direction sharp turn",
    "path": "32/direction--sharp-turn.svg"
  },
  {
    "name": "direction--sharp-turn--filled",
    "label": "Direction sharp turn filled",
    "path": "32/direction--sharp-turn--filled.svg"
  },
  {
    "name": "direction--straight",
    "label": "Direction straight",
    "path": "32/direction--straight.svg"
  },
  {
    "name": "direction--straight--filled",
    "label": "Direction straight filled",
    "path": "32/direction--straight--filled.svg"
  },
  {
    "name": "direction--straight--right",
    "label": "Direction straight right",
    "path": "32/direction--straight--right.svg"
  },
  {
    "name": "direction--straight--right--filled",
    "label": "Direction straight right filled",
    "path": "32/direction--straight--right--filled.svg"
  },
  {
    "name": "direction--u-turn",
    "label": "Direction U-turn",
    "path": "32/direction--u-turn.svg"
  },
  {
    "name": "direction--u-turn--filled",
    "label": "Direction U-turn filled",
    "path": "32/direction--u-turn--filled.svg"
  },
  {
    "name": "directory-domain",
    "label": "Directory domain",
    "path": "32/directory-domain.svg"
  },
  {
    "name": "distribute--horizontal-center",
    "label": "Distribute horizontal center",
    "path": "32/distribute--horizontal-center.svg"
  },
  {
    "name": "distribute--horizontal-left",
    "label": "Distribute horizontal left",
    "path": "32/distribute--horizontal-left.svg"
  },
  {
    "name": "distribute--horizontal-right",
    "label": "Distribute horizontal right",
    "path": "32/distribute--horizontal-right.svg"
  },
  {
    "name": "distribute--vertical-bottom",
    "label": "Distribute vertical bottom",
    "path": "32/distribute--vertical-bottom.svg"
  },
  {
    "name": "distribute--vertical-center",
    "label": "Distribute vertical center",
    "path": "32/distribute--vertical-center.svg"
  },
  {
    "name": "distribute--vertical-top",
    "label": "Distribute vertical top",
    "path": "32/distribute--vertical-top.svg"
  },
  {
    "name": "dna",
    "label": "DNA",
    "path": "32/watson-health/dna.svg"
  },
  {
    "name": "dns-services",
    "label": "IBM Cloud® DNS services",
    "path": "32/dns-services.svg"
  },
  {
    "name": "DOC",
    "label": "DOC",
    "path": "32/DOC.svg"
  },
  {
    "name": "document",
    "label": "Document",
    "path": "32/document.svg"
  },
  {
    "name": "document--add",
    "label": "Document add",
    "path": "32/document--add.svg"
  },
  {
    "name": "document--attachment",
    "label": "Document attachment",
    "path": "32/document--attachment.svg"
  },
  {
    "name": "document--audio",
    "label": "Document audio",
    "path": "32/document--audio.svg"
  },
  {
    "name": "document--blank",
    "label": "Document blank",
    "path": "32/document--blank.svg"
  },
  {
    "name": "document--download",
    "label": "Document download",
    "path": "32/document--download.svg"
  },
  {
    "name": "document--epdf",
    "label": "Document ePDF",
    "path": "32/document--epdf.svg"
  },
  {
    "name": "document--export",
    "label": "Document export",
    "path": "32/document--export.svg"
  },
  {
    "name": "document--horizontal",
    "label": "Document horizontal",
    "path": "32/document--horizontal.svg"
  },
  {
    "name": "document--import",
    "label": "Document import",
    "path": "32/document--import.svg"
  },
  {
    "name": "document--multiple-01",
    "label": "Document multiple 01",
    "path": "32/document--multiple-01.svg"
  },
  {
    "name": "document--multiple-02",
    "label": "Document multiple 02",
    "path": "32/document--multiple-02.svg"
  },
  {
    "name": "document--pdf",
    "label": "Document PDF",
    "path": "32/document--pdf.svg"
  },
  {
    "name": "document--preliminary",
    "label": "Document preliminary",
    "path": "32/document--preliminary.svg"
  },
  {
    "name": "document--protected",
    "label": "Document protected",
    "path": "32/document--protected.svg"
  },
  {
    "name": "document--security",
    "label": "Document security",
    "path": "32/document--security.svg"
  },
  {
    "name": "document--signed",
    "label": "Document signed",
    "path": "32/document--signed.svg"
  },
  {
    "name": "document--sketch",
    "label": "Document Sketch",
    "path": "32/document--sketch.svg"
  },
  {
    "name": "document--subtract",
    "label": "Document subtract",
    "path": "32/document--subtract.svg"
  },
  {
    "name": "document--tasks",
    "label": "Document tasks",
    "path": "32/document--tasks.svg"
  },
  {
    "name": "document--unknown",
    "label": "Document unknown",
    "path": "32/document--unknown.svg"
  },
  {
    "name": "document--unprotected",
    "label": "Document unprotected",
    "path": "32/document--unprotected.svg"
  },
  {
    "name": "document--vertical",
    "label": "Document vertical",
    "path": "32/document--vertical.svg"
  },
  {
    "name": "document--video",
    "label": "Document video",
    "path": "32/document--video.svg"
  },
  {
    "name": "document--view",
    "label": "Document view",
    "path": "32/document--view.svg"
  },
  {
    "name": "document--word-processor",
    "label": "Document word processor",
    "path": "32/document--word-processor.svg"
  },
  {
    "name": "document--word-processor--reference",
    "label": "Document word processor reference",
    "path": "32/document--word-processor--reference.svg"
  },
  {
    "name": "document-sentiment",
    "label": "Document sentiment",
    "path": "32/document-sentiment.svg"
  },
  {
    "name": "dog-walker",
    "label": "Dog walker",
    "path": "32/dog-walker.svg"
  },
  {
    "name": "dot-mark",
    "label": "Dot mark",
    "path": "32/dot-mark.svg"
  },
  {
    "name": "double-integer",
    "label": "Double integer",
    "path": "32/double-integer.svg"
  },
  {
    "name": "down-to-bottom",
    "label": "Down to bottom",
    "path": "32/down-to-bottom.svg"
  },
  {
    "name": "download",
    "label": "Download",
    "path": "32/download.svg"
  },
  {
    "name": "download-study",
    "label": "Download study",
    "path": "32/watson-health/download-study.svg"
  },
  {
    "name": "downstream",
    "label": "Downstream",
    "path": "32/downstream.svg"
  },
  {
    "name": "drag--horizontal",
    "label": "Drag horizontal",
    "path": "32/drag--horizontal.svg"
  },
  {
    "name": "drag--vertical",
    "label": "Drag vertical",
    "path": "32/drag--vertical.svg"
  },
  {
    "name": "draggable",
    "label": "Draggable",
    "path": "32/draggable.svg"
  },
  {
    "name": "draw",
    "label": "Draw",
    "path": "32/draw.svg"
  },
  {
    "name": "drill-back",
    "label": "Drill back",
    "path": "32/drill-back.svg"
  },
  {
    "name": "drill-down",
    "label": "Drill down",
    "path": "32/drill-down.svg"
  },
  {
    "name": "drill-through",
    "label": "Drill through",
    "path": "32/drill-through.svg"
  },
  {
    "name": "drink--01",
    "label": "Drink 01",
    "path": "32/drink--01.svg"
  },
  {
    "name": "drink--02",
    "label": "Drink 02",
    "path": "32/drink--02.svg"
  },
  {
    "name": "driver-analysis",
    "label": "Driver analysis",
    "path": "32/driver-analysis.svg"
  },
  {
    "name": "drone",
    "label": "Drone",
    "path": "32/drone.svg"
  },
  {
    "name": "drone--delivery",
    "label": "Drone delivery",
    "path": "32/drone--delivery.svg"
  },
  {
    "name": "drone--front",
    "label": "Drone front",
    "path": "32/drone--front.svg"
  },
  {
    "name": "drone--video",
    "label": "Drone video",
    "path": "32/drone--video.svg"
  },
  {
    "name": "drop-photo",
    "label": "Drop photo",
    "path": "32/drop-photo.svg"
  },
  {
    "name": "drop-photo--filled",
    "label": "Drop photo filled",
    "path": "32/drop-photo--filled.svg"
  },
  {
    "name": "drought",
    "label": "Drought",
    "path": "32/drought.svg"
  },
  {
    "name": "DVR",
    "label": "DVR",
    "path": "32/DVR.svg"
  },
  {
    "name": "earth",
    "label": "Earth",
    "path": "32/earth.svg"
  },
  {
    "name": "earth--americas",
    "label": "Earth Americas",
    "path": "32/earth--americas.svg"
  },
  {
    "name": "earth--americas--filled",
    "label": "Earth Americas filled",
    "path": "32/earth--americas--filled.svg"
  },
  {
    "name": "earth--europe-africa",
    "label": "Earth Europe Africa",
    "path": "32/earth--europe-africa.svg"
  },
  {
    "name": "earth--europe-africa--filled",
    "label": "Earth Europe Africa filled",
    "path": "32/earth--europe-africa--filled.svg"
  },
  {
    "name": "earth--filled",
    "label": "Earth filled",
    "path": "32/earth--filled.svg"
  },
  {
    "name": "earth--southeast-asia",
    "label": "Earth Southeast Asia",
    "path": "32/earth--southeast-asia.svg"
  },
  {
    "name": "earth--southeast-asia--filled",
    "label": "Earth Southeast Asia filled",
    "path": "32/earth--southeast-asia--filled.svg"
  },
  {
    "name": "earthquake",
    "label": "Earthquake",
    "path": "32/earthquake.svg"
  },
  {
    "name": "edge-cluster",
    "label": "Edge cluster",
    "path": "32/edge-cluster.svg"
  },
  {
    "name": "edge-device",
    "label": "Edge device",
    "path": "32/edge-device.svg"
  },
  {
    "name": "edge-enhancement",
    "label": "Edge enhancement",
    "path": "32/watson-health/edge-enhancement.svg"
  },
  {
    "name": "edge-enhancement--01",
    "label": "Edge enhancement 01",
    "path": "32/watson-health/edge-enhancement--01.svg"
  },
  {
    "name": "edge-enhancement--02",
    "label": "Edge enhancement 02",
    "path": "32/watson-health/edge-enhancement--02.svg"
  },
  {
    "name": "edge-enhancement--03",
    "label": "Edge enhancement 03",
    "path": "32/watson-health/edge-enhancement--03.svg"
  },
  {
    "name": "edge-node",
    "label": "Edge node",
    "path": "32/edge-node.svg"
  },
  {
    "name": "edge-node--alt",
    "label": "Edge node alt",
    "path": "32/edge-node--alt.svg"
  },
  {
    "name": "edge-service",
    "label": "Edge service",
    "path": "32/edge-service.svg"
  },
  {
    "name": "edit",
    "label": "Edit",
    "path": "32/edit.svg"
  },
  {
    "name": "edit--off",
    "label": "Edit off",
    "path": "32/edit--off.svg"
  },
  {
    "name": "edt-loop",
    "label": "EDT loop",
    "path": "32/edt-loop.svg"
  },
  {
    "name": "education",
    "label": "Education",
    "path": "32/education.svg"
  },
  {
    "name": "email",
    "label": "Email",
    "path": "32/email.svg"
  },
  {
    "name": "email--new",
    "label": "Email new",
    "path": "32/email--new.svg"
  },
  {
    "name": "encryption",
    "label": "Encryption",
    "path": "32/encryption.svg"
  },
  {
    "name": "energy--renewable",
    "label": "Energy renewable",
    "path": "32/energy--renewable.svg"
  },
  {
    "name": "enterprise",
    "label": "Enterprise",
    "path": "32/enterprise.svg"
  },
  {
    "name": "equal--approximately",
    "label": "Equal approximately",
    "path": "32/equal--approximately.svg"
  },
  {
    "name": "equalizer",
    "label": "Equalizer",
    "path": "32/equalizer.svg"
  },
  {
    "name": "erase",
    "label": "Erase",
    "path": "32/erase.svg"
  },
  {
    "name": "erase--3D",
    "label": "Erase 3D",
    "path": "32/watson-health/erase--3D.svg"
  },
  {
    "name": "error",
    "label": "Error",
    "path": "32/error.svg"
  },
  {
    "name": "error--filled",
    "label": "Error filled",
    "path": "32/error--filled.svg"
  },
  {
    "name": "error--outline",
    "label": "Error outline",
    "path": "32/error--outline.svg"
  },
  {
    "name": "event",
    "label": "Event",
    "path": "32/event.svg"
  },
  {
    "name": "event--change",
    "label": "Event change",
    "path": "32/event--change.svg"
  },
  {
    "name": "event--incident",
    "label": "Event incident",
    "path": "32/event--incident.svg"
  },
  {
    "name": "event--schedule",
    "label": "Event schedule",
    "path": "32/event--schedule.svg"
  },
  {
    "name": "event--warning",
    "label": "Event warning",
    "path": "32/event--warning.svg"
  },
  {
    "name": "events",
    "label": "Events",
    "path": "32/events.svg"
  },
  {
    "name": "events--alt",
    "label": "Events alt",
    "path": "32/events--alt.svg"
  },
  {
    "name": "exam-mode",
    "label": "Exam mode",
    "path": "32/exam-mode.svg"
  },
  {
    "name": "executable-program",
    "label": "Executable program",
    "path": "32/executable-program.svg"
  },
  {
    "name": "exit",
    "label": "Exit",
    "path": "32/exit.svg"
  },
  {
    "name": "expand-all",
    "label": "Expand all",
    "path": "32/expand-all.svg"
  },
  {
    "name": "expand-categories",
    "label": "Expand categories",
    "path": "32/expand-categories.svg"
  },
  {
    "name": "explore",
    "label": "Explore",
    "path": "32/explore.svg"
  },
  {
    "name": "export",
    "label": "Export",
    "path": "32/export.svg"
  },
  {
    "name": "eyedropper",
    "label": "Eyedropper",
    "path": "32/eyedropper.svg"
  },
  {
    "name": "face--activated",
    "label": "Face activated",
    "path": "32/face--activated.svg"
  },
  {
    "name": "face--activated--add",
    "label": "Face activated add",
    "path": "32/face--activated--add.svg"
  },
  {
    "name": "face--activated--filled",
    "label": "Face activated filled",
    "path": "32/face--activated--filled.svg"
  },
  {
    "name": "face--add",
    "label": "Face add",
    "path": "32/face--add.svg"
  },
  {
    "name": "face--cool",
    "label": "Face cool",
    "path": "32/face--cool.svg"
  },
  {
    "name": "face--dissatisfied",
    "label": "Face dissatisfied",
    "path": "32/face--dissatisfied.svg"
  },
  {
    "name": "face--dissatisfied--filled",
    "label": "Face dissatisfied filled",
    "path": "32/face--dissatisfied--filled.svg"
  },
  {
    "name": "face--dizzy",
    "label": "Face dizzy",
    "path": "32/face--dizzy.svg"
  },
  {
    "name": "face--dizzy--filled",
    "label": "Face dizzy filled",
    "path": "32/face--dizzy--filled.svg"
  },
  {
    "name": "face--mask",
    "label": "Face mask",
    "path": "32/face--mask.svg"
  },
  {
    "name": "face--neutral",
    "label": "Face neutral",
    "path": "32/face--neutral.svg"
  },
  {
    "name": "face--neutral--filled",
    "label": "Face neutral filled",
    "path": "32/face--neutral--filled.svg"
  },
  {
    "name": "face--pending",
    "label": "Face pending",
    "path": "32/face--pending.svg"
  },
  {
    "name": "face--pending--filled",
    "label": "Face pending filled",
    "path": "32/face--pending--filled.svg"
  },
  {
    "name": "face--satisfied",
    "label": "Face satisfied",
    "path": "32/face--satisfied.svg"
  },
  {
    "name": "face--satisfied--filled",
    "label": "Face satisfied filled",
    "path": "32/face--satisfied--filled.svg"
  },
  {
    "name": "face--wink",
    "label": "Face wink",
    "path": "32/face--wink.svg"
  },
  {
    "name": "face--wink--filled",
    "label": "Face wink filled",
    "path": "32/face--wink--filled.svg"
  },
  {
    "name": "factor",
    "label": "Factor",
    "path": "32/factor.svg"
  },
  {
    "name": "fade",
    "label": "Fade",
    "path": "32/fade.svg"
  },
  {
    "name": "favorite",
    "label": "Favorite",
    "path": "32/favorite.svg"
  },
  {
    "name": "favorite--filled",
    "label": "Favorite filled",
    "path": "32/favorite--filled.svg"
  },
  {
    "name": "favorite--half",
    "label": "Favorite half",
    "path": "32/favorite--half.svg"
  },
  {
    "name": "fetch-upload",
    "label": "Fetch upload",
    "path": "32/fetch-upload.svg"
  },
  {
    "name": "fetch-upload--cloud",
    "label": "Fetch upload cloud",
    "path": "32/fetch-upload--cloud.svg"
  },
  {
    "name": "file-storage",
    "label": "File storage",
    "path": "32/file-storage.svg"
  },
  {
    "name": "filter",
    "label": "Filter",
    "path": "32/filter.svg"
  },
  {
    "name": "filter--edit",
    "label": "Filter edit",
    "path": "32/filter--edit.svg"
  },
  {
    "name": "filter--remove",
    "label": "Filter remove",
    "path": "32/filter--remove.svg"
  },
  {
    "name": "filter--reset",
    "label": "Filter reset",
    "path": "32/filter--reset.svg"
  },
  {
    "name": "finance",
    "label": "Finance",
    "path": "32/finance.svg"
  },
  {
    "name": "fingerprint-recognition",
    "label": "Fingerprint recognition",
    "path": "32/fingerprint-recognition.svg"
  },
  {
    "name": "fire",
    "label": "Fire",
    "path": "32/fire.svg"
  },
  {
    "name": "firewall",
    "label": "Firewall",
    "path": "32/firewall.svg"
  },
  {
    "name": "firewall--classic",
    "label": "Firewall classic",
    "path": "32/firewall--classic.svg"
  },
  {
    "name": "fish",
    "label": "Fish",
    "path": "32/fish.svg"
  },
  {
    "name": "fish--multiple",
    "label": "Fish multiple",
    "path": "32/fish--multiple.svg"
  },
  {
    "name": "fit-to-height",
    "label": "Fit-to-height",
    "path": "32/fit-to-height.svg"
  },
  {
    "name": "fit-to-screen",
    "label": "Fit to screen",
    "path": "32/fit-to-screen.svg"
  },
  {
    "name": "fit-to-width",
    "label": "Fit-to-width",
    "path": "32/fit-to-width.svg"
  },
  {
    "name": "flag",
    "label": "Flag",
    "path": "32/flag.svg"
  },
  {
    "name": "flag--filled",
    "label": "Flag filled",
    "path": "32/flag--filled.svg"
  },
  {
    "name": "flagging-taxi",
    "label": "Flagging taxi",
    "path": "32/flagging-taxi.svg"
  },
  {
    "name": "flash",
    "label": "Flash",
    "path": "32/flash.svg"
  },
  {
    "name": "flash--filled",
    "label": "Flash filled",
    "path": "32/flash--filled.svg"
  },
  {
    "name": "flash--off",
    "label": "Flash off",
    "path": "32/flash--off.svg"
  },
  {
    "name": "flash--off--filled",
    "label": "Flash off filled",
    "path": "32/flash--off--filled.svg"
  },
  {
    "name": "flight--international",
    "label": "Flight international",
    "path": "32/flight--international.svg"
  },
  {
    "name": "flight--roster",
    "label": "Flight roster",
    "path": "32/flight--roster.svg"
  },
  {
    "name": "flight--schedule",
    "label": "Flight schedule",
    "path": "32/flight--schedule.svg"
  },
  {
    "name": "floating-ip",
    "label": "Floating IP",
    "path": "32/floating-ip.svg"
  },
  {
    "name": "flood",
    "label": "Flood",
    "path": "32/flood.svg"
  },
  {
    "name": "flood--warning",
    "label": "Flood warning",
    "path": "32/flood--warning.svg"
  },
  {
    "name": "floorplan",
    "label": "Floorplan",
    "path": "32/floorplan.svg"
  },
  {
    "name": "flow",
    "label": "Flow",
    "path": "32/flow.svg"
  },
  {
    "name": "flow--connection",
    "label": "Flow connection",
    "path": "32/flow--connection.svg"
  },
  {
    "name": "flow--data",
    "label": "Flow data",
    "path": "32/flow--data.svg"
  },
  {
    "name": "flow--modeler",
    "label": "Flow modeler",
    "path": "32/flow--modeler.svg"
  },
  {
    "name": "flow--modeler--reference",
    "label": "Flow modeler reference",
    "path": "32/flow--modeler--reference.svg"
  },
  {
    "name": "flow--stream",
    "label": "Flow stream",
    "path": "32/flow--stream.svg"
  },
  {
    "name": "flow--stream--reference",
    "label": "Flow stream reference",
    "path": "32/flow--stream--reference.svg"
  },
  {
    "name": "flow-logs-vpc",
    "label": "IBM Cloud® Flow Logs for VPC",
    "path": "32/flow-logs-vpc.svg"
  },
  {
    "name": "fog",
    "label": "Fog",
    "path": "32/fog.svg"
  },
  {
    "name": "folder",
    "label": "Folder",
    "path": "32/folder.svg"
  },
  {
    "name": "folder--add",
    "label": "Folder add",
    "path": "32/folder--add.svg"
  },
  {
    "name": "folder--details",
    "label": "Folder details",
    "path": "32/folder--details.svg"
  },
  {
    "name": "folder--details--reference",
    "label": "Folder details reference",
    "path": "32/folder--details--reference.svg"
  },
  {
    "name": "folder--move-to",
    "label": "Folder move to",
    "path": "32/folder--move-to.svg"
  },
  {
    "name": "folder--off",
    "label": "Folder off",
    "path": "32/folder--off.svg"
  },
  {
    "name": "folder--open",
    "label": "Folder open",
    "path": "32/folder--open.svg"
  },
  {
    "name": "folder--parent",
    "label": "Folder parent",
    "path": "32/folder--parent.svg"
  },
  {
    "name": "folder--shared",
    "label": "Folder shared",
    "path": "32/folder--shared.svg"
  },
  {
    "name": "folders",
    "label": "Folders",
    "path": "32/folders.svg"
  },
  {
    "name": "forecast--hail",
    "label": "Forecast hail",
    "path": "32/forecast--hail.svg"
  },
  {
    "name": "forecast--hail-30",
    "label": "Forecast hail 30",
    "path": "32/forecast--hail-30.svg"
  },
  {
    "name": "forecast--lightning",
    "label": "Forecast lightning",
    "path": "32/forecast--lightning.svg"
  },
  {
    "name": "forecast--lightning-30",
    "label": "Forecast lightning 30",
    "path": "32/forecast--lightning-30.svg"
  },
  {
    "name": "fork",
    "label": "Fork",
    "path": "32/fork.svg"
  },
  {
    "name": "forum",
    "label": "Forum",
    "path": "32/forum.svg"
  },
  {
    "name": "forward--10",
    "label": "Forward 10",
    "path": "32/forward--10.svg"
  },
  {
    "name": "forward--30",
    "label": "Forward 30",
    "path": "32/forward--30.svg"
  },
  {
    "name": "forward--5",
    "label": "Forward 5",
    "path": "32/forward--5.svg"
  },
  {
    "name": "fragile",
    "label": "Fragile",
    "path": "32/fragile.svg"
  },
  {
    "name": "friendship",
    "label": "friendship",
    "path": "32/friendship.svg"
  },
  {
    "name": "fruit-bowl",
    "label": "Fruit bowl",
    "path": "32/fruit-bowl.svg"
  },
  {
    "name": "function",
    "label": "Function",
    "path": "32/function.svg"
  },
  {
    "name": "function-math",
    "label": "Function math",
    "path": "32/function-math.svg"
  },
  {
    "name": "fusion-blender",
    "label": "Fusion blender",
    "path": "32/watson-health/fusion-blender.svg"
  },
  {
    "name": "game--console",
    "label": "Game console",
    "path": "32/game--console.svg"
  },
  {
    "name": "game--wireless",
    "label": "Game wireless",
    "path": "32/game--wireless.svg"
  },
  {
    "name": "gamification",
    "label": "Gamification",
    "path": "32/gamification.svg"
  },
  {
    "name": "gas-station",
    "label": "Gas station",
    "path": "32/gas-station.svg"
  },
  {
    "name": "gas-station--filled",
    "label": "Gas station filled",
    "path": "32/gas-station--filled.svg"
  },
  {
    "name": "gateway",
    "label": "Gateway",
    "path": "32/gateway.svg"
  },
  {
    "name": "gateway--api",
    "label": "Gateway api",
    "path": "32/gateway--api.svg"
  },
  {
    "name": "gateway--mail",
    "label": "Gateway mail",
    "path": "32/gateway--mail.svg"
  },
  {
    "name": "gateway--public",
    "label": "Gateway public",
    "path": "32/gateway--public.svg"
  },
  {
    "name": "gateway--security",
    "label": "Gateway security",
    "path": "32/gateway--security.svg"
  },
  {
    "name": "gateway--user-access",
    "label": "Gateway user access",
    "path": "32/gateway--user-access.svg"
  },
  {
    "name": "gateway--vpn",
    "label": "Gateway VPN",
    "path": "32/gateway--vpn.svg"
  },
  {
    "name": "gender--female",
    "label": "Gender female",
    "path": "32/gender--female.svg"
  },
  {
    "name": "gender--male",
    "label": "Gender male",
    "path": "32/gender--male.svg"
  },
  {
    "name": "generate-pdf",
    "label": "Generate pdf",
    "path": "32/generate-pdf.svg"
  },
  {
    "name": "GIF",
    "label": "GIF",
    "path": "32/GIF.svg"
  },
  {
    "name": "gift",
    "label": "Gift",
    "path": "32/gift.svg"
  },
  {
    "name": "global-loan-and-trial",
    "label": "Global loan and trial",
    "path": "32/global-loan-and-trial.svg"
  },
  {
    "name": "globe",
    "label": "Globe",
    "path": "32/globe.svg"
  },
  {
    "name": "gradient",
    "label": "Gradient",
    "path": "32/gradient.svg"
  },
  {
    "name": "graphical-data-flow",
    "label": "Graphical data flow",
    "path": "32/graphical-data-flow.svg"
  },
  {
    "name": "grid",
    "label": "Grid",
    "path": "32/grid.svg"
  },
  {
    "name": "group",
    "label": "Group",
    "path": "32/group.svg"
  },
  {
    "name": "group--access",
    "label": "Group access",
    "path": "32/group--access.svg"
  },
  {
    "name": "group--account",
    "label": "Group account",
    "path": "32/group--account.svg"
  },
  {
    "name": "group--presentation",
    "label": "Group presentation",
    "path": "32/group--presentation.svg"
  },
  {
    "name": "group--resource",
    "label": "Group resource",
    "path": "32/group--resource.svg"
  },
  {
    "name": "group--security",
    "label": "Group security",
    "path": "32/group--security.svg"
  },
  {
    "name": "group-objects",
    "label": "Group objects",
    "path": "32/group-objects.svg"
  },
  {
    "name": "group-objects--new",
    "label": "Group objects new",
    "path": "32/group-objects--new.svg"
  },
  {
    "name": "group-objects--save",
    "label": "Group objects save",
    "path": "32/group-objects--save.svg"
  },
  {
    "name": "growth",
    "label": "Growth",
    "path": "32/growth.svg"
  },
  {
    "name": "gui",
    "label": "GUI",
    "path": "32/gui.svg"
  },
  {
    "name": "gui--management",
    "label": "GUI management",
    "path": "32/gui--management.svg"
  },
  {
    "name": "H",
    "label": "H",
    "path": "32/Q/H.svg"
  },
  {
    "name": "hail",
    "label": "Hail",
    "path": "32/hail.svg"
  },
  {
    "name": "hanging-protocol",
    "label": "Hanging protocol",
    "path": "32/watson-health/hanging-protocol.svg"
  },
  {
    "name": "harbor",
    "label": "Harbor",
    "path": "32/harbor.svg"
  },
  {
    "name": "hardware-security-module",
    "label": "Hardware security module",
    "path": "32/hardware-security-module.svg"
  },
  {
    "name": "hashtag",
    "label": "Hashtag",
    "path": "32/hashtag.svg"
  },
  {
    "name": "haze",
    "label": "Haze",
    "path": "32/haze.svg"
  },
  {
    "name": "haze--night",
    "label": "Haze night",
    "path": "32/haze--night.svg"
  },
  {
    "name": "HD",
    "label": "HD",
    "path": "32/HD.svg"
  },
  {
    "name": "HD--filled",
    "label": "HD filled",
    "path": "32/HD--filled.svg"
  },
  {
    "name": "HDR",
    "label": "HDR",
    "path": "32/HDR.svg"
  },
  {
    "name": "headphones",
    "label": "Headphones",
    "path": "32/headphones.svg"
  },
  {
    "name": "headset",
    "label": "Headset",
    "path": "32/headset.svg"
  },
  {
    "name": "health-cross",
    "label": "Health cross",
    "path": "32/health-cross.svg"
  },
  {
    "name": "hearing",
    "label": "Hearing",
    "path": "32/hearing.svg"
  },
  {
    "name": "heat-map",
    "label": "Heat map",
    "path": "32/heat-map.svg"
  },
  {
    "name": "heat-map--02",
    "label": "Heat map 02",
    "path": "32/heat-map--02.svg"
  },
  {
    "name": "heat-map--03",
    "label": "Heat map 03",
    "path": "32/heat-map--03.svg"
  },
  {
    "name": "heat-map--stocks",
    "label": "Heat map stocks",
    "path": "32/heat-map--stocks.svg"
  },
  {
    "name": "helicopter",
    "label": "Helicopter",
    "path": "32/helicopter.svg"
  },
  {
    "name": "help",
    "label": "Help",
    "path": "32/help.svg"
  },
  {
    "name": "help--filled",
    "label": "Help filled",
    "path": "32/help--filled.svg"
  },
  {
    "name": "help-desk",
    "label": "Help desk",
    "path": "32/help-desk.svg"
  },
  {
    "name": "hexagon--outline",
    "label": "Hexagon outline",
    "path": "32/hexagon--outline.svg"
  },
  {
    "name": "hexagon--solid",
    "label": "Hexagon solid",
    "path": "32/hexagon--solid.svg"
  },
  {
    "name": "hexagon--vertical--outline",
    "label": "Hexagon vertical outline",
    "path": "32/hexagon--vertical--outline.svg"
  },
  {
    "name": "hexagon--vertical--solid",
    "label": "Hexagon vertical solid",
    "path": "32/hexagon--vertical--solid.svg"
  },
  {
    "name": "hinton-plot",
    "label": "Hinton plot",
    "path": "32/Q/hinton-plot.svg"
  },
  {
    "name": "HL7-attributes",
    "label": "HL7 attributes",
    "path": "32/watson-health/HL7-attributes.svg"
  },
  {
    "name": "hole-filling",
    "label": "Hole filling",
    "path": "32/watson-health/hole-filling.svg"
  },
  {
    "name": "hole-filling--cursor",
    "label": "Hole-filling cursor",
    "path": "32/watson-health/hole-filling--cursor.svg"
  },
  {
    "name": "home",
    "label": "Home",
    "path": "32/home.svg"
  },
  {
    "name": "horizontal-view",
    "label": "Horizontal view",
    "path": "32/horizontal-view.svg"
  },
  {
    "name": "hospital",
    "label": "Hospital",
    "path": "32/hospital.svg"
  },
  {
    "name": "hospital-bed",
    "label": "Hospital bed",
    "path": "32/hospital-bed.svg"
  },
  {
    "name": "hotel",
    "label": "Hotel",
    "path": "32/hotel.svg"
  },
  {
    "name": "hourglass",
    "label": "Hourglass",
    "path": "32/hourglass.svg"
  },
  {
    "name": "HTML",
    "label": "HTML",
    "path": "32/HTML.svg"
  },
  {
    "name": "HTML--reference",
    "label": "HTML reference",
    "path": "32/HTML--reference.svg"
  },
  {
    "name": "HTTP",
    "label": "HTTP",
    "path": "32/HTTP.svg"
  },
  {
    "name": "humidity",
    "label": "Humidity",
    "path": "32/humidity.svg"
  },
  {
    "name": "humidity--alt",
    "label": "Humidity alt",
    "path": "32/humidity--alt.svg"
  },
  {
    "name": "hurricane",
    "label": "Hurricane",
    "path": "32/hurricane.svg"
  },
  {
    "name": "hybrid-networking",
    "label": "Hybrid networking",
    "path": "32/hybrid-networking.svg"
  },
  {
    "name": "hybrid-networking--alt",
    "label": "Hybrid networking alt",
    "path": "32/hybrid-networking--alt.svg"
  },
  {
    "name": "ibm--ai-on-z",
    "label": "AI on Z",
    "path": "32/ibm--ai-on-z.svg"
  },
  {
    "name": "ibm--aiops-insights",
    "label": "IBM® AIOps Insights",
    "path": "32/ibm--aiops-insights.svg"
  },
  {
    "name": "ibm--bluepay",
    "label": "Unassigned",
    "path": "32/ibm--bluepay.svg"
  },
  {
    "name": "ibm--cloudant",
    "label": "IBM® Cloudant®",
    "path": "32/ibm--cloudant.svg"
  },
  {
    "name": "ibm--content-services",
    "label": "IBM® Content Services",
    "path": "32/ibm--content-services.svg"
  },
  {
    "name": "ibm--data-product-exchange",
    "label": "IBM® Data Product Exchange",
    "path": "32/ibm--data-product-exchange.svg"
  },
  {
    "name": "ibm--data-replication",
    "label": "IBM® Data Replication",
    "path": "32/ibm--data-replication.svg"
  },
  {
    "name": "ibm--datastage",
    "label": "IBM® DataStage®",
    "path": "32/ibm--datastage.svg"
  },
  {
    "name": "ibm--db2",
    "label": "IBM® Db2®",
    "path": "32/ibm--db2.svg"
  },
  {
    "name": "ibm--db2--alt",
    "label": "IBM® Db2® alt",
    "path": "32/ibm--db2--alt.svg"
  },
  {
    "name": "ibm--db2-warehouse",
    "label": "IBM® Db2® Warehouse",
    "path": "32/ibm--db2-warehouse.svg"
  },
  {
    "name": "ibm--dynamic-route-server",
    "label": "IBM® Dynamic Route Server",
    "path": "32/ibm--dynamic-route-server.svg"
  },
  {
    "name": "ibm--engineering-systems-design-rhapsody-model-manager",
    "label": "IBM® Engineering Systems Design Rhapsody Model Manager",
    "path": "32/ibm--engineering-systems-design-rhapsody-model-manager.svg"
  },
  {
    "name": "ibm--engineering-systems-design-rhapsody-sn1",
    "label": "IBM® Engineering Systems Design Rhapsody sn1",
    "path": "32/ibm--engineering-systems-design-rhapsody-sn1.svg"
  },
  {
    "name": "ibm--engineering-systems-design-rhapsody-sn2",
    "label": "IBM® Engineering Systems Design Rhapsody sn2",
    "path": "32/ibm--engineering-systems-design-rhapsody-sn2.svg"
  },
  {
    "name": "ibm--event-automation",
    "label": "IBM® Event Automation",
    "path": "32/ibm--event-automation.svg"
  },
  {
    "name": "ibm--event-endpoint-mgmt",
    "label": "IBM® Event Endpoint Management",
    "path": "32/ibm--event-endpoint-mgmt.svg"
  },
  {
    "name": "ibm--event-processing",
    "label": "IBM® Event Processing",
    "path": "32/ibm--event-processing.svg"
  },
  {
    "name": "ibm--event-streams",
    "label": "IBM® Event Streams",
    "path": "32/ibm--event-streams.svg"
  },
  {
    "name": "ibm--ibv",
    "label": "IBM® Institute for Business Value",
    "path": "32/ibm--ibv.svg"
  },
  {
    "name": "ibm--instana",
    "label": "IBM® Instana®",
    "path": "32/ibm--instana.svg"
  },
  {
    "name": "ibm--match-360",
    "label": "IBM® Match 360",
    "path": "32/ibm--match-360.svg"
  },
  {
    "name": "ibm--mq",
    "label": "IBM® MQ",
    "path": "32/ibm--mq.svg"
  },
  {
    "name": "ibm--open-enterprise-languages",
    "label": "IBM® Open Enterprise Languages",
    "path": "32/ibm--open-enterprise-languages.svg"
  },
  {
    "name": "ibm--openshift-container-platform-on-vpc-for-regulated-industries",
    "label": "RedHat® OpenShift® Container Platform on VPC landing zone",
    "path": "32/ibm--openshift-container-platform-on-vpc-for-regulated-industries.svg"
  },
  {
    "name": "ibm--power-vs",
    "label": "IBM® Power® Virtual Server",
    "path": "32/ibm--power-vs.svg"
  },
  {
    "name": "ibm--power-vs-private-cloud",
    "label": "IBM® Power® Virtual Server Private Cloud",
    "path": "32/ibm--power-vs-private-cloud.svg"
  },
  {
    "name": "ibm--power-with-vpc",
    "label": "IBM® Power® with VPC",
    "path": "32/ibm--power-with-vpc.svg"
  },
  {
    "name": "ibm--private-path-services",
    "label": "IBM Cloud® Private Path Services",
    "path": "32/ibm--private-path-services.svg"
  },
  {
    "name": "ibm--process-mining",
    "label": "IBM® Process Mining",
    "path": "32/ibm--process-mining.svg"
  },
  {
    "name": "ibm--saas-console",
    "label": "IBM® SaaS Console",
    "path": "32/ibm--saas-console.svg"
  },
  {
    "name": "ibm--sap-on-power",
    "label": "SAP HANA on IBM® Power® Systems",
    "path": "32/ibm--sap-on-power.svg"
  },
  {
    "name": "ibm--secure-infrastructure-on-vpc-for-regulated-industries",
    "label": "IBM® VPC landing zone",
    "path": "32/ibm--secure-infrastructure-on-vpc-for-regulated-industries.svg"
  },
  {
    "name": "ibm--telehealth",
    "label": "IBM® Telehealth",
    "path": "32/ibm--telehealth.svg"
  },
  {
    "name": "ibm--tenet",
    "label": "Unassigned",
    "path": "32/ibm--tenet.svg"
  },
  {
    "name": "ibm--toolchain",
    "label": "IBM® Open Toolchain API",
    "path": "32/ibm--toolchain.svg"
  },
  {
    "name": "ibm--turbonomic",
    "label": "IBM® Turbonomic®",
    "path": "32/ibm--turbonomic.svg"
  },
  {
    "name": "ibm--vpn-for-vpc",
    "label": "IBM® VPN for VPC",
    "path": "32/ibm--vpn-for-vpc.svg"
  },
  {
    "name": "ibm--vsi-on-vpc-for-regulated-industries",
    "label": "IBM® VSI on VPC landing zone",
    "path": "32/ibm--vsi-on-vpc-for-regulated-industries.svg"
  },
  {
    "name": "ibm--wazi-deploy",
    "label": "IBM® Wazi Deploy",
    "path": "32/ibm--wazi-deploy.svg"
  },
  {
    "name": "ibm-cloud",
    "label": "IBM Cloud®",
    "path": "32/ibm-cloud.svg"
  },
  {
    "name": "ibm-cloud--app-id",
    "label": "IBM Cloud® App ID",
    "path": "32/ibm-cloud--app-id.svg"
  },
  {
    "name": "ibm-cloud--bare-metal-server",
    "label": "IBM Cloud® Bare Metal Server",
    "path": "32/ibm-cloud--bare-metal-server.svg"
  },
  {
    "name": "ibm-cloud--bare-metal-servers-vpc",
    "label": "IBM Cloud® Bare Metal Server VPC",
    "path": "32/ibm-cloud--bare-metal-servers-vpc.svg"
  },
  {
    "name": "ibm-cloud--citrix-daas",
    "label": "Citrix DaaS for IBM Cloud®",
    "path": "32/ibm-cloud--citrix-daas.svg"
  },
  {
    "name": "ibm-cloud--continuous-delivery",
    "label": "IBM Cloud® Continuous Delivery",
    "path": "32/ibm-cloud--continuous-delivery.svg"
  },
  {
    "name": "ibm-cloud--dedicated-host",
    "label": "IBM Cloud® Dedicated Host",
    "path": "32/ibm-cloud--dedicated-host.svg"
  },
  {
    "name": "ibm-cloud--direct-link-1--connect",
    "label": "IBM Cloud® Direct Link Connect 01",
    "path": "32/ibm-cloud--direct-link-1--connect.svg"
  },
  {
    "name": "ibm-cloud--direct-link-1--dedicated",
    "label": "IBM Cloud® Direct Link Dedicated 01",
    "path": "32/ibm-cloud--direct-link-1--dedicated.svg"
  },
  {
    "name": "ibm-cloud--direct-link-1--dedicated-hosting",
    "label": "IBM Cloud® Direct Link Dedicated Hosting 01",
    "path": "32/ibm-cloud--direct-link-1--dedicated-hosting.svg"
  },
  {
    "name": "ibm-cloud--direct-link-1--exchange",
    "label": "IBM Cloud® Direct Link Exchange 01",
    "path": "32/ibm-cloud--direct-link-1--exchange.svg"
  },
  {
    "name": "ibm-cloud--direct-link-2--connect",
    "label": "IBM Cloud® Direct Link Connect 02",
    "path": "32/ibm-cloud--direct-link-2--connect.svg"
  },
  {
    "name": "ibm-cloud--direct-link-2--dedicated",
    "label": "IBM Cloud® Direct Link Dedicated 02",
    "path": "32/ibm-cloud--direct-link-2--dedicated.svg"
  },
  {
    "name": "ibm-cloud--direct-link-2--dedicated-hosting",
    "label": "IBM Cloud® Direct Link Dedicated Hosting 02",
    "path": "32/ibm-cloud--direct-link-2--dedicated-hosting.svg"
  },
  {
    "name": "ibm-cloud--event-notification",
    "label": "IBM Cloud® Event Notifications",
    "path": "32/ibm-cloud--event-notification.svg"
  },
  {
    "name": "ibm-cloud--event-streams",
    "label": "IBM Cloud® Event Streams",
    "path": "32/ibm-cloud--event-streams.svg"
  },
  {
    "name": "ibm-cloud--for-education",
    "label": "IBM Cloud® for Education",
    "path": "32/ibm-cloud--for-education.svg"
  },
  {
    "name": "ibm-cloud--hpc",
    "label": "IBM Cloud® HPC",
    "path": "32/ibm-cloud--hpc.svg"
  },
  {
    "name": "ibm-cloud--HSM",
    "label": "IBM Cloud® HSM",
    "path": "32/ibm-cloud--HSM.svg"
  },
  {
    "name": "ibm-cloud--hyper-protect-crypto-services",
    "label": "IBM Cloud® Hyper Protect Crypto Services",
    "path": "32/ibm-cloud--hyper-protect-crypto-services.svg"
  },
  {
    "name": "ibm-cloud--hyper-protect-dbaas",
    "label": "IBM Cloud® Hyper Protect DBaaS",
    "path": "32/ibm-cloud--hyper-protect-dbaas.svg"
  },
  {
    "name": "ibm-cloud--hyper-protect-vs",
    "label": "IBM Cloud® Hyper Protect Virtual Servers",
    "path": "32/ibm-cloud--hyper-protect-vs.svg"
  },
  {
    "name": "ibm-cloud--internet-services",
    "label": "IBM Cloud® Internet Services",
    "path": "32/ibm-cloud--internet-services.svg"
  },
  {
    "name": "ibm-cloud--ipsec-vpn",
    "label": "IBM Cloud® IPsec VPN",
    "path": "32/ibm-cloud--ipsec-vpn.svg"
  },
  {
    "name": "ibm-cloud--key-protect",
    "label": "IBM® Key Protect for IBM Cloud®",
    "path": "32/ibm-cloud--key-protect.svg"
  },
  {
    "name": "ibm-cloud--kubernetes-service",
    "label": "IBM Cloud® Kubernetes Service",
    "path": "32/ibm-cloud--kubernetes-service.svg"
  },
  {
    "name": "ibm-cloud--logging",
    "label": "IBM Cloud® Logging",
    "path": "32/ibm-cloud--logging.svg"
  },
  {
    "name": "ibm-cloud--mass-data-migration",
    "label": "IBM Cloud® Mass Data Migration",
    "path": "32/ibm-cloud--mass-data-migration.svg"
  },
  {
    "name": "ibm-cloud--pal",
    "label": "Carbon for Cloud",
    "path": "32/ibm-cloud--pal.svg"
  },
  {
    "name": "ibm-cloud--privileged-access-gateway",
    "label": "IBM Cloud® Privileged Access Gateway",
    "path": "32/ibm-cloud--privileged-access-gateway.svg"
  },
  {
    "name": "ibm-cloud--projects",
    "label": "IBM Cloud™ projects",
    "path": "32/ibm-cloud--projects.svg"
  },
  {
    "name": "ibm-cloud--resiliency",
    "label": "IBM Cloud® Resiliency Consulting and Enablement",
    "path": "32/ibm-cloud--resiliency.svg"
  },
  {
    "name": "ibm-cloud--secrets-manager",
    "label": "IBM Cloud® Secrets Manager",
    "path": "32/ibm-cloud--secrets-manager.svg"
  },
  {
    "name": "ibm-cloud--security-compliance-center",
    "label": "IBM Cloud® Security and Compliance Center",
    "path": "32/ibm-cloud--security-compliance-center.svg"
  },
  {
    "name": "ibm-cloud--security-compliance-center-workload-protection",
    "label": "IBM Cloud® Security and Compliance Center Workload Protection",
    "path": "32/ibm-cloud--security-compliance-center-workload-protection.svg"
  },
  {
    "name": "ibm-cloud--subnets",
    "label": "IBM Cloud® subnets",
    "path": "32/ibm-cloud--subnets.svg"
  },
  {
    "name": "ibm-cloud--sysdig-secure",
    "label": "Sysdig Secure on IBM Cloud®",
    "path": "32/ibm-cloud--sysdig-secure.svg"
  },
  {
    "name": "ibm-cloud--transit-gateway",
    "label": "IBM Cloud® Transit Gateway",
    "path": "32/ibm-cloud--transit-gateway.svg"
  },
  {
    "name": "ibm-cloud--virtual-server-classic",
    "label": "IBM Cloud® Virtual Server Classic",
    "path": "32/ibm-cloud--virtual-server-classic.svg"
  },
  {
    "name": "ibm-cloud--virtual-server-vpc",
    "label": "IBM Cloud® Virtual Server VPC",
    "path": "32/ibm-cloud--virtual-server-vpc.svg"
  },
  {
    "name": "ibm-cloud--vpc",
    "label": "IBM Cloud® Virtual Private Cloud",
    "path": "32/ibm-cloud--vpc.svg"
  },
  {
    "name": "ibm-cloud--vpc-endpoints",
    "label": "IBM Cloud® VPC endpoints",
    "path": "32/ibm-cloud--vpc-endpoints.svg"
  },
  {
    "name": "ibm-cloud-pak--applications",
    "label": "IBM Cloud Pak® for Applications",
    "path": "32/ibm-cloud-pak--applications.svg"
  },
  {
    "name": "ibm-cloud-pak--business-automation",
    "label": "IBM Cloud Pak® for Business Automation",
    "path": "32/ibm-cloud-pak--business-automation.svg"
  },
  {
    "name": "ibm-cloud-pak--data",
    "label": "IBM Cloud Pak® for Data",
    "path": "32/ibm-cloud-pak--data.svg"
  },
  {
    "name": "ibm-cloud-pak--integration",
    "label": "IBM Cloud Pak® for Integration",
    "path": "32/ibm-cloud-pak--integration.svg"
  },
  {
    "name": "ibm-cloud-pak--MANTA-automated-data-lineage",
    "label": "MANTA Automated Data Lineage for IBM Cloud Pak® for Data",
    "path": "32/ibm-cloud-pak--MANTA-automated-data-lineage.svg"
  },
  {
    "name": "ibm-cloud-pak--multicloud-mgmt",
    "label": "IBM Cloud Pak® for Multicloud Management",
    "path": "32/ibm-cloud-pak--multicloud-mgmt.svg"
  },
  {
    "name": "ibm-cloud-pak--netezza",
    "label": "IBM Cloud Pak® Netezza®",
    "path": "32/ibm-cloud-pak--netezza.svg"
  },
  {
    "name": "ibm-cloud-pak--network-automation",
    "label": "IBM Cloud Pak® Network Automation",
    "path": "32/ibm-cloud-pak--network-automation.svg"
  },
  {
    "name": "ibm-cloud-pak--security",
    "label": "IBM Cloud Pak® for Security",
    "path": "32/ibm-cloud-pak--security.svg"
  },
  {
    "name": "ibm-cloud-pak--system",
    "label": "IBM Cloud Pak® System",
    "path": "32/ibm-cloud-pak--system.svg"
  },
  {
    "name": "ibm-cloud-pak--watson-aiops",
    "label": "IBM Cloud Pak® AIOps",
    "path": "32/ibm-cloud-pak--watson-aiops.svg"
  },
  {
    "name": "ibm-security",
    "label": "IBM Security®",
    "path": "32/ibm-security.svg"
  },
  {
    "name": "ibm-security--services",
    "label": "IBM Security® Services",
    "path": "32/ibm-security--services.svg"
  },
  {
    "name": "ibm-watson--assistant",
    "label": "IBM Watson® Assistant",
    "path": "32/ibm-watson--assistant.svg"
  },
  {
    "name": "ibm-watson--discovery",
    "label": "IBM® watsonx™ Discovery",
    "path": "32/ibm-watson--discovery.svg"
  },
  {
    "name": "ibm-watson--knowledge-catalog",
    "label": "IBM® Knowledge Catalog",
    "path": "32/ibm-watson--knowledge-catalog.svg"
  },
  {
    "name": "ibm-watson--knowledge-studio",
    "label": "IBM® Knowledge Studio",
    "path": "32/ibm-watson--knowledge-studio.svg"
  },
  {
    "name": "ibm-watson--language-translator",
    "label": "IBM Watson® Language Translator Service",
    "path": "32/ibm-watson--language-translator.svg"
  },
  {
    "name": "ibm-watson--machine-learning",
    "label": "IBM® Machine Learning",
    "path": "32/ibm-watson--machine-learning.svg"
  },
  {
    "name": "ibm-watson--natural-language-classifier",
    "label": "IBM Watson® Natural Language Classifier Service",
    "path": "32/ibm-watson--natural-language-classifier.svg"
  },
  {
    "name": "ibm-watson--natural-language-understanding",
    "label": "IBM Watson® Natural Language Understanding Service",
    "path": "32/ibm-watson--natural-language-understanding.svg"
  },
  {
    "name": "ibm-watson--openscale",
    "label": "IBM® OpenScale",
    "path": "32/ibm-watson--openscale.svg"
  },
  {
    "name": "ibm-watson--orders",
    "label": "IBM® watsonx™ Orders",
    "path": "32/ibm-watson--orders.svg"
  },
  {
    "name": "ibm-watson--query",
    "label": "IBM Watson® Query",
    "path": "32/ibm-watson--query.svg"
  },
  {
    "name": "ibm-watson--speech-to-text",
    "label": "IBM Watson® Speech to Text",
    "path": "32/ibm-watson--speech-to-text.svg"
  },
  {
    "name": "ibm-watson--studio",
    "label": "IBM Watson® Studio",
    "path": "32/ibm-watson--studio.svg"
  },
  {
    "name": "ibm-watson--text-to-speech",
    "label": "IBM Watson® Text to Speech",
    "path": "32/ibm-watson--text-to-speech.svg"
  },
  {
    "name": "ibm-watson--tone-analyzer",
    "label": "IBM Watson® Tone Analyzer",
    "path": "32/ibm-watson--tone-analyzer.svg"
  },
  {
    "name": "ibm-watsonx--assistant",
    "label": "IBM® watsonx™ Assistant",
    "path": "32/ibm-watsonx--assistant.svg"
  },
  {
    "name": "ibm-watsonx--code-assistant",
    "label": "IBM® watsonx™ Code Assistant",
    "path": "32/ibm-watsonx--code-assistant.svg"
  },
  {
    "name": "ibm-watsonx--code-assistant-for-z",
    "label": "IBM® watsonx™ Code Assistant for Z",
    "path": "32/ibm-watsonx--code-assistant-for-z.svg"
  },
  {
    "name": "ibm-watsonx--code-assistant-for-z--refactor",
    "label": "IBM® watsonx™ Code Assistant for Z Refactor",
    "path": "32/ibm-watsonx--code-assistant-for-z--refactor.svg"
  },
  {
    "name": "ibm-watsonx--orchestrate",
    "label": "IBM® watsonx™ Orchestrate",
    "path": "32/ibm-watsonx--orchestrate.svg"
  },
  {
    "name": "ibm-z--cloud-mod-stack",
    "label": "IBM Z® Cloud Modernization Stack",
    "path": "32/ibm-z--cloud-mod-stack.svg"
  },
  {
    "name": "ibm-z--environments-dev-sec-ops",
    "label": "IBM Z® Environments for DevSecOps Development",
    "path": "32/ibm-z--environments-dev-sec-ops.svg"
  },
  {
    "name": "ibm-z--processor-capacity-reference",
    "label": "IBM Z® Processor Capacity Reference",
    "path": "32/ibm-z--processor-capacity-reference.svg"
  },
  {
    "name": "ibm-z-cloud--provisioning",
    "label": "IBM Z® and Cloud Modernization Stack Provisioning",
    "path": "32/ibm-z-cloud--provisioning.svg"
  },
  {
    "name": "ibm-z-os",
    "label": "IBM® z/OS®",
    "path": "32/ibm-z-os.svg"
  },
  {
    "name": "ibm-z-os--ai-control-interface",
    "label": "AI Control Interface for IBM® z/OS®",
    "path": "32/ibm-z-os--ai-control-interface.svg"
  },
  {
    "name": "ibm-z-os--containers",
    "label": "IBM® z/OS® containers",
    "path": "32/ibm-z-os--containers.svg"
  },
  {
    "name": "ibm-z-os--package-manager",
    "label": "IBM® z/OS Package Manager",
    "path": "32/ibm-z-os--package-manager.svg"
  },
  {
    "name": "iCA-2D",
    "label": "ICA 2D",
    "path": "32/watson-health/iCA-2D.svg"
  },
  {
    "name": "ice--accretion",
    "label": "Ice accretion",
    "path": "32/ice--accretion.svg"
  },
  {
    "name": "ice--vision",
    "label": "Ice vision",
    "path": "32/ice--vision.svg"
  },
  {
    "name": "iD",
    "label": "ID",
    "path": "32/Q/iD.svg"
  },
  {
    "name": "id-management",
    "label": "ID management",
    "path": "32/id-management.svg"
  },
  {
    "name": "idea",
    "label": "Idea",
    "path": "32/idea.svg"
  },
  {
    "name": "identification",
    "label": "Identification",
    "path": "32/identification.svg"
  },
  {
    "name": "image",
    "label": "Image",
    "path": "32/image.svg"
  },
  {
    "name": "image--copy",
    "label": "Image copy",
    "path": "32/image--copy.svg"
  },
  {
    "name": "image--medical",
    "label": "Image medical",
    "path": "32/image--medical.svg"
  },
  {
    "name": "image--reference",
    "label": "Image reference",
    "path": "32/image--reference.svg"
  },
  {
    "name": "image--search",
    "label": "Image search",
    "path": "32/image--search.svg"
  },
  {
    "name": "image--search--alt",
    "label": "Image search alt",
    "path": "32/image--search--alt.svg"
  },
  {
    "name": "image-availability--local",
    "label": "Image availability local",
    "path": "32/watson-health/image-availability--local.svg"
  },
  {
    "name": "image-availability--retrieving",
    "label": "Image availability retrieving",
    "path": "32/watson-health/image-availability--retrieving.svg"
  },
  {
    "name": "image-availability--unavailable",
    "label": "Image availability unavailable",
    "path": "32/watson-health/image-availability--unavailable.svg"
  },
  {
    "name": "image-service",
    "label": "Image service",
    "path": "32/image-service.svg"
  },
  {
    "name": "import-export",
    "label": "Import export",
    "path": "32/import-export.svg"
  },
  {
    "name": "improve-relevance",
    "label": "Improve relevance",
    "path": "32/improve-relevance.svg"
  },
  {
    "name": "in-progress",
    "label": "In progress",
    "path": "32/in-progress.svg"
  },
  {
    "name": "in-progress--error",
    "label": "In progress error",
    "path": "32/in-progress--error.svg"
  },
  {
    "name": "in-progress--warning",
    "label": "In progress warning",
    "path": "32/in-progress--warning.svg"
  },
  {
    "name": "incomplete",
    "label": "Incomplete",
    "path": "32/incomplete.svg"
  },
  {
    "name": "incomplete--cancel",
    "label": "Incomplete cancel",
    "path": "32/incomplete--cancel.svg"
  },
  {
    "name": "incomplete--error",
    "label": "Incomplete error",
    "path": "32/incomplete--error.svg"
  },
  {
    "name": "incomplete--warning",
    "label": "Incomplete warning",
    "path": "32/incomplete--warning.svg"
  },
  {
    "name": "increase-level",
    "label": "Increase level",
    "path": "32/increase-level.svg"
  },
  {
    "name": "industry",
    "label": "Industry",
    "path": "32/industry.svg"
  },
  {
    "name": "infinity-symbol",
    "label": "Infinity",
    "path": "32/infinity-symbol.svg"
  },
  {
    "name": "information",
    "label": "Information",
    "path": "32/information.svg"
  },
  {
    "name": "information--disabled",
    "label": "Information disabled",
    "path": "32/information--disabled.svg"
  },
  {
    "name": "information--filled",
    "label": "Information filled",
    "path": "32/information--filled.svg"
  },
  {
    "name": "information--square",
    "label": "Information square",
    "path": "32/information--square.svg"
  },
  {
    "name": "information--square--filled",
    "label": "Information square filled",
    "path": "32/information--square--filled.svg"
  },
  {
    "name": "infrastructure--classic",
    "label": "IBM Cloud® Classic Infrastructure",
    "path": "32/infrastructure--classic.svg"
  },
  {
    "name": "insert",
    "label": "Insert",
    "path": "32/insert.svg"
  },
  {
    "name": "insert--page",
    "label": "Insert page",
    "path": "32/insert--page.svg"
  },
  {
    "name": "insert-syntax",
    "label": "Insert syntax",
    "path": "32/insert-syntax.svg"
  },
  {
    "name": "inspection",
    "label": "Inspection",
    "path": "32/inspection.svg"
  },
  {
    "name": "instance--bx",
    "label": "Instance Bx",
    "path": "32/instance--bx.svg"
  },
  {
    "name": "instance--classic",
    "label": "Instance classic",
    "path": "32/instance--classic.svg"
  },
  {
    "name": "instance--cx",
    "label": "Instance Cx",
    "path": "32/instance--cx.svg"
  },
  {
    "name": "instance--mx",
    "label": "Instance Mx",
    "path": "32/instance--mx.svg"
  },
  {
    "name": "instance--virtual",
    "label": "Instance virtual",
    "path": "32/instance--virtual.svg"
  },
  {
    "name": "integration",
    "label": "Integration",
    "path": "32/integration.svg"
  },
  {
    "name": "intent-request--active",
    "label": "Intent request active",
    "path": "32/intent-request--active.svg"
  },
  {
    "name": "intent-request--create",
    "label": "Intent request create",
    "path": "32/intent-request--create.svg"
  },
  {
    "name": "intent-request--heal",
    "label": "Intent request heal",
    "path": "32/intent-request--heal.svg"
  },
  {
    "name": "intent-request--inactive",
    "label": "Intent request inactive",
    "path": "32/intent-request--inactive.svg"
  },
  {
    "name": "intent-request--scale-in",
    "label": "Intent request scale-in",
    "path": "32/intent-request--scale-in.svg"
  },
  {
    "name": "intent-request--scale-out",
    "label": "Intent request scale-out",
    "path": "32/intent-request--scale-out.svg"
  },
  {
    "name": "intent-request--uninstall",
    "label": "Intent request uninstall",
    "path": "32/intent-request--uninstall.svg"
  },
  {
    "name": "intent-request--upgrade",
    "label": "Intent request upgrade",
    "path": "32/intent-request--upgrade.svg"
  },
  {
    "name": "interactions",
    "label": "Interactions",
    "path": "32/interactions.svg"
  },
  {
    "name": "interactive-segmentation-cursor",
    "label": "Interactive segmentation cursor",
    "path": "32/watson-health/interactive-segmentation-cursor.svg"
  },
  {
    "name": "intersect",
    "label": "Intersect",
    "path": "32/intersect.svg"
  },
  {
    "name": "intrusion-prevention",
    "label": "Intrusion prevention",
    "path": "32/intrusion-prevention.svg"
  },
  {
    "name": "inventory-management",
    "label": "Inventory management",
    "path": "32/inventory-management.svg"
  },
  {
    "name": "iot--connect",
    "label": "IoT connect",
    "path": "32/iot--connect.svg"
  },
  {
    "name": "iot--platform",
    "label": "IoT platform",
    "path": "32/iot--platform.svg"
  },
  {
    "name": "IP",
    "label": "IP",
    "path": "32/IP.svg"
  },
  {
    "name": "ISO",
    "label": "ISO",
    "path": "32/ISO.svg"
  },
  {
    "name": "ISO--filled",
    "label": "ISO filled",
    "path": "32/ISO--filled.svg"
  },
  {
    "name": "ISO--outline",
    "label": "ISO outline",
    "path": "32/ISO--outline.svg"
  },
  {
    "name": "join--full",
    "label": "Join full",
    "path": "32/join--full.svg"
  },
  {
    "name": "join--inner",
    "label": "Join inner",
    "path": "32/join--inner.svg"
  },
  {
    "name": "join--left",
    "label": "Join left",
    "path": "32/join--left.svg"
  },
  {
    "name": "join--outer",
    "label": "Join outer",
    "path": "32/join--outer.svg"
  },
  {
    "name": "join--right",
    "label": "Join right",
    "path": "32/join--right.svg"
  },
  {
    "name": "JPG",
    "label": "JPG",
    "path": "32/JPG.svg"
  },
  {
    "name": "js-error",
    "label": "JS error",
    "path": "32/js-error.svg"
  },
  {
    "name": "JSON",
    "label": "JSON",
    "path": "32/JSON.svg"
  },
  {
    "name": "JSON--reference",
    "label": "JSON reference",
    "path": "32/JSON--reference.svg"
  },
  {
    "name": "jump-link",
    "label": "Jump link",
    "path": "32/jump-link.svg"
  },
  {
    "name": "keep-dry",
    "label": "Keep dry",
    "path": "32/keep-dry.svg"
  },
  {
    "name": "keyboard",
    "label": "Keyboard",
    "path": "32/keyboard.svg"
  },
  {
    "name": "keyboard--off",
    "label": "Keyboard off",
    "path": "32/keyboard--off.svg"
  },
  {
    "name": "kubernetes",
    "label": "Kubernetes",
    "path": "32/kubernetes.svg"
  },
  {
    "name": "kubernetes--ip-address",
    "label": "Kubernetes IP address",
    "path": "32/kubernetes--ip-address.svg"
  },
  {
    "name": "kubernetes--pod",
    "label": "Kubernetes pod",
    "path": "32/kubernetes--pod.svg"
  },
  {
    "name": "label",
    "label": "Label",
    "path": "32/label.svg"
  },
  {
    "name": "language",
    "label": "Language",
    "path": "32/language.svg"
  },
  {
    "name": "laptop",
    "label": "Laptop",
    "path": "32/laptop.svg"
  },
  {
    "name": "lasso",
    "label": "Lasso",
    "path": "32/lasso.svg"
  },
  {
    "name": "lasso--polygon",
    "label": "Lasso polygon",
    "path": "32/lasso--polygon.svg"
  },
  {
    "name": "launch",
    "label": "Launch",
    "path": "32/launch.svg"
  },
  {
    "name": "launch-study--1",
    "label": "Launch study 1",
    "path": "32/watson-health/launch-study--1.svg"
  },
  {
    "name": "launch-study--2",
    "label": "Launch study 2",
    "path": "32/watson-health/launch-study--2.svg"
  },
  {
    "name": "launch-study--3",
    "label": "Launch study 3",
    "path": "32/watson-health/launch-study--3.svg"
  },
  {
    "name": "layers",
    "label": "Layers",
    "path": "32/layers.svg"
  },
  {
    "name": "legend",
    "label": "Legend",
    "path": "32/legend.svg"
  },
  {
    "name": "letter--Aa",
    "label": "Letter Aa",
    "path": "32/letter--Aa.svg"
  },
  {
    "name": "letter--Bb",
    "label": "Letter Bb",
    "path": "32/letter--Bb.svg"
  },
  {
    "name": "letter--Cc",
    "label": "Letter Cc",
    "path": "32/letter--Cc.svg"
  },
  {
    "name": "letter--Dd",
    "label": "Letter Dd",
    "path": "32/letter--Dd.svg"
  },
  {
    "name": "letter--Ee",
    "label": "Letter Ee",
    "path": "32/letter--Ee.svg"
  },
  {
    "name": "letter--Ff",
    "label": "Letter Ff",
    "path": "32/letter--Ff.svg"
  },
  {
    "name": "letter--Gg",
    "label": "Letter Gg",
    "path": "32/letter--Gg.svg"
  },
  {
    "name": "letter--Hh",
    "label": "Letter Hh",
    "path": "32/letter--Hh.svg"
  },
  {
    "name": "letter--Ii",
    "label": "Letter Ii",
    "path": "32/letter--Ii.svg"
  },
  {
    "name": "letter--Jj",
    "label": "Letter Jj",
    "path": "32/letter--Jj.svg"
  },
  {
    "name": "letter--Kk",
    "label": "Letter Kk",
    "path": "32/letter--Kk.svg"
  },
  {
    "name": "letter--Ll",
    "label": "Letter Ll",
    "path": "32/letter--Ll.svg"
  },
  {
    "name": "letter--Mm",
    "label": "Letter Mm",
    "path": "32/letter--Mm.svg"
  },
  {
    "name": "letter--Nn",
    "label": "Letter Nn",
    "path": "32/letter--Nn.svg"
  },
  {
    "name": "letter--Oo",
    "label": "Letter Oo",
    "path": "32/letter--Oo.svg"
  },
  {
    "name": "letter--Pp",
    "label": "Letter Pp",
    "path": "32/letter--Pp.svg"
  },
  {
    "name": "letter--Qq",
    "label": "Letter Qq",
    "path": "32/letter--Qq.svg"
  },
  {
    "name": "letter--Rr",
    "label": "Letter Rr",
    "path": "32/letter--Rr.svg"
  },
  {
    "name": "letter--Ss",
    "label": "Letter Ss",
    "path": "32/letter--Ss.svg"
  },
  {
    "name": "letter--Tt",
    "label": "Letter Tt",
    "path": "32/letter--Tt.svg"
  },
  {
    "name": "letter--Uu",
    "label": "Letter Uu",
    "path": "32/letter--Uu.svg"
  },
  {
    "name": "letter--Vv",
    "label": "Letter Vv",
    "path": "32/letter--Vv.svg"
  },
  {
    "name": "letter--Ww",
    "label": "Letter Ww",
    "path": "32/letter--Ww.svg"
  },
  {
    "name": "letter--Xx",
    "label": "Letter Xx",
    "path": "32/letter--Xx.svg"
  },
  {
    "name": "letter--Yy",
    "label": "Letter Yy",
    "path": "32/letter--Yy.svg"
  },
  {
    "name": "letter--Zz",
    "label": "Letter Zz",
    "path": "32/letter--Zz.svg"
  },
  {
    "name": "license",
    "label": "License",
    "path": "32/license.svg"
  },
  {
    "name": "license--draft",
    "label": "License draft",
    "path": "32/license--draft.svg"
  },
  {
    "name": "license--global",
    "label": "License global",
    "path": "32/license--global.svg"
  },
  {
    "name": "license--maintenance",
    "label": "License maintenance",
    "path": "32/license--maintenance.svg"
  },
  {
    "name": "license--maintenance-draft",
    "label": "License maintenance draft",
    "path": "32/license--maintenance-draft.svg"
  },
  {
    "name": "license--third-party",
    "label": "License third-party",
    "path": "32/license--third-party.svg"
  },
  {
    "name": "license--third-party-draft",
    "label": "License third-party draft",
    "path": "32/license--third-party-draft.svg"
  },
  {
    "name": "lifesaver",
    "label": "Lifesaver",
    "path": "32/lifesaver.svg"
  },
  {
    "name": "light",
    "label": "Light",
    "path": "32/light.svg"
  },
  {
    "name": "light--filled",
    "label": "Light filled",
    "path": "32/light--filled.svg"
  },
  {
    "name": "lightning",
    "label": "Lightning",
    "path": "32/lightning.svg"
  },
  {
    "name": "link",
    "label": "Link",
    "path": "32/link.svg"
  },
  {
    "name": "linux",
    "label": "Linux®",
    "path": "32/linux.svg"
  },
  {
    "name": "linux--alt",
    "label": "Linux® alt",
    "path": "32/linux--alt.svg"
  },
  {
    "name": "list",
    "label": "List",
    "path": "32/list.svg"
  },
  {
    "name": "list--boxes",
    "label": "List boxes",
    "path": "32/list--boxes.svg"
  },
  {
    "name": "list--bulleted",
    "label": "List bulleted",
    "path": "32/list--bulleted.svg"
  },
  {
    "name": "list--checked",
    "label": "List checked",
    "path": "32/list--checked.svg"
  },
  {
    "name": "list--checked--mirror",
    "label": "List checked mirror",
    "path": "32/list--checked--mirror.svg"
  },
  {
    "name": "list--dropdown",
    "label": "List dropdown",
    "path": "32/list--dropdown.svg"
  },
  {
    "name": "list--numbered",
    "label": "List numbered",
    "path": "32/list--numbered.svg"
  },
  {
    "name": "list--numbered--mirror",
    "label": "List numbered mirror",
    "path": "32/list--numbered--mirror.svg"
  },
  {
    "name": "load-balancer--application",
    "label": "Load balancer application",
    "path": "32/load-balancer--application.svg"
  },
  {
    "name": "load-balancer--classic",
    "label": "Load balancer classic",
    "path": "32/load-balancer--classic.svg"
  },
  {
    "name": "load-balancer--global",
    "label": "Load balancer global",
    "path": "32/load-balancer--global.svg"
  },
  {
    "name": "load-balancer--listener",
    "label": "Load balancer listener",
    "path": "32/load-balancer--listener.svg"
  },
  {
    "name": "load-balancer--local",
    "label": "Load balancer local",
    "path": "32/load-balancer--local.svg"
  },
  {
    "name": "load-balancer--network",
    "label": "Load balancer network",
    "path": "32/load-balancer--network.svg"
  },
  {
    "name": "load-balancer--pool",
    "label": "Load balancer pool",
    "path": "32/load-balancer--pool.svg"
  },
  {
    "name": "load-balancer--vpc",
    "label": "IBM Cloud® Load Balancer for VPC",
    "path": "32/load-balancer--vpc.svg"
  },
  {
    "name": "location",
    "label": "Location",
    "path": "32/location.svg"
  },
  {
    "name": "location--company",
    "label": "Location company",
    "path": "32/location--company.svg"
  },
  {
    "name": "location--company--filled",
    "label": "Location company filled",
    "path": "32/location--company--filled.svg"
  },
  {
    "name": "location--current",
    "label": "Location current",
    "path": "32/location--current.svg"
  },
  {
    "name": "location--filled",
    "label": "Location filled",
    "path": "32/location--filled.svg"
  },
  {
    "name": "location--hazard",
    "label": "Location hazard",
    "path": "32/location--hazard.svg"
  },
  {
    "name": "location--hazard--filled",
    "label": "Location hazard filled",
    "path": "32/location--hazard--filled.svg"
  },
  {
    "name": "location--heart",
    "label": "Location heart",
    "path": "32/location--heart.svg"
  },
  {
    "name": "location--heart--filled",
    "label": "Location heart filled",
    "path": "32/location--heart--filled.svg"
  },
  {
    "name": "location--person",
    "label": "Location person",
    "path": "32/location--person.svg"
  },
  {
    "name": "location--person--filled",
    "label": "Location person filled",
    "path": "32/location--person--filled.svg"
  },
  {
    "name": "location--save",
    "label": "Location save",
    "path": "32/location--save.svg"
  },
  {
    "name": "location--star",
    "label": "Location star",
    "path": "32/location--star.svg"
  },
  {
    "name": "location--star--filled",
    "label": "Location star filled",
    "path": "32/location--star--filled.svg"
  },
  {
    "name": "locked",
    "label": "Locked",
    "path": "32/locked.svg"
  },
  {
    "name": "logical-partition",
    "label": "Logical partition",
    "path": "32/logical-partition.svg"
  },
  {
    "name": "login",
    "label": "Login",
    "path": "32/login.svg"
  },
  {
    "name": "logo--angular",
    "label": "Logo Angular",
    "path": "32/logo--angular.svg"
  },
  {
    "name": "logo--ansible-community",
    "label": "Logo Ansible Community",
    "path": "32/logo--ansible-community.svg"
  },
  {
    "name": "logo--digg",
    "label": "Logo Digg",
    "path": "32/logo--digg.svg"
  },
  {
    "name": "logo--discord",
    "label": "Logo Discord",
    "path": "32/logo--discord.svg"
  },
  {
    "name": "logo--facebook",
    "label": "Logo Facebook",
    "path": "32/logo--facebook.svg"
  },
  {
    "name": "logo--figma",
    "label": "Logo Figma",
    "path": "32/logo--figma.svg"
  },
  {
    "name": "logo--flickr",
    "label": "Logo Flickr",
    "path": "32/logo--flickr.svg"
  },
  {
    "name": "logo--github",
    "label": "Logo GitHub",
    "path": "32/logo--github.svg"
  },
  {
    "name": "logo--gitlab",
    "label": "Logo GitLab",
    "path": "32/logo--gitlab.svg"
  },
  {
    "name": "logo--glassdoor",
    "label": "Logo Glassdoor",
    "path": "32/logo--glassdoor.svg"
  },
  {
    "name": "logo--instagram",
    "label": "Logo Instagram",
    "path": "32/logo--instagram.svg"
  },
  {
    "name": "logo--invision",
    "label": "Logo Invision",
    "path": "32/logo--invision.svg"
  },
  {
    "name": "logo--jupyter",
    "label": "Logo Jupyter",
    "path": "32/logo--jupyter.svg"
  },
  {
    "name": "logo--keybase",
    "label": "Logo Keybase",
    "path": "32/logo--keybase.svg"
  },
  {
    "name": "logo--kubernetes",
    "label": "Logo Kubernetes",
    "path": "32/logo--kubernetes.svg"
  },
  {
    "name": "logo--linkedin",
    "label": "Logo LinkedIn",
    "path": "32/logo--linkedin.svg"
  },
  {
    "name": "logo--livestream",
    "label": "Logo Livestream",
    "path": "32/logo--livestream.svg"
  },
  {
    "name": "logo--mastodon",
    "label": "Logo Mastodon",
    "path": "32/logo--mastodon.svg"
  },
  {
    "name": "logo--medium",
    "label": "Logo Medium",
    "path": "32/logo--medium.svg"
  },
  {
    "name": "logo--npm",
    "label": "Logo npm",
    "path": "32/logo--npm.svg"
  },
  {
    "name": "logo--openshift",
    "label": "Logo OpenShift®",
    "path": "32/logo--openshift.svg"
  },
  {
    "name": "logo--pinterest",
    "label": "Logo Pinterest",
    "path": "32/logo--pinterest.svg"
  },
  {
    "name": "logo--python",
    "label": "Logo Python",
    "path": "32/logo--python.svg"
  },
  {
    "name": "logo--quora",
    "label": "Logo Quora",
    "path": "32/logo--quora.svg"
  },
  {
    "name": "logo--r-script",
    "label": "Logo R script",
    "path": "32/logo--r-script.svg"
  },
  {
    "name": "logo--react",
    "label": "Logo React",
    "path": "32/logo--react.svg"
  },
  {
    "name": "logo--red-hat-ansible",
    "label": "Logo Red Hat Ansible",
    "path": "32/logo--red-hat-ansible.svg"
  },
  {
    "name": "logo--sketch",
    "label": "Logo Sketch",
    "path": "32/logo--sketch.svg"
  },
  {
    "name": "logo--skype",
    "label": "Logo Skype",
    "path": "32/logo--skype.svg"
  },
  {
    "name": "logo--slack",
    "label": "Logo Slack",
    "path": "32/logo--slack.svg"
  },
  {
    "name": "logo--snapchat",
    "label": "Logo Snapchat",
    "path": "32/logo--snapchat.svg"
  },
  {
    "name": "logo--svelte",
    "label": "Logo Svelte",
    "path": "32/logo--svelte.svg"
  },
  {
    "name": "logo--tumblr",
    "label": "Logo Tumblr",
    "path": "32/logo--tumblr.svg"
  },
  {
    "name": "logo--twitter",
    "label": "Logo Twitter",
    "path": "32/logo--twitter.svg"
  },
  {
    "name": "logo--vmware",
    "label": "Logo VMware",
    "path": "32/logo--vmware.svg"
  },
  {
    "name": "logo--vmware--alt",
    "label": "Logo VMware alt",
    "path": "32/logo--vmware--alt.svg"
  },
  {
    "name": "logo--vue",
    "label": "Logo Vue",
    "path": "32/logo--vue.svg"
  },
  {
    "name": "logo--wechat",
    "label": "Logo WeChat",
    "path": "32/logo--wechat.svg"
  },
  {
    "name": "logo--x",
    "label": "Logo X",
    "path": "32/logo--x.svg"
  },
  {
    "name": "logo--xing",
    "label": "Logo XING",
    "path": "32/logo--xing.svg"
  },
  {
    "name": "logo--yelp",
    "label": "Logo Yelp",
    "path": "32/logo--yelp.svg"
  },
  {
    "name": "logo--youtube",
    "label": "Logo YouTube",
    "path": "32/logo--youtube.svg"
  },
  {
    "name": "logout",
    "label": "Logout",
    "path": "32/logout.svg"
  },
  {
    "name": "loop",
    "label": "Loop",
    "path": "32/loop.svg"
  },
  {
    "name": "low-severity",
    "label": "Low severity",
    "path": "low-severity.svg"
  },
  {
    "name": "MAC",
    "label": "MAC",
    "path": "32/MAC.svg"
  },
  {
    "name": "mac--command",
    "label": "Mac command",
    "path": "32/mac--command.svg"
  },
  {
    "name": "mac--option",
    "label": "Mac option",
    "path": "32/mac--option.svg"
  },
  {
    "name": "mac--shift",
    "label": "Mac shift",
    "path": "32/mac--shift.svg"
  },
  {
    "name": "machine-learning",
    "label": "Machine learning",
    "path": "32/machine-learning.svg"
  },
  {
    "name": "machine-learning-model",
    "label": "Machine learning model",
    "path": "32/machine-learning-model.svg"
  },
  {
    "name": "magic-wand",
    "label": "Magic wand",
    "path": "32/magic-wand.svg"
  },
  {
    "name": "magic-wand--filled",
    "label": "Magic wand filled",
    "path": "32/magic-wand--filled.svg"
  },
  {
    "name": "magnify",
    "label": "Magnify",
    "path": "32/watson-health/magnify.svg"
  },
  {
    "name": "mail--all",
    "label": "Mail all",
    "path": "32/mail--all.svg"
  },
  {
    "name": "mail--reply",
    "label": "Mail reply",
    "path": "32/mail--reply.svg"
  },
  {
    "name": "mammogram",
    "label": "Mammogram",
    "path": "32/watson-health/mammogram.svg"
  },
  {
    "name": "manage-protection",
    "label": "Manage protection",
    "path": "32/manage-protection.svg"
  },
  {
    "name": "managed-solutions",
    "label": "Managed solutions",
    "path": "32/managed-solutions.svg"
  },
  {
    "name": "map",
    "label": "Map",
    "path": "32/map.svg"
  },
  {
    "name": "map--center",
    "label": "Map center",
    "path": "32/map--center.svg"
  },
  {
    "name": "map--identify",
    "label": "Map identify",
    "path": "32/map--identify.svg"
  },
  {
    "name": "map-boundary",
    "label": "Map boundary",
    "path": "32/map-boundary.svg"
  },
  {
    "name": "map-boundary--vegetation",
    "label": "Map boundary vegetation",
    "path": "32/map-boundary--vegetation.svg"
  },
  {
    "name": "marine-warning",
    "label": "Marine warning",
    "path": "32/marine-warning.svg"
  },
  {
    "name": "math-curve",
    "label": "Math curve",
    "path": "32/math-curve.svg"
  },
  {
    "name": "matrix",
    "label": "Matrix",
    "path": "32/Q/matrix.svg"
  },
  {
    "name": "maximize",
    "label": "Maximize",
    "path": "32/maximize.svg"
  },
  {
    "name": "media--library",
    "label": "Media library",
    "path": "32/media--library.svg"
  },
  {
    "name": "media--library--filled",
    "label": "Media library filled",
    "path": "32/media--library--filled.svg"
  },
  {
    "name": "media-cast",
    "label": "Media cast",
    "path": "32/media-cast.svg"
  },
  {
    "name": "medication",
    "label": "Medication",
    "path": "32/medication.svg"
  },
  {
    "name": "medication--alert",
    "label": "Medication alert",
    "path": "32/medication--alert.svg"
  },
  {
    "name": "medication--reminder",
    "label": "Medication reminder",
    "path": "32/medication--reminder.svg"
  },
  {
    "name": "menu",
    "label": "Menu",
    "path": "32/menu.svg"
  },
  {
    "name": "message-queue",
    "label": "Message queue",
    "path": "32/message-queue.svg"
  },
  {
    "name": "meter",
    "label": "Meter",
    "path": "32/meter.svg"
  },
  {
    "name": "meter--alt",
    "label": "Meter alt",
    "path": "32/meter--alt.svg"
  },
  {
    "name": "microphone",
    "label": "Microphone",
    "path": "32/microphone.svg"
  },
  {
    "name": "microphone--filled",
    "label": "Microphone filled",
    "path": "32/microphone--filled.svg"
  },
  {
    "name": "microphone--off",
    "label": "Microphone off",
    "path": "32/microphone--off.svg"
  },
  {
    "name": "microphone--off--filled",
    "label": "Microphone off filled",
    "path": "32/microphone--off--filled.svg"
  },
  {
    "name": "microscope",
    "label": "Microscope",
    "path": "32/microscope.svg"
  },
  {
    "name": "microservices--1",
    "label": "Microservices 1",
    "path": "32/microservices--1.svg"
  },
  {
    "name": "microservices--2",
    "label": "Microservices 2",
    "path": "32/microservices--2.svg"
  },
  {
    "name": "migrate",
    "label": "Migrate",
    "path": "32/migrate.svg"
  },
  {
    "name": "migrate--alt",
    "label": "Migrate alt",
    "path": "32/migrate--alt.svg"
  },
  {
    "name": "milestone",
    "label": "Milestone",
    "path": "32/milestone.svg"
  },
  {
    "name": "military-camp",
    "label": "Military camp",
    "path": "32/military-camp.svg"
  },
  {
    "name": "minimize",
    "label": "Minimize",
    "path": "32/minimize.svg"
  },
  {
    "name": "misuse",
    "label": "Misuse",
    "path": "32/misuse.svg"
  },
  {
    "name": "misuse--outline",
    "label": "Misuse outline",
    "path": "32/misuse--outline.svg"
  },
  {
    "name": "mixed-rain-hail",
    "label": "Mixed rain hail",
    "path": "32/mixed-rain-hail.svg"
  },
  {
    "name": "mobile",
    "label": "Mobile",
    "path": "32/mobile.svg"
  },
  {
    "name": "mobile--add",
    "label": "Mobile add",
    "path": "32/mobile--add.svg"
  },
  {
    "name": "mobile--audio",
    "label": "Mobile audio",
    "path": "32/mobile--audio.svg"
  },
  {
    "name": "mobile--check",
    "label": "Mobile check",
    "path": "32/mobile--check.svg"
  },
  {
    "name": "mobile--crash",
    "label": "Mobile crash",
    "path": "32/mobile--crash.svg"
  },
  {
    "name": "mobile--download",
    "label": "Mobile download",
    "path": "32/mobile--download.svg"
  },
  {
    "name": "mobile--event",
    "label": "Mobile event",
    "path": "32/mobile--event.svg"
  },
  {
    "name": "mobile--landscape",
    "label": "Mobile landscape",
    "path": "32/mobile--landscape.svg"
  },
  {
    "name": "mobile--request",
    "label": "Mobile request",
    "path": "32/mobile--request.svg"
  },
  {
    "name": "mobile--session",
    "label": "Mobile session",
    "path": "32/mobile--session.svg"
  },
  {
    "name": "mobile--view",
    "label": "Mobile view",
    "path": "32/mobile--view.svg"
  },
  {
    "name": "mobile--view-orientation",
    "label": "Mobile view orientation",
    "path": "32/mobile--view-orientation.svg"
  },
  {
    "name": "mobility--services",
    "label": "Mobility services",
    "path": "32/mobility--services.svg"
  },
  {
    "name": "model",
    "label": "Model",
    "path": "32/model.svg"
  },
  {
    "name": "model--alt",
    "label": "Model alt",
    "path": "32/model--alt.svg"
  },
  {
    "name": "model--reference",
    "label": "Model reference",
    "path": "32/model--reference.svg"
  },
  {
    "name": "model--tuned",
    "label": "Model tuned",
    "path": "32/model--tuned.svg"
  },
  {
    "name": "model-builder",
    "label": "Model builder",
    "path": "32/model-builder.svg"
  },
  {
    "name": "model-builder--reference",
    "label": "Model builder reference",
    "path": "32/model-builder--reference.svg"
  },
  {
    "name": "money",
    "label": "Money",
    "path": "32/money.svg"
  },
  {
    "name": "monster",
    "label": "Monster",
    "path": "32/monster.svg"
  },
  {
    "name": "monument",
    "label": "Monument",
    "path": "32/monument.svg"
  },
  {
    "name": "moon",
    "label": "Moon",
    "path": "32/moon.svg"
  },
  {
    "name": "moonrise",
    "label": "Moonrise",
    "path": "32/moonrise.svg"
  },
  {
    "name": "moonset",
    "label": "moonset",
    "path": "32/moonset.svg"
  },
  {
    "name": "mostly-cloudy",
    "label": "Mostly cloudy",
    "path": "32/mostly-cloudy.svg"
  },
  {
    "name": "mostly-cloudy--night",
    "label": "Mostly cloudy night",
    "path": "32/mostly-cloudy--night.svg"
  },
  {
    "name": "mountain",
    "label": "Mountain",
    "path": "32/mountain.svg"
  },
  {
    "name": "MOV",
    "label": "MOV",
    "path": "32/MOV.svg"
  },
  {
    "name": "move",
    "label": "Move",
    "path": "32/move.svg"
  },
  {
    "name": "movement",
    "label": "Movement",
    "path": "32/movement.svg"
  },
  {
    "name": "MP3",
    "label": "MP3",
    "path": "32/MP3.svg"
  },
  {
    "name": "MP4",
    "label": "MP4",
    "path": "32/MP4.svg"
  },
  {
    "name": "MPEG",
    "label": "MPEG",
    "path": "32/MPEG.svg"
  },
  {
    "name": "MPG2",
    "label": "MPG2",
    "path": "32/MPG2.svg"
  },
  {
    "name": "music",
    "label": "Music",
    "path": "32/music.svg"
  },
  {
    "name": "music--add",
    "label": "Music add",
    "path": "32/music--add.svg"
  },
  {
    "name": "music--remove",
    "label": "Music remove",
    "path": "32/music--remove.svg"
  },
  {
    "name": "mysql",
    "label": "MySQL",
    "path": "32/mysql.svg"
  },
  {
    "name": "name-space",
    "label": "Name space",
    "path": "32/name-space.svg"
  },
  {
    "name": "navaid--civil",
    "label": "Navaid civil",
    "path": "32/navaid--civil.svg"
  },
  {
    "name": "navaid--dme",
    "label": "Navaid dme",
    "path": "32/navaid--dme.svg"
  },
  {
    "name": "navaid--helipad",
    "label": "Navaid helipad",
    "path": "32/navaid--helipad.svg"
  },
  {
    "name": "navaid--military",
    "label": "Navaid military",
    "path": "32/navaid--military.svg"
  },
  {
    "name": "navaid--military-civil",
    "label": "Navaid military civil",
    "path": "32/navaid--military-civil.svg"
  },
  {
    "name": "navaid--ndb",
    "label": "Navaid ndb",
    "path": "32/navaid--ndb.svg"
  },
  {
    "name": "navaid--ndb-dme",
    "label": "Navaid ndb dme",
    "path": "32/navaid--ndb-dme.svg"
  },
  {
    "name": "navaid--private",
    "label": "Navaid private",
    "path": "32/navaid--private.svg"
  },
  {
    "name": "navaid--seaplane",
    "label": "Navaid seaplane",
    "path": "32/navaid--seaplane.svg"
  },
  {
    "name": "navaid--tacan",
    "label": "Navaid tacan",
    "path": "32/navaid--tacan.svg"
  },
  {
    "name": "navaid--vhfor",
    "label": "Navaid vhfor",
    "path": "32/navaid--vhfor.svg"
  },
  {
    "name": "navaid--vor",
    "label": "Navaid vor",
    "path": "32/navaid--vor.svg"
  },
  {
    "name": "navaid--vordme",
    "label": "Navaid vordme",
    "path": "32/navaid--vordme.svg"
  },
  {
    "name": "navaid--vortac",
    "label": "Navaid vortac",
    "path": "32/navaid--vortac.svg"
  },
  {
    "name": "need",
    "label": "Need",
    "path": "32/need.svg"
  },
  {
    "name": "network--1",
    "label": "Network 1",
    "path": "32/network--1.svg"
  },
  {
    "name": "network--2",
    "label": "Network 2",
    "path": "32/network--2.svg"
  },
  {
    "name": "network--3",
    "label": "Network 3",
    "path": "32/network--3.svg"
  },
  {
    "name": "network--3--reference",
    "label": "Network 3 reference",
    "path": "32/network--3--reference.svg"
  },
  {
    "name": "network--4",
    "label": "Network 4",
    "path": "32/network--4.svg"
  },
  {
    "name": "network--4--reference",
    "label": "Network 4 reference",
    "path": "32/network--4--reference.svg"
  },
  {
    "name": "network--admin-control",
    "label": "Network admin control",
    "path": "32/network--admin-control.svg"
  },
  {
    "name": "network--enterprise",
    "label": "Network enterprise",
    "path": "32/network--enterprise.svg"
  },
  {
    "name": "network--overlay",
    "label": "Network overlay",
    "path": "32/network--overlay.svg"
  },
  {
    "name": "network--public",
    "label": "Network public",
    "path": "32/network--public.svg"
  },
  {
    "name": "network-interface",
    "label": "Network interface",
    "path": "32/network-interface.svg"
  },
  {
    "name": "new-tab",
    "label": "New tab",
    "path": "32/new-tab.svg"
  },
  {
    "name": "next--filled",
    "label": "Next filled",
    "path": "32/next--filled.svg"
  },
  {
    "name": "next--outline",
    "label": "Next outline",
    "path": "32/next--outline.svg"
  },
  {
    "name": "no-image",
    "label": "No image",
    "path": "32/no-image.svg"
  },
  {
    "name": "no-ticket",
    "label": "No ticket",
    "path": "32/no-ticket.svg"
  },
  {
    "name": "nominal",
    "label": "Nominal",
    "path": "32/nominal.svg"
  },
  {
    "name": "nominate",
    "label": "Nominate",
    "path": "32/watson-health/nominate.svg"
  },
  {
    "name": "non-certified",
    "label": "Non-certified",
    "path": "32/non-certified.svg"
  },
  {
    "name": "noodle-bowl",
    "label": "Noodle bowl",
    "path": "32/noodle-bowl.svg"
  },
  {
    "name": "not-available",
    "label": "Not available",
    "path": "32/not-available.svg"
  },
  {
    "name": "not-sent",
    "label": "Not sent",
    "path": "32/not-sent.svg"
  },
  {
    "name": "not-sent--filled",
    "label": "Not sent filled",
    "path": "32/not-sent--filled.svg"
  },
  {
    "name": "notebook",
    "label": "Notebook",
    "path": "32/notebook.svg"
  },
  {
    "name": "notebook--reference",
    "label": "Notebook reference",
    "path": "32/notebook--reference.svg"
  },
  {
    "name": "notification",
    "label": "Notification",
    "path": "32/notification.svg"
  },
  {
    "name": "notification--filled",
    "label": "Notification filled",
    "path": "32/notification--filled.svg"
  },
  {
    "name": "notification--new",
    "label": "Notification new",
    "path": "32/notification--new.svg"
  },
  {
    "name": "notification--off",
    "label": "Notification off",
    "path": "32/notification--off.svg"
  },
  {
    "name": "notification--off--filled",
    "label": "Notification off filled",
    "path": "32/notification--off--filled.svg"
  },
  {
    "name": "number--0",
    "label": "Number 0",
    "path": "32/number--0.svg"
  },
  {
    "name": "number--1",
    "label": "Number 1",
    "path": "32/number--1.svg"
  },
  {
    "name": "number--2",
    "label": "Number 2",
    "path": "32/number--2.svg"
  },
  {
    "name": "number--3",
    "label": "Number 3",
    "path": "32/number--3.svg"
  },
  {
    "name": "number--4",
    "label": "Number 4",
    "path": "32/number--4.svg"
  },
  {
    "name": "number--5",
    "label": "Number 5",
    "path": "32/number--5.svg"
  },
  {
    "name": "number--6",
    "label": "Number 6",
    "path": "32/number--6.svg"
  },
  {
    "name": "number--7",
    "label": "Number 7",
    "path": "32/number--7.svg"
  },
  {
    "name": "number--8",
    "label": "Number 8",
    "path": "32/number--8.svg"
  },
  {
    "name": "number--9",
    "label": "Number 9",
    "path": "32/number--9.svg"
  },
  {
    "name": "number--small--0",
    "label": "Number small 0",
    "path": "32/number--small--0.svg"
  },
  {
    "name": "number--small--1",
    "label": "Number small 1",
    "path": "32/number--small--1.svg"
  },
  {
    "name": "number--small--2",
    "label": "Number small 2",
    "path": "32/number--small--2.svg"
  },
  {
    "name": "number--small--3",
    "label": "Number small 3",
    "path": "32/number--small--3.svg"
  },
  {
    "name": "number--small--4",
    "label": "Number small 4",
    "path": "32/number--small--4.svg"
  },
  {
    "name": "number--small--5",
    "label": "Number small 5",
    "path": "32/number--small--5.svg"
  },
  {
    "name": "number--small--6",
    "label": "Number small 6",
    "path": "32/number--small--6.svg"
  },
  {
    "name": "number--small--7",
    "label": "Number small 7",
    "path": "32/number--small--7.svg"
  },
  {
    "name": "number--small--8",
    "label": "Number small 8",
    "path": "32/number--small--8.svg"
  },
  {
    "name": "number--small--9",
    "label": "Number small 9",
    "path": "32/number--small--9.svg"
  },
  {
    "name": "object-storage",
    "label": "Object storage",
    "path": "32/object-storage.svg"
  },
  {
    "name": "object-storage--alt",
    "label": "Object storage alt",
    "path": "32/object-storage--alt.svg"
  },
  {
    "name": "observed--hail",
    "label": "Observed hail",
    "path": "32/observed--hail.svg"
  },
  {
    "name": "observed--lightning",
    "label": "Observed lightning",
    "path": "32/observed--lightning.svg"
  },
  {
    "name": "omega",
    "label": "Omega",
    "path": "32/omega.svg"
  },
  {
    "name": "opacity",
    "label": "Opacity",
    "path": "32/opacity.svg"
  },
  {
    "name": "open-panel--bottom",
    "label": "Open panel bottom",
    "path": "32/open-panel--bottom.svg"
  },
  {
    "name": "open-panel--filled--bottom",
    "label": "Open panel filled bottom",
    "path": "32/open-panel--filled--bottom.svg"
  },
  {
    "name": "open-panel--filled--left",
    "label": "Open panel filled left",
    "path": "32/open-panel--filled--left.svg"
  },
  {
    "name": "open-panel--filled--right",
    "label": "Open panel filled right",
    "path": "32/open-panel--filled--right.svg"
  },
  {
    "name": "open-panel--filled--top",
    "label": "Open panel filled top",
    "path": "32/open-panel--filled--top.svg"
  },
  {
    "name": "open-panel--left",
    "label": "Open panel left",
    "path": "32/open-panel--left.svg"
  },
  {
    "name": "open-panel--right",
    "label": "Open panel right",
    "path": "32/open-panel--right.svg"
  },
  {
    "name": "open-panel--top",
    "label": "Open panel top",
    "path": "32/open-panel--top.svg"
  },
  {
    "name": "operation",
    "label": "Operation",
    "path": "32/Q/operation.svg"
  },
  {
    "name": "operation--gauge",
    "label": "Operation gauge",
    "path": "32/Q/operation--gauge.svg"
  },
  {
    "name": "operation--if",
    "label": "Operation if",
    "path": "32/Q/operation--if.svg"
  },
  {
    "name": "operations--field",
    "label": "Operations field",
    "path": "32/operations--field.svg"
  },
  {
    "name": "operations--record",
    "label": "Operations record",
    "path": "32/operations--record.svg"
  },
  {
    "name": "order-details",
    "label": "Order details",
    "path": "32/order-details.svg"
  },
  {
    "name": "ordinal",
    "label": "Ordinal",
    "path": "32/ordinal.svg"
  },
  {
    "name": "outage",
    "label": "Outage",
    "path": "32/outage.svg"
  },
  {
    "name": "outlook-severe",
    "label": "Outlook severe",
    "path": "32/outlook-severe.svg"
  },
  {
    "name": "overflow-menu--horizontal",
    "label": "Overflow menu horizontal",
    "path": "32/overflow-menu--horizontal.svg"
  },
  {
    "name": "overflow-menu--vertical",
    "label": "Overflow menu vertical",
    "path": "32/overflow-menu--vertical.svg"
  },
  {
    "name": "overlay",
    "label": "Overlay",
    "path": "32/overlay.svg"
  },
  {
    "name": "package",
    "label": "Package",
    "path": "32/package.svg"
  },
  {
    "name": "package--text-analysis",
    "label": "Package text analysis",
    "path": "32/package--text-analysis.svg"
  },
  {
    "name": "page--first",
    "label": "Page first",
    "path": "32/page--first.svg"
  },
  {
    "name": "page--last",
    "label": "Page last",
    "path": "32/page--last.svg"
  },
  {
    "name": "page-break",
    "label": "Page break",
    "path": "32/page-break.svg"
  },
  {
    "name": "page-number",
    "label": "Page number",
    "path": "32/page-number.svg"
  },
  {
    "name": "page-scroll",
    "label": "Page scroll",
    "path": "32/watson-health/page-scroll.svg"
  },
  {
    "name": "paint-brush",
    "label": "Paint brush",
    "path": "32/paint-brush.svg"
  },
  {
    "name": "paint-brush--alt",
    "label": "Paint brush alt",
    "path": "32/paint-brush--alt.svg"
  },
  {
    "name": "palm-tree",
    "label": "Palm tree",
    "path": "32/palm-tree.svg"
  },
  {
    "name": "pan--horizontal",
    "label": "Pan horizontal",
    "path": "32/pan--horizontal.svg"
  },
  {
    "name": "pan--vertical",
    "label": "Pan vertical",
    "path": "32/pan--vertical.svg"
  },
  {
    "name": "panel-expansion",
    "label": "Panel expansion",
    "path": "32/panel-expansion.svg"
  },
  {
    "name": "paragraph",
    "label": "Paragraph",
    "path": "32/paragraph.svg"
  },
  {
    "name": "parameter",
    "label": "Parameter",
    "path": "32/parameter.svg"
  },
  {
    "name": "parent-child",
    "label": "Parent child",
    "path": "32/parent-child.svg"
  },
  {
    "name": "partition--auto",
    "label": "Partition auto",
    "path": "32/partition--auto.svg"
  },
  {
    "name": "partition--collection",
    "label": "Partition collection",
    "path": "32/partition--collection.svg"
  },
  {
    "name": "partition--repartition",
    "label": "Partition repartition",
    "path": "32/partition--repartition.svg"
  },
  {
    "name": "partition--same",
    "label": "Partition same",
    "path": "32/partition--same.svg"
  },
  {
    "name": "partition--specific",
    "label": "Partition specific",
    "path": "32/partition--specific.svg"
  },
  {
    "name": "partly-cloudy",
    "label": "Partly cloudy",
    "path": "32/partly-cloudy.svg"
  },
  {
    "name": "partly-cloudy--night",
    "label": "Partly cloudy night",
    "path": "32/partly-cloudy--night.svg"
  },
  {
    "name": "partnership",
    "label": "Partnership",
    "path": "32/partnership.svg"
  },
  {
    "name": "passenger--drinks",
    "label": "Passenger drinks",
    "path": "32/passenger--drinks.svg"
  },
  {
    "name": "passenger--plus",
    "label": "Passenger plus",
    "path": "32/passenger--plus.svg"
  },
  {
    "name": "password",
    "label": "Password",
    "path": "32/password.svg"
  },
  {
    "name": "paste",
    "label": "Paste",
    "path": "32/paste.svg"
  },
  {
    "name": "pause",
    "label": "Pause",
    "path": "32/pause.svg"
  },
  {
    "name": "pause--filled",
    "label": "Pause filled",
    "path": "32/pause--filled.svg"
  },
  {
    "name": "pause--outline",
    "label": "Pause outline",
    "path": "32/pause--outline.svg"
  },
  {
    "name": "pause--outline--filled",
    "label": "Pause outline filled",
    "path": "32/pause--outline--filled.svg"
  },
  {
    "name": "pause-future",
    "label": "Pause future",
    "path": "32/pause-future.svg"
  },
  {
    "name": "pause-past",
    "label": "Pause past",
    "path": "32/pause-past.svg"
  },
  {
    "name": "pcn--e-node",
    "label": "PCN E-Node",
    "path": "32/pcn--e-node.svg"
  },
  {
    "name": "pcn--military",
    "label": "PCN military",
    "path": "32/pcn--military.svg"
  },
  {
    "name": "pcn--p-node",
    "label": "PCN P node",
    "path": "32/pcn--p-node.svg"
  },
  {
    "name": "pcn--z-node",
    "label": "PCN Z node",
    "path": "32/pcn--z-node.svg"
  },
  {
    "name": "PDF",
    "label": "PDF",
    "path": "32/PDF.svg"
  },
  {
    "name": "PDF--reference",
    "label": "PDF reference",
    "path": "32/PDF--reference.svg"
  },
  {
    "name": "pedestrian",
    "label": "Pedestrian",
    "path": "32/pedestrian.svg"
  },
  {
    "name": "pedestrian--family",
    "label": "Pedestrian family",
    "path": "32/pedestrian--family.svg"
  },
  {
    "name": "pedestrian-child",
    "label": "Pedestrian child",
    "path": "32/pedestrian-child.svg"
  },
  {
    "name": "pen",
    "label": "Pen",
    "path": "32/pen.svg"
  },
  {
    "name": "pen--fountain",
    "label": "Pen fountain",
    "path": "32/pen--fountain.svg"
  },
  {
    "name": "pending",
    "label": "Pending",
    "path": "32/pending.svg"
  },
  {
    "name": "pending--filled",
    "label": "Pending filled",
    "path": "32/pending--filled.svg"
  },
  {
    "name": "pentagon--down--outline",
    "label": "Pentagon down outline",
    "path": "32/pentagon--down--outline.svg"
  },
  {
    "name": "pentagon--down--solid",
    "label": "Pentagon down solid",
    "path": "32/pentagon--down--solid.svg"
  },
  {
    "name": "pentagon--left--outline",
    "label": "Pentagon left outline",
    "path": "32/pentagon--left--outline.svg"
  },
  {
    "name": "pentagon--left--solid",
    "label": "Pentagon left solid",
    "path": "32/pentagon--left--solid.svg"
  },
  {
    "name": "pentagon--outline",
    "label": "Pentagon outline",
    "path": "32/pentagon--outline.svg"
  },
  {
    "name": "pentagon--right--outline",
    "label": "Pentagon right outline",
    "path": "32/pentagon--right--outline.svg"
  },
  {
    "name": "pentagon--right--solid",
    "label": "Pentagon right solid",
    "path": "32/pentagon--right--solid.svg"
  },
  {
    "name": "pentagon--solid",
    "label": "Pentagon solid",
    "path": "32/pentagon--solid.svg"
  },
  {
    "name": "percentage",
    "label": "Percentage",
    "path": "32/percentage.svg"
  },
  {
    "name": "percentage--filled",
    "label": "Percentage filled",
    "path": "32/percentage--filled.svg"
  },
  {
    "name": "person",
    "label": "Person",
    "path": "32/person.svg"
  },
  {
    "name": "person--favorite",
    "label": "Person favorite",
    "path": "32/person--favorite.svg"
  },
  {
    "name": "pest",
    "label": "Pest",
    "path": "32/pest.svg"
  },
  {
    "name": "pet-image--B",
    "label": "PET image B",
    "path": "32/watson-health/pet-image--B.svg"
  },
  {
    "name": "pet-image--O",
    "label": "PET image O",
    "path": "32/watson-health/pet-image--O.svg"
  },
  {
    "name": "phone",
    "label": "Phone",
    "path": "32/phone.svg"
  },
  {
    "name": "phone--application",
    "label": "Phone application",
    "path": "32/phone--application.svg"
  },
  {
    "name": "phone--block",
    "label": "Phone block",
    "path": "32/phone--block.svg"
  },
  {
    "name": "phone--block--filled",
    "label": "Phone block filled",
    "path": "32/phone--block--filled.svg"
  },
  {
    "name": "phone--filled",
    "label": "Phone filled",
    "path": "32/phone--filled.svg"
  },
  {
    "name": "phone--incoming",
    "label": "Phone incoming",
    "path": "32/phone--incoming.svg"
  },
  {
    "name": "phone--incoming--filled",
    "label": "Phone incoming filled",
    "path": "32/phone--incoming--filled.svg"
  },
  {
    "name": "phone--ip",
    "label": "Phone IP",
    "path": "32/phone--ip.svg"
  },
  {
    "name": "phone--off",
    "label": "Phone off",
    "path": "32/phone--off.svg"
  },
  {
    "name": "phone--off--filled",
    "label": "Phone off filled",
    "path": "32/phone--off--filled.svg"
  },
  {
    "name": "phone--outgoing",
    "label": "Phone outgoing",
    "path": "32/phone--outgoing.svg"
  },
  {
    "name": "phone--outgoing--filled",
    "label": "Phone outgoing filled",
    "path": "32/phone--outgoing--filled.svg"
  },
  {
    "name": "phone--settings",
    "label": "Phone settings",
    "path": "32/phone--settings.svg"
  },
  {
    "name": "phone--voice",
    "label": "Phone voice",
    "path": "32/phone--voice.svg"
  },
  {
    "name": "phone--voice--filled",
    "label": "Phone voice filled",
    "path": "32/phone--voice--filled.svg"
  },
  {
    "name": "phrase-sentiment",
    "label": "Phrase sentiment",
    "path": "32/phrase-sentiment.svg"
  },
  {
    "name": "picnic-area",
    "label": "Picnic area",
    "path": "32/picnic-area.svg"
  },
  {
    "name": "piggy-bank",
    "label": "Piggy bank",
    "path": "32/piggy-bank.svg"
  },
  {
    "name": "piggy-bank--slot",
    "label": "Piggy bank slot",
    "path": "32/piggy-bank--slot.svg"
  },
  {
    "name": "pills",
    "label": "Pills",
    "path": "32/pills.svg"
  },
  {
    "name": "pills--add",
    "label": "Pills add",
    "path": "32/pills--add.svg"
  },
  {
    "name": "pills--subtract",
    "label": "Pills subtract",
    "path": "32/pills--subtract.svg"
  },
  {
    "name": "pin",
    "label": "Pin",
    "path": "32/pin.svg"
  },
  {
    "name": "pin--filled",
    "label": "Pin filled",
    "path": "32/pin--filled.svg"
  },
  {
    "name": "plan",
    "label": "Plan",
    "path": "32/plan.svg"
  },
  {
    "name": "plane",
    "label": "Plane",
    "path": "32/plane.svg"
  },
  {
    "name": "plane--private",
    "label": "Plane private",
    "path": "32/plane--private.svg"
  },
  {
    "name": "plane--sea",
    "label": "Plane sea",
    "path": "32/plane--sea.svg"
  },
  {
    "name": "platforms",
    "label": "Platforms",
    "path": "32/platforms.svg"
  },
  {
    "name": "play",
    "label": "Play",
    "path": "32/play.svg"
  },
  {
    "name": "play--filled",
    "label": "Play filled",
    "path": "32/play--filled.svg"
  },
  {
    "name": "play--filled--alt",
    "label": "Play filled alt",
    "path": "32/play--filled--alt.svg"
  },
  {
    "name": "play--outline",
    "label": "Play outline",
    "path": "32/play--outline.svg"
  },
  {
    "name": "play--outline--filled",
    "label": "Play outline filled",
    "path": "32/play--outline--filled.svg"
  },
  {
    "name": "playlist",
    "label": "Playlist",
    "path": "32/playlist.svg"
  },
  {
    "name": "plug",
    "label": "Plug",
    "path": "32/plug.svg"
  },
  {
    "name": "plug--filled",
    "label": "Plug filled",
    "path": "32/plug--filled.svg"
  },
  {
    "name": "PNG",
    "label": "PNG",
    "path": "32/PNG.svg"
  },
  {
    "name": "point-of-presence",
    "label": "Point of presence",
    "path": "32/point-of-presence.svg"
  },
  {
    "name": "pointer-text",
    "label": "Pointer text",
    "path": "32/watson-health/pointer-text.svg"
  },
  {
    "name": "police",
    "label": "Police",
    "path": "32/police.svg"
  },
  {
    "name": "policy",
    "label": "Policy",
    "path": "32/policy.svg"
  },
  {
    "name": "popup",
    "label": "Pop-up",
    "path": "32/popup.svg"
  },
  {
    "name": "port--input",
    "label": "Port input",
    "path": "32/port--input.svg"
  },
  {
    "name": "port--output",
    "label": "Port output",
    "path": "32/port--output.svg"
  },
  {
    "name": "portfolio",
    "label": "Portfolio",
    "path": "32/portfolio.svg"
  },
  {
    "name": "power",
    "label": "Power",
    "path": "32/power.svg"
  },
  {
    "name": "PPT",
    "label": "PPT",
    "path": "32/PPT.svg"
  },
  {
    "name": "presentation-file",
    "label": "Presentation file",
    "path": "32/presentation-file.svg"
  },
  {
    "name": "pressure",
    "label": "Pressure",
    "path": "32/pressure.svg"
  },
  {
    "name": "pressure--filled",
    "label": "Pressure filled",
    "path": "32/pressure--filled.svg"
  },
  {
    "name": "previous--filled",
    "label": "Previous filled",
    "path": "32/previous--filled.svg"
  },
  {
    "name": "previous--outline",
    "label": "Previous outline",
    "path": "32/previous--outline.svg"
  },
  {
    "name": "printer",
    "label": "Printer",
    "path": "32/printer.svg"
  },
  {
    "name": "process",
    "label": "Process",
    "path": "32/process.svg"
  },
  {
    "name": "process-automate",
    "label": "Process automate",
    "path": "32/process-automate.svg"
  },
  {
    "name": "product",
    "label": "Product",
    "path": "32/product.svg"
  },
  {
    "name": "progress-bar",
    "label": "Progress bar",
    "path": "32/progress-bar.svg"
  },
  {
    "name": "progress-bar--round",
    "label": "Progress bar round",
    "path": "32/progress-bar--round.svg"
  },
  {
    "name": "promote",
    "label": "Promote",
    "path": "32/promote.svg"
  },
  {
    "name": "prompt-session",
    "label": "Prompt session",
    "path": "32/prompt-session.svg"
  },
  {
    "name": "prompt-template",
    "label": "Prompt template",
    "path": "32/prompt-template.svg"
  },
  {
    "name": "property-relationship",
    "label": "Property relationship",
    "path": "32/property-relationship.svg"
  },
  {
    "name": "purchase",
    "label": "Purchase",
    "path": "32/purchase.svg"
  },
  {
    "name": "QC-launch",
    "label": "QC launch",
    "path": "32/watson-health/QC-launch.svg"
  },
  {
    "name": "qq-plot",
    "label": "QQ plot",
    "path": "32/qq-plot.svg"
  },
  {
    "name": "qr-code",
    "label": "QR code",
    "path": "32/qr-code.svg"
  },
  {
    "name": "quadrant-plot",
    "label": "Quadrant plot",
    "path": "32/quadrant-plot.svg"
  },
  {
    "name": "query",
    "label": "Query",
    "path": "32/query.svg"
  },
  {
    "name": "query-queue",
    "label": "Query queue",
    "path": "32/query-queue.svg"
  },
  {
    "name": "queued",
    "label": "Queued",
    "path": "32/queued.svg"
  },
  {
    "name": "quotes",
    "label": "Quotes",
    "path": "32/quotes.svg"
  },
  {
    "name": "radar",
    "label": "Radar",
    "path": "32/radar.svg"
  },
  {
    "name": "radar--enhanced",
    "label": "Radar enhanced",
    "path": "32/radar--enhanced.svg"
  },
  {
    "name": "radar--weather",
    "label": "Radar weather",
    "path": "32/radar--weather.svg"
  },
  {
    "name": "radio",
    "label": "Radio",
    "path": "32/radio.svg"
  },
  {
    "name": "radio--combat",
    "label": "Radio combat",
    "path": "32/radio--combat.svg"
  },
  {
    "name": "radio--push-to-talk",
    "label": "Radio push-to-talk",
    "path": "32/radio--push-to-talk.svg"
  },
  {
    "name": "radio-button",
    "label": "Radio button",
    "path": "32/radio-button.svg"
  },
  {
    "name": "radio-button--checked",
    "label": "Radio button checked",
    "path": "32/radio-button--checked.svg"
  },
  {
    "name": "rain",
    "label": "Rain",
    "path": "32/rain.svg"
  },
  {
    "name": "rain--drizzle",
    "label": "Rain drizzle",
    "path": "32/rain--drizzle.svg"
  },
  {
    "name": "rain--heavy",
    "label": "Rain heavy",
    "path": "32/rain--heavy.svg"
  },
  {
    "name": "rain--scattered",
    "label": "Rain scattered",
    "path": "32/rain--scattered.svg"
  },
  {
    "name": "rain--scattered--night",
    "label": "Rain scattered night",
    "path": "32/rain--scattered--night.svg"
  },
  {
    "name": "rain-drop",
    "label": "Rain drop",
    "path": "32/rain-drop.svg"
  },
  {
    "name": "RAW",
    "label": "RAW",
    "path": "32/RAW.svg"
  },
  {
    "name": "receipt",
    "label": "Receipt",
    "path": "32/receipt.svg"
  },
  {
    "name": "recently-viewed",
    "label": "Recently viewed",
    "path": "32/recently-viewed.svg"
  },
  {
    "name": "recommend",
    "label": "Recommend",
    "path": "32/recommend.svg"
  },
  {
    "name": "recording",
    "label": "Recording",
    "path": "32/recording.svg"
  },
  {
    "name": "recording--filled",
    "label": "Recording filled",
    "path": "32/recording--filled.svg"
  },
  {
    "name": "recording--filled--alt",
    "label": "Recording filled alt",
    "path": "32/recording--filled--alt.svg"
  },
  {
    "name": "recycle",
    "label": "Recycle",
    "path": "32/recycle.svg"
  },
  {
    "name": "redo",
    "label": "Redo",
    "path": "32/redo.svg"
  },
  {
    "name": "ref-evapotranspiration",
    "label": "Ref evapotranspiration",
    "path": "32/ref-evapotranspiration.svg"
  },
  {
    "name": "reference-architecture",
    "label": "Reference architecture",
    "path": "32/reference-architecture.svg"
  },
  {
    "name": "reflect--horizontal",
    "label": "Reflect horizontal",
    "path": "32/reflect--horizontal.svg"
  },
  {
    "name": "reflect--vertical",
    "label": "Reflect vertical",
    "path": "32/reflect--vertical.svg"
  },
  {
    "name": "region-analysis--area",
    "label": "Region analysis area",
    "path": "32/watson-health/region-analysis--area.svg"
  },
  {
    "name": "region-analysis--volume",
    "label": "Region analysis volume",
    "path": "32/watson-health/region-analysis--volume.svg"
  },
  {
    "name": "registration",
    "label": "Registration",
    "path": "32/watson-health/registration.svg"
  },
  {
    "name": "reminder",
    "label": "Reminder",
    "path": "32/reminder.svg"
  },
  {
    "name": "reminder--medical",
    "label": "Reminder medical",
    "path": "32/reminder--medical.svg"
  },
  {
    "name": "renew",
    "label": "Renew",
    "path": "32/renew.svg"
  },
  {
    "name": "repeat",
    "label": "Repeat",
    "path": "32/repeat.svg"
  },
  {
    "name": "repeat--one",
    "label": "Repeat one",
    "path": "32/repeat--one.svg"
  },
  {
    "name": "replicate",
    "label": "Replicate",
    "path": "32/replicate.svg"
  },
  {
    "name": "reply",
    "label": "Reply",
    "path": "32/reply.svg"
  },
  {
    "name": "reply--all",
    "label": "Reply all",
    "path": "32/reply--all.svg"
  },
  {
    "name": "repo--artifact",
    "label": "Repo artifact",
    "path": "32/repo--artifact.svg"
  },
  {
    "name": "repo--source-code",
    "label": "Repo source code",
    "path": "32/repo--source-code.svg"
  },
  {
    "name": "report",
    "label": "Report",
    "path": "32/report.svg"
  },
  {
    "name": "report--data",
    "label": "Report data",
    "path": "32/report--data.svg"
  },
  {
    "name": "request-quote",
    "label": "Request quote",
    "path": "32/request-quote.svg"
  },
  {
    "name": "reset",
    "label": "Reset",
    "path": "32/reset.svg"
  },
  {
    "name": "reset--alt",
    "label": "Reset alt",
    "path": "32/reset--alt.svg"
  },
  {
    "name": "restart",
    "label": "Restart",
    "path": "32/restart.svg"
  },
  {
    "name": "restaurant",
    "label": "Restaurant",
    "path": "32/restaurant.svg"
  },
  {
    "name": "restaurant--fine",
    "label": "Restaurant fine",
    "path": "32/restaurant--fine.svg"
  },
  {
    "name": "result",
    "label": "Result",
    "path": "32/result.svg"
  },
  {
    "name": "result--draft",
    "label": "Result draft",
    "path": "32/result--draft.svg"
  },
  {
    "name": "result--new",
    "label": "Result new",
    "path": "32/result--new.svg"
  },
  {
    "name": "result--old",
    "label": "Result old",
    "path": "32/result--old.svg"
  },
  {
    "name": "retry--failed",
    "label": "Retry failed",
    "path": "32/retry--failed.svg"
  },
  {
    "name": "return",
    "label": "Return",
    "path": "32/return.svg"
  },
  {
    "name": "review",
    "label": "Review",
    "path": "32/review.svg"
  },
  {
    "name": "rewind--10",
    "label": "Rewind 10",
    "path": "32/rewind--10.svg"
  },
  {
    "name": "rewind--30",
    "label": "Rewind 30",
    "path": "32/rewind--30.svg"
  },
  {
    "name": "rewind--5",
    "label": "Rewind 5",
    "path": "32/rewind--5.svg"
  },
  {
    "name": "right-panel--close",
    "label": "Right panel close",
    "path": "32/right-panel--close.svg"
  },
  {
    "name": "right-panel--close--filled",
    "label": "Right panel close filled",
    "path": "32/right-panel--close--filled.svg"
  },
  {
    "name": "right-panel--open",
    "label": "Right panel open",
    "path": "32/right-panel--open.svg"
  },
  {
    "name": "right-panel--open--filled",
    "label": "Right panel open filled",
    "path": "32/right-panel--open--filled.svg"
  },
  {
    "name": "road",
    "label": "Road",
    "path": "32/road.svg"
  },
  {
    "name": "road--weather",
    "label": "Road weather",
    "path": "32/road--weather.svg"
  },
  {
    "name": "roadmap",
    "label": "Roadmap",
    "path": "32/roadmap.svg"
  },
  {
    "name": "rocket",
    "label": "Rocket",
    "path": "32/rocket.svg"
  },
  {
    "name": "rotate",
    "label": "Rotate",
    "path": "32/rotate.svg"
  },
  {
    "name": "rotate--180",
    "label": "Rotate 180",
    "path": "32/watson-health/rotate--180.svg"
  },
  {
    "name": "rotate--360",
    "label": "Rotate 360",
    "path": "32/watson-health/rotate--360.svg"
  },
  {
    "name": "rotate--clockwise",
    "label": "Rotate clockwise",
    "path": "32/rotate--clockwise.svg"
  },
  {
    "name": "rotate--clockwise--alt",
    "label": "Rotate clockwise alt",
    "path": "32/rotate--clockwise--alt.svg"
  },
  {
    "name": "rotate--clockwise--alt--filled",
    "label": "Rotate clockwise alt filled",
    "path": "32/rotate--clockwise--alt--filled.svg"
  },
  {
    "name": "rotate--clockwise--filled",
    "label": "Rotate clockwise filled",
    "path": "32/rotate--clockwise--filled.svg"
  },
  {
    "name": "rotate--counterclockwise",
    "label": "Rotate counterclockwise",
    "path": "32/rotate--counterclockwise.svg"
  },
  {
    "name": "rotate--counterclockwise--alt",
    "label": "Rotate counterclockwise alt",
    "path": "32/rotate--counterclockwise--alt.svg"
  },
  {
    "name": "rotate--counterclockwise--alt--filled",
    "label": "Rotate counterclockwise alt filled",
    "path": "32/rotate--counterclockwise--alt--filled.svg"
  },
  {
    "name": "rotate--counterclockwise--filled",
    "label": "Rotate counterclockwise filled",
    "path": "32/rotate--counterclockwise--filled.svg"
  },
  {
    "name": "router",
    "label": "Router",
    "path": "32/router.svg"
  },
  {
    "name": "router--voice",
    "label": "Router voice",
    "path": "32/router--voice.svg"
  },
  {
    "name": "router--wifi",
    "label": "Router WiFi",
    "path": "32/router--wifi.svg"
  },
  {
    "name": "row",
    "label": "Row",
    "path": "32/row.svg"
  },
  {
    "name": "row--collapse",
    "label": "Row collapse",
    "path": "32/row--collapse.svg"
  },
  {
    "name": "row--delete",
    "label": "Row delete",
    "path": "32/row--delete.svg"
  },
  {
    "name": "row--expand",
    "label": "Row expand",
    "path": "32/row--expand.svg"
  },
  {
    "name": "row--insert",
    "label": "Row insert",
    "path": "32/row--insert.svg"
  },
  {
    "name": "rss",
    "label": "RSS",
    "path": "32/rss.svg"
  },
  {
    "name": "rule",
    "label": "Rule",
    "path": "32/rule.svg"
  },
  {
    "name": "rule--cancelled",
    "label": "Rule cancelled",
    "path": "32/rule--cancelled.svg"
  },
  {
    "name": "rule--data-quality",
    "label": "Rule data quality",
    "path": "32/rule--data-quality.svg"
  },
  {
    "name": "rule--draft",
    "label": "Rule draft",
    "path": "32/rule--draft.svg"
  },
  {
    "name": "rule--filled",
    "label": "Rule filled",
    "path": "32/rule--filled.svg"
  },
  {
    "name": "rule--locked",
    "label": "Rule locked",
    "path": "32/rule--locked.svg"
  },
  {
    "name": "rule--partial",
    "label": "Rule partial",
    "path": "32/rule--partial.svg"
  },
  {
    "name": "rule--test",
    "label": "Rule test",
    "path": "32/rule--test.svg"
  },
  {
    "name": "ruler",
    "label": "Ruler",
    "path": "32/ruler.svg"
  },
  {
    "name": "ruler--alt",
    "label": "Ruler alt",
    "path": "32/ruler--alt.svg"
  },
  {
    "name": "run",
    "label": "Run",
    "path": "32/run.svg"
  },
  {
    "name": "run--mirror",
    "label": "Run mirror",
    "path": "32/run--mirror.svg"
  },
  {
    "name": "running",
    "label": "Running",
    "path": "32/running.svg"
  },
  {
    "name": "S",
    "label": "S",
    "path": "32/Q/S.svg"
  },
  {
    "name": "S--alt",
    "label": "S alt",
    "path": "32/Q/S--alt.svg"
  },
  {
    "name": "sailboat--coastal",
    "label": "Sailboat coastal",
    "path": "32/sailboat--coastal.svg"
  },
  {
    "name": "sailboat--offshore",
    "label": "Sailboat offshore",
    "path": "32/sailboat--offshore.svg"
  },
  {
    "name": "sales-ops",
    "label": "Sales ops",
    "path": "32/sales-ops.svg"
  },
  {
    "name": "sankey-diagram",
    "label": "Sankey diagram",
    "path": "32/sankey-diagram.svg"
  },
  {
    "name": "sankey-diagram--alt",
    "label": "Sankey diagram alt",
    "path": "32/sankey-diagram--alt.svg"
  },
  {
    "name": "satellite",
    "label": "Satellite",
    "path": "32/satellite.svg"
  },
  {
    "name": "satellite--radar",
    "label": "Satellite radar",
    "path": "32/satellite--radar.svg"
  },
  {
    "name": "satellite--weather",
    "label": "Satellite weather",
    "path": "32/satellite--weather.svg"
  },
  {
    "name": "save",
    "label": "Save",
    "path": "32/save.svg"
  },
  {
    "name": "save--annotation",
    "label": "Save annotation",
    "path": "32/watson-health/save--annotation.svg"
  },
  {
    "name": "save--image",
    "label": "Save image",
    "path": "32/watson-health/save--image.svg"
  },
  {
    "name": "save--model",
    "label": "Save model",
    "path": "32/save--model.svg"
  },
  {
    "name": "save--series",
    "label": "Save series",
    "path": "32/watson-health/save--series.svg"
  },
  {
    "name": "scale",
    "label": "Scale",
    "path": "32/scale.svg"
  },
  {
    "name": "scales",
    "label": "Scales",
    "path": "32/scales.svg"
  },
  {
    "name": "scales--tipped",
    "label": "Scales tipped",
    "path": "32/scales--tipped.svg"
  },
  {
    "name": "scalpel",
    "label": "Scalpel",
    "path": "32/scalpel.svg"
  },
  {
    "name": "scalpel--cursor",
    "label": "Scalpel cursor",
    "path": "32/watson-health/scalpel--cursor.svg"
  },
  {
    "name": "scalpel--lasso",
    "label": "Scalpel lasso",
    "path": "32/watson-health/scalpel--lasso.svg"
  },
  {
    "name": "scalpel--select",
    "label": "Scalpel select",
    "path": "32/watson-health/scalpel--select.svg"
  },
  {
    "name": "scan",
    "label": "Scan",
    "path": "32/scan.svg"
  },
  {
    "name": "scan--alt",
    "label": "Scan alt",
    "path": "32/scan--alt.svg"
  },
  {
    "name": "scan--disabled",
    "label": "Scan disabled",
    "path": "32/scan--disabled.svg"
  },
  {
    "name": "scatter-matrix",
    "label": "Scatter matrix",
    "path": "32/scatter-matrix.svg"
  },
  {
    "name": "schematics",
    "label": "Schematics",
    "path": "32/schematics.svg"
  },
  {
    "name": "scis--control-tower",
    "label": "IBM® Supply Chain Intelligence Suite Control Tower",
    "path": "32/scis--control-tower.svg"
  },
  {
    "name": "scis--transparent-supply",
    "label": "IBM® Supply Chain Intelligence Suite transparent supply",
    "path": "32/scis--transparent-supply.svg"
  },
  {
    "name": "scooter",
    "label": "Scooter",
    "path": "32/scooter.svg"
  },
  {
    "name": "scooter--front",
    "label": "Scooter front",
    "path": "32/scooter--front.svg"
  },
  {
    "name": "screen",
    "label": "Screen",
    "path": "32/screen.svg"
  },
  {
    "name": "screen--off",
    "label": "Screen off",
    "path": "32/screen--off.svg"
  },
  {
    "name": "screen-map",
    "label": "Screen map",
    "path": "32/screen-map.svg"
  },
  {
    "name": "screen-map--set",
    "label": "Screen map set",
    "path": "32/screen-map--set.svg"
  },
  {
    "name": "script",
    "label": "Script",
    "path": "32/script.svg"
  },
  {
    "name": "script--reference",
    "label": "Script reference",
    "path": "32/script--reference.svg"
  },
  {
    "name": "SDK",
    "label": "SDK",
    "path": "32/SDK.svg"
  },
  {
    "name": "search",
    "label": "Search",
    "path": "32/search.svg"
  },
  {
    "name": "search--advanced",
    "label": "Search advanced",
    "path": "32/search--advanced.svg"
  },
  {
    "name": "search--locate",
    "label": "Search locate",
    "path": "32/search--locate.svg"
  },
  {
    "name": "search--locate--mirror",
    "label": "Search locate mirror",
    "path": "32/search--locate--mirror.svg"
  },
  {
    "name": "security",
    "label": "Security",
    "path": "32/security.svg"
  },
  {
    "name": "security-services",
    "label": "Security services",
    "path": "32/security-services.svg"
  },
  {
    "name": "select--01",
    "label": "Select 01",
    "path": "32/select--01.svg"
  },
  {
    "name": "select--02",
    "label": "Select 02",
    "path": "32/select--02.svg"
  },
  {
    "name": "select--window",
    "label": "Select window",
    "path": "32/select--window.svg"
  },
  {
    "name": "send",
    "label": "Send",
    "path": "32/send.svg"
  },
  {
    "name": "send--alt",
    "label": "Send alt",
    "path": "32/send--alt.svg"
  },
  {
    "name": "send--alt--filled",
    "label": "Send alt filled",
    "path": "32/send--alt--filled.svg"
  },
  {
    "name": "send--filled",
    "label": "Send filled",
    "path": "32/send--filled.svg"
  },
  {
    "name": "send-backward",
    "label": "Send backward",
    "path": "32/send-backward.svg"
  },
  {
    "name": "send-to-back",
    "label": "Send to back",
    "path": "32/send-to-back.svg"
  },
  {
    "name": "server--dns",
    "label": "Server DNS",
    "path": "32/server--dns.svg"
  },
  {
    "name": "server--proxy",
    "label": "Server proxy",
    "path": "32/server--proxy.svg"
  },
  {
    "name": "server--time",
    "label": "Server time",
    "path": "32/server--time.svg"
  },
  {
    "name": "service-desk",
    "label": "Service desk",
    "path": "32/service-desk.svg"
  },
  {
    "name": "service-id",
    "label": "Service ID",
    "path": "32/service-id.svg"
  },
  {
    "name": "service-levels",
    "label": "Service levels",
    "path": "32/service-levels.svg"
  },
  {
    "name": "session-border-control",
    "label": "Session border control",
    "path": "32/session-border-control.svg"
  },
  {
    "name": "settings",
    "label": "Settings",
    "path": "32/settings.svg"
  },
  {
    "name": "settings--adjust",
    "label": "Settings adjust",
    "path": "32/settings--adjust.svg"
  },
  {
    "name": "settings--check",
    "label": "Settings check",
    "path": "32/settings--check.svg"
  },
  {
    "name": "settings--edit",
    "label": "Settings edit",
    "path": "32/settings--edit.svg"
  },
  {
    "name": "settings--services",
    "label": "Settings services",
    "path": "32/settings--services.svg"
  },
  {
    "name": "settings--view",
    "label": "Settings view",
    "path": "32/settings--view.svg"
  },
  {
    "name": "shape--except",
    "label": "Shape except",
    "path": "32/shape--except.svg"
  },
  {
    "name": "shape--exclude",
    "label": "Shape exclude",
    "path": "32/shape--exclude.svg"
  },
  {
    "name": "shape--intersect",
    "label": "Shape intersect",
    "path": "32/shape--intersect.svg"
  },
  {
    "name": "shape--join",
    "label": "Shape join",
    "path": "32/shape--join.svg"
  },
  {
    "name": "shape--unite",
    "label": "Shape unite",
    "path": "32/shape--unite.svg"
  },
  {
    "name": "share",
    "label": "Share",
    "path": "32/share.svg"
  },
  {
    "name": "share-knowledge",
    "label": "Share knowledge",
    "path": "32/share-knowledge.svg"
  },
  {
    "name": "shopping--bag",
    "label": "Shopping bag",
    "path": "32/shopping--bag.svg"
  },
  {
    "name": "shopping--cart",
    "label": "Shopping cart",
    "path": "32/shopping--cart.svg"
  },
  {
    "name": "shopping--cart--arrow-down",
    "label": "Shopping cart arrow down",
    "path": "32/shopping--cart--arrow-down.svg"
  },
  {
    "name": "shopping--cart--arrow-up",
    "label": "Shopping cart arrow up",
    "path": "32/shopping--cart--arrow-up.svg"
  },
  {
    "name": "shopping--cart--clear",
    "label": "Shopping cart clear",
    "path": "32/shopping--cart--clear.svg"
  },
  {
    "name": "shopping--cart--error",
    "label": "Shopping cart error",
    "path": "32/shopping--cart--error.svg"
  },
  {
    "name": "shopping--cart--minus",
    "label": "Shopping cart minus",
    "path": "32/shopping--cart--minus.svg"
  },
  {
    "name": "shopping--cart--plus",
    "label": "Shopping cart plus",
    "path": "32/shopping--cart--plus.svg"
  },
  {
    "name": "shopping--catalog",
    "label": "Shopping catalog",
    "path": "32/shopping--catalog.svg"
  },
  {
    "name": "show-data--cards",
    "label": "Show-data cards",
    "path": "32/show-data--cards.svg"
  },
  {
    "name": "shrink-screen",
    "label": "Shrink screen",
    "path": "32/shrink-screen.svg"
  },
  {
    "name": "shrink-screen--filled",
    "label": "Shrink screen filled",
    "path": "32/shrink-screen--filled.svg"
  },
  {
    "name": "shuffle",
    "label": "Shuffle",
    "path": "32/shuffle.svg"
  },
  {
    "name": "shuttle",
    "label": "Shuttle",
    "path": "32/shuttle.svg"
  },
  {
    "name": "side-panel--close",
    "label": "Side panel close",
    "path": "32/side-panel--close.svg"
  },
  {
    "name": "side-panel--close--filled",
    "label": "Side panel close filled",
    "path": "32/side-panel--close--filled.svg"
  },
  {
    "name": "side-panel--open",
    "label": "Side panel open",
    "path": "32/side-panel--open.svg"
  },
  {
    "name": "side-panel--open--filled",
    "label": "Side panel open filled",
    "path": "32/side-panel--open--filled.svg"
  },
  {
    "name": "sight",
    "label": "Sight",
    "path": "32/sight.svg"
  },
  {
    "name": "sigma",
    "label": "Sigma",
    "path": "32/sigma.svg"
  },
  {
    "name": "signal-strength",
    "label": "Signal strength",
    "path": "32/signal-strength.svg"
  },
  {
    "name": "sim-card",
    "label": "SIM card",
    "path": "32/sim-card.svg"
  },
  {
    "name": "skill-level",
    "label": "Skill level",
    "path": "32/skill-level.svg"
  },
  {
    "name": "skill-level--advanced",
    "label": "Skill level advanced",
    "path": "32/skill-level--advanced.svg"
  },
  {
    "name": "skill-level--basic",
    "label": "Skill level basic",
    "path": "32/skill-level--basic.svg"
  },
  {
    "name": "skill-level--intermediate",
    "label": "Skill level intermediate",
    "path": "32/skill-level--intermediate.svg"
  },
  {
    "name": "skip--back",
    "label": "Skip back",
    "path": "32/skip--back.svg"
  },
  {
    "name": "skip--back--filled",
    "label": "Skip back filled",
    "path": "32/skip--back--filled.svg"
  },
  {
    "name": "skip--back--outline",
    "label": "Skip back outline",
    "path": "32/skip--back--outline.svg"
  },
  {
    "name": "skip--back--outline--filled",
    "label": "Skip back outline filled",
    "path": "32/skip--back--outline--filled.svg"
  },
  {
    "name": "skip--back--outline--solid",
    "label": "Skip back outline solid",
    "path": "32/skip--back--outline--solid.svg"
  },
  {
    "name": "skip--back--solid--filled",
    "label": "Skip back solid filled",
    "path": "32/skip--back--solid--filled.svg"
  },
  {
    "name": "skip--forward",
    "label": "Skip forward",
    "path": "32/skip--forward.svg"
  },
  {
    "name": "skip--forward--filled",
    "label": "Skip forward filled",
    "path": "32/skip--forward--filled.svg"
  },
  {
    "name": "skip--forward--outline",
    "label": "Skip forward outline",
    "path": "32/skip--forward--outline.svg"
  },
  {
    "name": "skip--forward--outline--filled",
    "label": "Skip forward outline filled",
    "path": "32/skip--forward--outline--filled.svg"
  },
  {
    "name": "skip--forward--outline--solid",
    "label": "Skip forward outline solid",
    "path": "32/skip--forward--outline--solid.svg"
  },
  {
    "name": "skip--forward--solid--filled",
    "label": "Skip forward solid filled",
    "path": "32/skip--forward--solid--filled.svg"
  },
  {
    "name": "sleet",
    "label": "Sleet",
    "path": "32/sleet.svg"
  },
  {
    "name": "slisor",
    "label": "slicestor",
    "path": "32/slisor.svg"
  },
  {
    "name": "SLM",
    "label": "SLM",
    "path": "32/SLM.svg"
  },
  {
    "name": "smell",
    "label": "Smell",
    "path": "32/smell.svg"
  },
  {
    "name": "smoke",
    "label": "Smoke",
    "path": "32/smoke.svg"
  },
  {
    "name": "smoothing",
    "label": "Smoothing",
    "path": "32/watson-health/smoothing.svg"
  },
  {
    "name": "smoothing--cursor",
    "label": "Smoothing cursor",
    "path": "32/watson-health/smoothing--cursor.svg"
  },
  {
    "name": "snooze",
    "label": "Snooze",
    "path": "32/snooze.svg"
  },
  {
    "name": "snow",
    "label": "Snow",
    "path": "32/snow.svg"
  },
  {
    "name": "snow--blizzard",
    "label": "Snow blizzard",
    "path": "32/snow--blizzard.svg"
  },
  {
    "name": "snow--heavy",
    "label": "Snow heavy",
    "path": "32/snow--heavy.svg"
  },
  {
    "name": "snow--scattered",
    "label": "Snow scattered",
    "path": "32/snow--scattered.svg"
  },
  {
    "name": "snow--scattered--night",
    "label": "Snow scattered night",
    "path": "32/snow--scattered--night.svg"
  },
  {
    "name": "snow-density",
    "label": "Snow density",
    "path": "32/snow-density.svg"
  },
  {
    "name": "snowflake",
    "label": "Snowflake",
    "path": "32/snowflake.svg"
  },
  {
    "name": "soccer",
    "label": "Soccer",
    "path": "32/soccer.svg"
  },
  {
    "name": "software-resource",
    "label": "Software resource",
    "path": "32/software-resource.svg"
  },
  {
    "name": "software-resource--cluster",
    "label": "Software resource cluster",
    "path": "32/software-resource--cluster.svg"
  },
  {
    "name": "software-resource--resource",
    "label": "Software resource reference",
    "path": "32/software-resource--resource.svg"
  },
  {
    "name": "soil-moisture",
    "label": "Soil moisture",
    "path": "32/soil-moisture.svg"
  },
  {
    "name": "soil-moisture--field",
    "label": "Soil moisture field",
    "path": "32/soil-moisture--field.svg"
  },
  {
    "name": "soil-moisture--global",
    "label": "Soil moisture global",
    "path": "32/soil-moisture--global.svg"
  },
  {
    "name": "soil-temperature",
    "label": "Soil temperature",
    "path": "32/soil-temperature.svg"
  },
  {
    "name": "soil-temperature--field",
    "label": "Soil temperature field",
    "path": "32/soil-temperature--field.svg"
  },
  {
    "name": "soil-temperature--global",
    "label": "Soil temperature global",
    "path": "32/soil-temperature--global.svg"
  },
  {
    "name": "solar-panel",
    "label": "Solar panel",
    "path": "32/solar-panel.svg"
  },
  {
    "name": "sort--ascending",
    "label": "Sort ascending",
    "path": "32/sort--ascending.svg"
  },
  {
    "name": "sort--descending",
    "label": "Sort descending",
    "path": "32/sort--descending.svg"
  },
  {
    "name": "sort--remove",
    "label": "Sort remove",
    "path": "32/sort--remove.svg"
  },
  {
    "name": "spell-check",
    "label": "Spell check",
    "path": "32/spell-check.svg"
  },
  {
    "name": "spine-label",
    "label": "Spine label",
    "path": "32/watson-health/spine-label.svg"
  },
  {
    "name": "split",
    "label": "Split",
    "path": "32/split.svg"
  },
  {
    "name": "split--discard",
    "label": "Split discard",
    "path": "32/watson-health/split--discard.svg"
  },
  {
    "name": "split-screen",
    "label": "Split screen",
    "path": "32/split-screen.svg"
  },
  {
    "name": "spray-paint",
    "label": "Spray paint",
    "path": "32/spray-paint.svg"
  },
  {
    "name": "sprout",
    "label": "Sprout",
    "path": "32/sprout.svg"
  },
  {
    "name": "SQL",
    "label": "SQL",
    "path": "32/SQL.svg"
  },
  {
    "name": "square--outline",
    "label": "Square outline",
    "path": "32/square--outline.svg"
  },
  {
    "name": "square--solid",
    "label": "Square solid",
    "path": "32/square--solid.svg"
  },
  {
    "name": "square-fill",
    "label": "Square fill",
    "path": "square-fill.svg"
  },
  {
    "name": "stack-limitation",
    "label": "Stack limitation",
    "path": "32/stack-limitation.svg"
  },
  {
    "name": "stacked-move",
    "label": "Stacked move",
    "path": "32/watson-health/stacked-move.svg"
  },
  {
    "name": "stacked-scrolling--1",
    "label": "Stacked scrolling 1",
    "path": "32/watson-health/stacked-scrolling--1.svg"
  },
  {
    "name": "stacked-scrolling--2",
    "label": "Stacked scrolling 2",
    "path": "32/watson-health/stacked-scrolling--2.svg"
  },
  {
    "name": "stamp",
    "label": "Stamp",
    "path": "32/stamp.svg"
  },
  {
    "name": "star",
    "label": "Star",
    "path": "32/star.svg"
  },
  {
    "name": "star--filled",
    "label": "Star filled",
    "path": "32/star--filled.svg"
  },
  {
    "name": "star--half",
    "label": "Star half",
    "path": "32/star--half.svg"
  },
  {
    "name": "star--review",
    "label": "Star review",
    "path": "32/star--review.svg"
  },
  {
    "name": "status--acknowledge",
    "label": "Status acknowledge",
    "path": "32/watson-health/status--acknowledge.svg"
  },
  {
    "name": "status--change",
    "label": "Status change",
    "path": "32/watson-health/status--change.svg"
  },
  {
    "name": "status--partial-fail",
    "label": "Status partial fail",
    "path": "32/watson-health/status--partial-fail.svg"
  },
  {
    "name": "status--resolved",
    "label": "Status resolved",
    "path": "32/watson-health/status--resolved.svg"
  },
  {
    "name": "stay-inside",
    "label": "Stay inside",
    "path": "32/stay-inside.svg"
  },
  {
    "name": "stem-leaf-plot",
    "label": "Stem leaf plot",
    "path": "32/stem-leaf-plot.svg"
  },
  {
    "name": "stethoscope",
    "label": "Stethoscope",
    "path": "32/stethoscope.svg"
  },
  {
    "name": "stop",
    "label": "Stop",
    "path": "32/stop.svg"
  },
  {
    "name": "stop--filled",
    "label": "Stop filled",
    "path": "32/stop--filled.svg"
  },
  {
    "name": "stop--filled--alt",
    "label": "Stop filled alt",
    "path": "32/stop--filled--alt.svg"
  },
  {
    "name": "stop--outline",
    "label": "Stop outline",
    "path": "32/stop--outline.svg"
  },
  {
    "name": "stop--outline--filled",
    "label": "Stop outline filled",
    "path": "32/stop--outline--filled.svg"
  },
  {
    "name": "stop-sign",
    "label": "Stop sign",
    "path": "32/stop-sign.svg"
  },
  {
    "name": "stop-sign--filled",
    "label": "Stop sign filled",
    "path": "32/stop-sign--filled.svg"
  },
  {
    "name": "storage-pool",
    "label": "Storage pool",
    "path": "32/storage-pool.svg"
  },
  {
    "name": "storage-request",
    "label": "Storage request",
    "path": "32/storage-request.svg"
  },
  {
    "name": "store",
    "label": "Store",
    "path": "32/store.svg"
  },
  {
    "name": "storm-tracker",
    "label": "Storm tracker",
    "path": "32/storm-tracker.svg"
  },
  {
    "name": "strawberry",
    "label": "Strawberry",
    "path": "32/strawberry.svg"
  },
  {
    "name": "stress-breath-editor",
    "label": "Stress breath editor",
    "path": "32/watson-health/stress-breath-editor.svg"
  },
  {
    "name": "string-integer",
    "label": "String integer",
    "path": "32/string-integer.svg"
  },
  {
    "name": "string-text",
    "label": "String text",
    "path": "32/string-text.svg"
  },
  {
    "name": "study--next",
    "label": "Study next",
    "path": "32/watson-health/study--next.svg"
  },
  {
    "name": "study--previous",
    "label": "Study previous",
    "path": "32/watson-health/study--previous.svg"
  },
  {
    "name": "study--read",
    "label": "Study read",
    "path": "32/watson-health/study--read.svg"
  },
  {
    "name": "study--skip",
    "label": "Study skip",
    "path": "32/watson-health/study--skip.svg"
  },
  {
    "name": "study--transfer",
    "label": "Study transfer",
    "path": "32/watson-health/study--transfer.svg"
  },
  {
    "name": "study--unread",
    "label": "Study unread",
    "path": "32/watson-health/study--unread.svg"
  },
  {
    "name": "study--view",
    "label": "Study view",
    "path": "32/watson-health/study--view.svg"
  },
  {
    "name": "sub-volume",
    "label": "Sub volume",
    "path": "32/watson-health/sub-volume.svg"
  },
  {
    "name": "subdirectory",
    "label": "Subdirectory",
    "path": "32/subdirectory.svg"
  },
  {
    "name": "subflow",
    "label": "Subflow",
    "path": "32/subflow.svg"
  },
  {
    "name": "subflow--local",
    "label": "Subflow local",
    "path": "32/subflow--local.svg"
  },
  {
    "name": "subnet-acl-rules",
    "label": "Subnet ACL rules",
    "path": "32/subnet-acl-rules.svg"
  },
  {
    "name": "subtract",
    "label": "Subtract",
    "path": "32/subtract.svg"
  },
  {
    "name": "subtract--alt",
    "label": "Subtract alt",
    "path": "32/subtract--alt.svg"
  },
  {
    "name": "subtract--filled",
    "label": "Subtract filled",
    "path": "32/subtract--filled.svg"
  },
  {
    "name": "subtract--large",
    "label": "Subtract large",
    "path": "32/subtract--large.svg"
  },
  {
    "name": "summary--KPI",
    "label": "Summary KPI",
    "path": "32/summary--KPI.svg"
  },
  {
    "name": "summary--KPI--mirror",
    "label": "Summary KPI mirror",
    "path": "32/summary--KPI--mirror.svg"
  },
  {
    "name": "sun",
    "label": "Sun",
    "path": "32/sun.svg"
  },
  {
    "name": "sunrise",
    "label": "Sunrise",
    "path": "32/sunrise.svg"
  },
  {
    "name": "sunset",
    "label": "Sunset",
    "path": "32/sunset.svg"
  },
  {
    "name": "support-vector-machine",
    "label": "Support vector machine",
    "path": "32/support-vector-machine.svg"
  },
  {
    "name": "sustainability",
    "label": "Sustainability",
    "path": "32/sustainability.svg"
  },
  {
    "name": "SVG",
    "label": "SVG",
    "path": "32/SVG.svg"
  },
  {
    "name": "swim",
    "label": "Swim",
    "path": "32/swim.svg"
  },
  {
    "name": "switch-layer-2",
    "label": "Switch layer 2",
    "path": "32/switch-layer-2.svg"
  },
  {
    "name": "switch-layer-3",
    "label": "Switch layer 3",
    "path": "32/switch-layer-3.svg"
  },
  {
    "name": "switcher",
    "label": "Switcher",
    "path": "32/switcher.svg"
  },
  {
    "name": "sync-settings",
    "label": "Sync settings",
    "path": "32/sync-settings.svg"
  },
  {
    "name": "sys-provision",
    "label": "Sys provision",
    "path": "32/sys-provision.svg"
  },
  {
    "name": "T",
    "label": "T",
    "path": "32/Q/T.svg"
  },
  {
    "name": "T--alt",
    "label": "T alt",
    "path": "32/Q/T--alt.svg"
  },
  {
    "name": "table",
    "label": "Table",
    "path": "32/table.svg"
  },
  {
    "name": "table--alias",
    "label": "Table alias",
    "path": "32/table--alias.svg"
  },
  {
    "name": "table--built",
    "label": "Table built",
    "path": "32/table--built.svg"
  },
  {
    "name": "table--shortcut",
    "label": "Table shortcut",
    "path": "32/table--shortcut.svg"
  },
  {
    "name": "table--split",
    "label": "Table split",
    "path": "32/table--split.svg"
  },
  {
    "name": "table-of-contents",
    "label": "Table of contents",
    "path": "32/table-of-contents.svg"
  },
  {
    "name": "tablet",
    "label": "Tablet",
    "path": "32/tablet.svg"
  },
  {
    "name": "tablet--landscape",
    "label": "Tablet landscape",
    "path": "32/tablet--landscape.svg"
  },
  {
    "name": "tag",
    "label": "Tag",
    "path": "32/tag.svg"
  },
  {
    "name": "tag--edit",
    "label": "Tag edit",
    "path": "32/tag--edit.svg"
  },
  {
    "name": "tag--export",
    "label": "Tag export",
    "path": "32/tag--export.svg"
  },
  {
    "name": "tag--group",
    "label": "Tag group",
    "path": "32/tag--group.svg"
  },
  {
    "name": "tag--import",
    "label": "Tag import",
    "path": "32/tag--import.svg"
  },
  {
    "name": "tag--none",
    "label": "Tag none",
    "path": "32/tag--none.svg"
  },
  {
    "name": "tank",
    "label": "Tank",
    "path": "32/tank.svg"
  },
  {
    "name": "task",
    "label": "Task",
    "path": "32/task.svg"
  },
  {
    "name": "task--add",
    "label": "Task add",
    "path": "32/task--add.svg"
  },
  {
    "name": "task--approved",
    "label": "Task approved",
    "path": "32/task--approved.svg"
  },
  {
    "name": "task--asset-view",
    "label": "Task asset-view",
    "path": "32/task--asset-view.svg"
  },
  {
    "name": "task--complete",
    "label": "Task complete",
    "path": "32/task--complete.svg"
  },
  {
    "name": "task--location",
    "label": "Task location",
    "path": "32/task--location.svg"
  },
  {
    "name": "task--remove",
    "label": "Task remove",
    "path": "32/task--remove.svg"
  },
  {
    "name": "task--settings",
    "label": "Task settings",
    "path": "32/task--settings.svg"
  },
  {
    "name": "task--star",
    "label": "Task star",
    "path": "32/task--star.svg"
  },
  {
    "name": "task--tools",
    "label": "Task tools",
    "path": "32/task--tools.svg"
  },
  {
    "name": "task--view",
    "label": "Task view",
    "path": "32/task--view.svg"
  },
  {
    "name": "taste",
    "label": "Taste",
    "path": "32/taste.svg"
  },
  {
    "name": "taxi",
    "label": "Taxi",
    "path": "32/taxi.svg"
  },
  {
    "name": "tcp-ip-service",
    "label": "TCP IP Service",
    "path": "32/tcp-ip-service.svg"
  },
  {
    "name": "temperature",
    "label": "Temperature",
    "path": "32/temperature.svg"
  },
  {
    "name": "temperature--celsius",
    "label": "Temperature Celsius",
    "path": "32/temperature--celsius.svg"
  },
  {
    "name": "temperature--celsius--alt",
    "label": "Temperature Celsius alt",
    "path": "32/temperature--celsius--alt.svg"
  },
  {
    "name": "temperature--fahrenheit",
    "label": "Temperature Fahrenheit",
    "path": "32/temperature--fahrenheit.svg"
  },
  {
    "name": "temperature--fahrenheit--alt",
    "label": "Temperature Fahrenheit alt",
    "path": "32/temperature--fahrenheit--alt.svg"
  },
  {
    "name": "temperature--feels-like",
    "label": "Temperature feels-like",
    "path": "32/temperature--feels-like.svg"
  },
  {
    "name": "temperature--frigid",
    "label": "Temperature frigid",
    "path": "32/temperature--frigid.svg"
  },
  {
    "name": "temperature--hot",
    "label": "Temperature hot",
    "path": "32/temperature--hot.svg"
  },
  {
    "name": "temperature--inversion",
    "label": "Temperature inversion",
    "path": "32/temperature--inversion.svg"
  },
  {
    "name": "temperature--max",
    "label": "Temperature max",
    "path": "32/temperature--max.svg"
  },
  {
    "name": "temperature--min",
    "label": "Temperature min",
    "path": "32/temperature--min.svg"
  },
  {
    "name": "temperature--water",
    "label": "Temperature water",
    "path": "32/temperature--water.svg"
  },
  {
    "name": "template",
    "label": "Template",
    "path": "32/template.svg"
  },
  {
    "name": "tennis",
    "label": "Tennis",
    "path": "32/tennis.svg"
  },
  {
    "name": "tennis-ball",
    "label": "Tennis ball",
    "path": "32/tennis-ball.svg"
  },
  {
    "name": "term",
    "label": "Term",
    "path": "32/term.svg"
  },
  {
    "name": "terminal",
    "label": "Terminal",
    "path": "32/terminal.svg"
  },
  {
    "name": "terminal--3270",
    "label": "Terminal 3270",
    "path": "32/terminal--3270.svg"
  },
  {
    "name": "test-tool",
    "label": "Test tool",
    "path": "32/test-tool.svg"
  },
  {
    "name": "text--align--center",
    "label": "Text align center",
    "path": "32/text--align--center.svg"
  },
  {
    "name": "text--align--justify",
    "label": "Text align justify",
    "path": "32/text--align--justify.svg"
  },
  {
    "name": "text--align--left",
    "label": "Text align left",
    "path": "32/text--align--left.svg"
  },
  {
    "name": "text--align--mixed",
    "label": "Text align mixed",
    "path": "32/text--align--mixed.svg"
  },
  {
    "name": "text--align--right",
    "label": "Text align right",
    "path": "32/text--align--right.svg"
  },
  {
    "name": "text--all-caps",
    "label": "Text all caps",
    "path": "32/text--all-caps.svg"
  },
  {
    "name": "text--bold",
    "label": "Text bold",
    "path": "32/text--bold.svg"
  },
  {
    "name": "text--clear-format",
    "label": "Text clear format",
    "path": "32/text--clear-format.svg"
  },
  {
    "name": "text--color",
    "label": "Text color",
    "path": "32/text--color.svg"
  },
  {
    "name": "text--creation",
    "label": "Text creation",
    "path": "32/text--creation.svg"
  },
  {
    "name": "text--fill",
    "label": "Text fill",
    "path": "32/text--fill.svg"
  },
  {
    "name": "text--font",
    "label": "Text font",
    "path": "32/text--font.svg"
  },
  {
    "name": "text--footnote",
    "label": "Text footnote",
    "path": "32/text--footnote.svg"
  },
  {
    "name": "text--highlight",
    "label": "Text highlight",
    "path": "32/text--highlight.svg"
  },
  {
    "name": "text--indent",
    "label": "Text indent",
    "path": "32/text--indent.svg"
  },
  {
    "name": "text--indent--less",
    "label": "Text indent less",
    "path": "32/text--indent--less.svg"
  },
  {
    "name": "text--indent--more",
    "label": "Text indent more",
    "path": "32/text--indent--more.svg"
  },
  {
    "name": "text--italic",
    "label": "Text italic",
    "path": "32/text--italic.svg"
  },
  {
    "name": "text--kerning",
    "label": "Text kerning",
    "path": "32/text--kerning.svg"
  },
  {
    "name": "text--leading",
    "label": "Text leading",
    "path": "32/text--leading.svg"
  },
  {
    "name": "text--line-spacing",
    "label": "Text line spacing",
    "path": "32/text--line-spacing.svg"
  },
  {
    "name": "text--long-paragraph",
    "label": "Text long paragraph",
    "path": "32/text--long-paragraph.svg"
  },
  {
    "name": "text--new-line",
    "label": "Text new line",
    "path": "32/text--new-line.svg"
  },
  {
    "name": "text--scale",
    "label": "Text scale",
    "path": "32/text--scale.svg"
  },
  {
    "name": "text--selection",
    "label": "Text selection",
    "path": "32/text--selection.svg"
  },
  {
    "name": "text--short-paragraph",
    "label": "Text short paragraph",
    "path": "32/text--short-paragraph.svg"
  },
  {
    "name": "text--small-caps",
    "label": "Text small caps",
    "path": "32/text--small-caps.svg"
  },
  {
    "name": "text--strikethrough",
    "label": "Text strikethrough",
    "path": "32/text--strikethrough.svg"
  },
  {
    "name": "text--subscript",
    "label": "Text subscript",
    "path": "32/text--subscript.svg"
  },
  {
    "name": "text--superscript",
    "label": "Text superscript",
    "path": "32/text--superscript.svg"
  },
  {
    "name": "text--tracking",
    "label": "Text tracking",
    "path": "32/text--tracking.svg"
  },
  {
    "name": "text--underline",
    "label": "Text underline",
    "path": "32/text--underline.svg"
  },
  {
    "name": "text--vertical-alignment",
    "label": "Text vertical alignment",
    "path": "32/text--vertical-alignment.svg"
  },
  {
    "name": "text--wrap",
    "label": "Text wrap",
    "path": "32/text--wrap.svg"
  },
  {
    "name": "text-annotation-toggle",
    "label": "Text annotation toggle",
    "path": "32/watson-health/text-annotation-toggle.svg"
  },
  {
    "name": "text-link",
    "label": "Text link",
    "path": "32/text-link.svg"
  },
  {
    "name": "text-link--analysis",
    "label": "Text link analysis",
    "path": "32/text-link--analysis.svg"
  },
  {
    "name": "text-mining",
    "label": "Text mining",
    "path": "32/text-mining.svg"
  },
  {
    "name": "text-mining--applier",
    "label": "Text mining applier",
    "path": "32/text-mining--applier.svg"
  },
  {
    "name": "theater",
    "label": "Theater",
    "path": "32/theater.svg"
  },
  {
    "name": "this-side-up",
    "label": "This side up",
    "path": "32/this-side-up.svg"
  },
  {
    "name": "threshold",
    "label": "Threshold",
    "path": "32/watson-health/threshold.svg"
  },
  {
    "name": "thumbnail--1",
    "label": "Thumbnail 1",
    "path": "32/thumbnail--1.svg"
  },
  {
    "name": "thumbnail--2",
    "label": "Thumbnail 2",
    "path": "32/thumbnail--2.svg"
  },
  {
    "name": "thumbnail-preview",
    "label": "Thumbnail preview",
    "path": "32/watson-health/thumbnail-preview.svg"
  },
  {
    "name": "thumbs-down",
    "label": "Thumbs down",
    "path": "32/thumbs-down.svg"
  },
  {
    "name": "thumbs-down--filled",
    "label": "Thumbs down filled",
    "path": "32/thumbs-down--filled.svg"
  },
  {
    "name": "thumbs-up",
    "label": "Thumbs up",
    "path": "32/thumbs-up.svg"
  },
  {
    "name": "thumbs-up--filled",
    "label": "Thumbs up filled",
    "path": "32/thumbs-up--filled.svg"
  },
  {
    "name": "thunderstorm",
    "label": "Thunderstorm",
    "path": "32/thunderstorm.svg"
  },
  {
    "name": "thunderstorm--scattered",
    "label": "Thunderstorm scattered",
    "path": "32/thunderstorm--scattered.svg"
  },
  {
    "name": "thunderstorm--scattered--night",
    "label": "Thunderstorm scattered night",
    "path": "32/thunderstorm--scattered--night.svg"
  },
  {
    "name": "thunderstorm--severe",
    "label": "Thunderstorm severe",
    "path": "32/thunderstorm--severe.svg"
  },
  {
    "name": "thunderstorm--strong",
    "label": "Thunderstorm strong",
    "path": "32/thunderstorm--strong.svg"
  },
  {
    "name": "ticket",
    "label": "Ticket",
    "path": "32/ticket.svg"
  },
  {
    "name": "tides",
    "label": "Tides",
    "path": "32/tides.svg"
  },
  {
    "name": "TIF",
    "label": "TIF",
    "path": "32/TIF.svg"
  },
  {
    "name": "time",
    "label": "Time",
    "path": "32/time.svg"
  },
  {
    "name": "time--filled",
    "label": "Time filled",
    "path": "32/time--filled.svg"
  },
  {
    "name": "time-plot",
    "label": "Time plot",
    "path": "32/time-plot.svg"
  },
  {
    "name": "timer",
    "label": "Timer",
    "path": "32/timer.svg"
  },
  {
    "name": "tool-box",
    "label": "Tool box",
    "path": "32/tool-box.svg"
  },
  {
    "name": "tool-kit",
    "label": "Tool kit",
    "path": "32/tool-kit.svg"
  },
  {
    "name": "tools",
    "label": "Tools",
    "path": "32/tools.svg"
  },
  {
    "name": "tools--alt",
    "label": "Tools alt",
    "path": "32/tools--alt.svg"
  },
  {
    "name": "tornado",
    "label": "Tornado",
    "path": "32/tornado.svg"
  },
  {
    "name": "tornado-warning",
    "label": "Tornado warning",
    "path": "32/tornado-warning.svg"
  },
  {
    "name": "touch--1",
    "label": "Touch 1",
    "path": "32/touch--1.svg"
  },
  {
    "name": "touch--1--filled",
    "label": "Touch 1 filled",
    "path": "32/touch--1--filled.svg"
  },
  {
    "name": "touch--1-down",
    "label": "Touch 1 down",
    "path": "32/touch--1-down.svg"
  },
  {
    "name": "touch--1-down--filled",
    "label": "Touch 1 down filled",
    "path": "32/touch--1-down--filled.svg"
  },
  {
    "name": "touch--2",
    "label": "Touch 2",
    "path": "32/touch--2.svg"
  },
  {
    "name": "touch--2--filled",
    "label": "Touch 2 filled",
    "path": "32/touch--2--filled.svg"
  },
  {
    "name": "touch--interaction",
    "label": "Touch interaction",
    "path": "32/touch--interaction.svg"
  },
  {
    "name": "tour",
    "label": "Tour",
    "path": "32/tour.svg"
  },
  {
    "name": "traffic--event",
    "label": "Traffic event",
    "path": "32/traffic--event.svg"
  },
  {
    "name": "traffic--flow",
    "label": "Traffic flow",
    "path": "32/traffic--flow.svg"
  },
  {
    "name": "traffic--flow-incident",
    "label": "Traffic flow incident",
    "path": "32/traffic--flow-incident.svg"
  },
  {
    "name": "traffic--incident",
    "label": "Traffic incident",
    "path": "32/traffic--incident.svg"
  },
  {
    "name": "traffic--weather-incident",
    "label": "Traffic weather incident",
    "path": "32/traffic--weather-incident.svg"
  },
  {
    "name": "traffic-cone",
    "label": "Traffic cone",
    "path": "32/traffic-cone.svg"
  },
  {
    "name": "train",
    "label": "Train",
    "path": "32/train.svg"
  },
  {
    "name": "train--heart",
    "label": "Train heart",
    "path": "32/train--heart.svg"
  },
  {
    "name": "train--profile",
    "label": "Train profile",
    "path": "32/train--profile.svg"
  },
  {
    "name": "train--speed",
    "label": "Train speed",
    "path": "32/train--speed.svg"
  },
  {
    "name": "train--ticket",
    "label": "Train ticket",
    "path": "32/train--ticket.svg"
  },
  {
    "name": "train--time",
    "label": "Train time",
    "path": "32/train--time.svg"
  },
  {
    "name": "tram",
    "label": "Tram",
    "path": "32/tram.svg"
  },
  {
    "name": "transform--binary",
    "label": "Transform binary",
    "path": "32/transform--binary.svg"
  },
  {
    "name": "transform--instructions",
    "label": "Transform instructions",
    "path": "32/transform--instructions.svg"
  },
  {
    "name": "transform--language",
    "label": "Transform language",
    "path": "32/transform--language.svg"
  },
  {
    "name": "transgender",
    "label": "Transgender",
    "path": "32/transgender.svg"
  },
  {
    "name": "translate",
    "label": "Translate",
    "path": "32/translate.svg"
  },
  {
    "name": "transmission-lte",
    "label": "Transmission LTE",
    "path": "32/transmission-lte.svg"
  },
  {
    "name": "transpose",
    "label": "Transpose",
    "path": "32/transpose.svg"
  },
  {
    "name": "trash-can",
    "label": "Trash can",
    "path": "32/trash-can.svg"
  },
  {
    "name": "tree",
    "label": "Tree",
    "path": "32/tree.svg"
  },
  {
    "name": "tree--fall-risk",
    "label": "Tree fall risk",
    "path": "32/tree--fall-risk.svg"
  },
  {
    "name": "tree-view",
    "label": "Tree view",
    "path": "32/tree-view.svg"
  },
  {
    "name": "tree-view--alt",
    "label": "Tree view alt",
    "path": "32/tree-view--alt.svg"
  },
  {
    "name": "triangle--down--outline",
    "label": "Triangle down outline",
    "path": "32/triangle--down--outline.svg"
  },
  {
    "name": "triangle--down--solid",
    "label": "Triangle down solid",
    "path": "32/triangle--down--solid.svg"
  },
  {
    "name": "triangle--left--outline",
    "label": "Triangle left outline",
    "path": "32/triangle--left--outline.svg"
  },
  {
    "name": "triangle--left--solid",
    "label": "Triangle left solid",
    "path": "32/triangle--left--solid.svg"
  },
  {
    "name": "triangle--outline",
    "label": "Triangle outline",
    "path": "32/triangle--outline.svg"
  },
  {
    "name": "triangle--right--outline",
    "label": "Triangle right outline",
    "path": "32/triangle--right--outline.svg"
  },
  {
    "name": "triangle--right--solid",
    "label": "Triangle right solid",
    "path": "32/triangle--right--solid.svg"
  },
  {
    "name": "triangle--solid",
    "label": "Triangle solid",
    "path": "32/triangle--solid.svg"
  },
  {
    "name": "trophy",
    "label": "Trophy",
    "path": "32/trophy.svg"
  },
  {
    "name": "trophy--filled",
    "label": "Trophy filled",
    "path": "32/trophy--filled.svg"
  },
  {
    "name": "tropical-storm",
    "label": "Tropical storm",
    "path": "32/tropical-storm.svg"
  },
  {
    "name": "tropical-storm--model-tracks",
    "label": "Tropical storm model tracks",
    "path": "32/tropical-storm--model-tracks.svg"
  },
  {
    "name": "tropical-storm--tracks",
    "label": "tropical-storm--tracks",
    "path": "32/tropical-storm--tracks.svg"
  },
  {
    "name": "tropical-warning",
    "label": "Tropical warning",
    "path": "32/tropical-warning.svg"
  },
  {
    "name": "tsq",
    "label": "TSQ",
    "path": "32/tsq.svg"
  },
  {
    "name": "tsunami",
    "label": "Tsunami",
    "path": "32/tsunami.svg"
  },
  {
    "name": "TSV",
    "label": "TSV",
    "path": "32/TSV.svg"
  },
  {
    "name": "tuning",
    "label": "Tuning",
    "path": "32/tuning.svg"
  },
  {
    "name": "two-factor-authentication",
    "label": "Two-factor authentication",
    "path": "32/two-factor-authentication.svg"
  },
  {
    "name": "two-person-lift",
    "label": "Two-person lift",
    "path": "32/two-person-lift.svg"
  },
  {
    "name": "TXT",
    "label": "TXT",
    "path": "32/TXT.svg"
  },
  {
    "name": "TXT--reference",
    "label": "TXT reference",
    "path": "32/TXT--reference.svg"
  },
  {
    "name": "type-pattern",
    "label": "Type pattern",
    "path": "32/type-pattern.svg"
  },
  {
    "name": "types",
    "label": "Types",
    "path": "32/types.svg"
  },
  {
    "name": "U1",
    "label": "U1",
    "path": "32/Q/U1.svg"
  },
  {
    "name": "U2",
    "label": "U2",
    "path": "32/Q/U2.svg"
  },
  {
    "name": "U3",
    "label": "U3",
    "path": "32/Q/U3.svg"
  },
  {
    "name": "umbrella",
    "label": "Umbrella",
    "path": "32/umbrella.svg"
  },
  {
    "name": "undefined",
    "label": "Undefined",
    "path": "32/undefined.svg"
  },
  {
    "name": "undefined--filled",
    "label": "Undefined filled",
    "path": "32/undefined--filled.svg"
  },
  {
    "name": "undo",
    "label": "Undo",
    "path": "32/undo.svg"
  },
  {
    "name": "ungroup-objects",
    "label": "Ungroup objects",
    "path": "32/ungroup-objects.svg"
  },
  {
    "name": "unknown",
    "label": "Unknown",
    "path": "32/unknown.svg"
  },
  {
    "name": "unknown--filled",
    "label": "Unknown filled",
    "path": "32/unknown--filled.svg"
  },
  {
    "name": "unlink",
    "label": "Unlink",
    "path": "32/unlink.svg"
  },
  {
    "name": "unlocked",
    "label": "Unlocked",
    "path": "32/unlocked.svg"
  },
  {
    "name": "unsaved",
    "label": "Unsaved",
    "path": "32/unsaved.svg"
  },
  {
    "name": "up-to-top",
    "label": "Up to top",
    "path": "32/up-to-top.svg"
  },
  {
    "name": "update-now",
    "label": "Update now",
    "path": "32/update-now.svg"
  },
  {
    "name": "upgrade",
    "label": "Upgrade",
    "path": "32/upgrade.svg"
  },
  {
    "name": "upload",
    "label": "Upload",
    "path": "32/upload.svg"
  },
  {
    "name": "upstream",
    "label": "Upstream",
    "path": "32/upstream.svg"
  },
  {
    "name": "URL",
    "label": "URL",
    "path": "32/URL.svg"
  },
  {
    "name": "USB",
    "label": "USB",
    "path": "32/USB.svg"
  },
  {
    "name": "user",
    "label": "User",
    "path": "32/user.svg"
  },
  {
    "name": "user--access",
    "label": "User access",
    "path": "32/user--access.svg"
  },
  {
    "name": "user--activity",
    "label": "User activity",
    "path": "32/user--activity.svg"
  },
  {
    "name": "user--admin",
    "label": "User admin",
    "path": "32/user--admin.svg"
  },
  {
    "name": "user--avatar",
    "label": "User avatar",
    "path": "32/user--avatar.svg"
  },
  {
    "name": "user--avatar--filled",
    "label": "User avatar filled",
    "path": "32/user--avatar--filled.svg"
  },
  {
    "name": "user--avatar--filled--alt",
    "label": "User avatar filled alt",
    "path": "32/user--avatar--filled--alt.svg"
  },
  {
    "name": "user--certification",
    "label": "User certification",
    "path": "32/user--certification.svg"
  },
  {
    "name": "user--data",
    "label": "User data",
    "path": "32/user--data.svg"
  },
  {
    "name": "user--favorite",
    "label": "User favorite",
    "path": "32/user--favorite.svg"
  },
  {
    "name": "user--favorite--alt",
    "label": "User favorite alt",
    "path": "32/user--favorite--alt.svg"
  },
  {
    "name": "user--favorite--alt--filled",
    "label": "User favorite alt filled",
    "path": "32/user--favorite--alt--filled.svg"
  },
  {
    "name": "user--filled",
    "label": "User filled",
    "path": "32/user--filled.svg"
  },
  {
    "name": "user--follow",
    "label": "User follow",
    "path": "32/user--follow.svg"
  },
  {
    "name": "user--identification",
    "label": "User identification",
    "path": "32/user--identification.svg"
  },
  {
    "name": "user--military",
    "label": "User military",
    "path": "32/user--military.svg"
  },
  {
    "name": "user--multiple",
    "label": "User multiple",
    "path": "32/user--multiple.svg"
  },
  {
    "name": "user--online",
    "label": "User online",
    "path": "32/user--online.svg"
  },
  {
    "name": "user--profile",
    "label": "User profile",
    "path": "32/user--profile.svg"
  },
  {
    "name": "user--role",
    "label": "User role",
    "path": "32/user--role.svg"
  },
  {
    "name": "user--service-desk",
    "label": "User service desk",
    "path": "32/user--service-desk.svg"
  },
  {
    "name": "user--settings",
    "label": "User settings",
    "path": "32/user--settings.svg"
  },
  {
    "name": "user--simulation",
    "label": "User simulation",
    "path": "32/user--simulation.svg"
  },
  {
    "name": "user--speaker",
    "label": "User speaker",
    "path": "32/user--speaker.svg"
  },
  {
    "name": "user--sponsor",
    "label": "User sponsor",
    "path": "32/user--sponsor.svg"
  },
  {
    "name": "user--x-ray",
    "label": "User x-ray",
    "path": "32/user--x-ray.svg"
  },
  {
    "name": "user-profile--alt",
    "label": "User profile alt",
    "path": "32/user-profile--alt.svg"
  },
  {
    "name": "uv-index",
    "label": "UV index",
    "path": "32/uv-index.svg"
  },
  {
    "name": "uv-index--alt",
    "label": "UV index alt",
    "path": "32/uv-index--alt.svg"
  },
  {
    "name": "uv-index--filled",
    "label": "UV index filled",
    "path": "32/uv-index--filled.svg"
  },
  {
    "name": "value--variable",
    "label": "Value variable",
    "path": "32/value--variable.svg"
  },
  {
    "name": "van",
    "label": "Van",
    "path": "32/van.svg"
  },
  {
    "name": "vegetation--asset",
    "label": "Vegetation asset",
    "path": "32/vegetation--asset.svg"
  },
  {
    "name": "vegetation--encroachment",
    "label": "Vegetation encroachment",
    "path": "32/vegetation--encroachment.svg"
  },
  {
    "name": "vegetation--height",
    "label": "Vegetation height",
    "path": "32/vegetation--height.svg"
  },
  {
    "name": "vehicle--api",
    "label": "Vehicle API",
    "path": "32/vehicle--api.svg"
  },
  {
    "name": "vehicle--connected",
    "label": "Vehicle connected",
    "path": "32/vehicle--connected.svg"
  },
  {
    "name": "vehicle--insights",
    "label": "Vehicle insights",
    "path": "32/vehicle--insights.svg"
  },
  {
    "name": "vehicle--services",
    "label": "Vehicle services",
    "path": "32/vehicle--services.svg"
  },
  {
    "name": "version",
    "label": "Version",
    "path": "32/version.svg"
  },
  {
    "name": "version--major",
    "label": "Version major",
    "path": "32/version--major.svg"
  },
  {
    "name": "version--minor",
    "label": "Version minor",
    "path": "32/version--minor.svg"
  },
  {
    "name": "version--patch",
    "label": "Version patch",
    "path": "32/version--patch.svg"
  },
  {
    "name": "vertical-view",
    "label": "Vertical view",
    "path": "32/vertical-view.svg"
  },
  {
    "name": "video",
    "label": "Video",
    "path": "32/video.svg"
  },
  {
    "name": "video--add",
    "label": "Video add",
    "path": "32/video--add.svg"
  },
  {
    "name": "video--chat",
    "label": "Video chat",
    "path": "32/video--chat.svg"
  },
  {
    "name": "video--filled",
    "label": "Video filled",
    "path": "32/video--filled.svg"
  },
  {
    "name": "video--off",
    "label": "Video off",
    "path": "32/video--off.svg"
  },
  {
    "name": "video--off--filled",
    "label": "Video off filled",
    "path": "32/video--off--filled.svg"
  },
  {
    "name": "video-player",
    "label": "Video player",
    "path": "32/video-player.svg"
  },
  {
    "name": "view",
    "label": "View",
    "path": "32/view.svg"
  },
  {
    "name": "view--filled",
    "label": "View filled",
    "path": "32/view--filled.svg"
  },
  {
    "name": "view--mode-1",
    "label": "View mode 1",
    "path": "32/view--mode-1.svg"
  },
  {
    "name": "view--mode-2",
    "label": "View mode 2",
    "path": "32/view--mode-2.svg"
  },
  {
    "name": "view--off",
    "label": "View off",
    "path": "32/view--off.svg"
  },
  {
    "name": "view--off--filled",
    "label": "View off filled",
    "path": "32/view--off--filled.svg"
  },
  {
    "name": "view-next",
    "label": "View next",
    "path": "32/view-next.svg"
  },
  {
    "name": "virtual-column",
    "label": "Virtual column",
    "path": "32/virtual-column.svg"
  },
  {
    "name": "virtual-column--key",
    "label": "Virtual column key",
    "path": "32/virtual-column--key.svg"
  },
  {
    "name": "virtual-desktop",
    "label": "Virtual desktop",
    "path": "32/virtual-desktop.svg"
  },
  {
    "name": "virtual-machine",
    "label": "Virtual machine",
    "path": "32/virtual-machine.svg"
  },
  {
    "name": "virtual-private-cloud",
    "label": "Virtual private cloud",
    "path": "32/virtual-private-cloud.svg"
  },
  {
    "name": "virtual-private-cloud--alt",
    "label": "IBM Cloud® VPC",
    "path": "32/virtual-private-cloud--alt.svg"
  },
  {
    "name": "visual-recognition",
    "label": "Visual recognition",
    "path": "32/visual-recognition.svg"
  },
  {
    "name": "vlan",
    "label": "VLAN",
    "path": "32/vlan.svg"
  },
  {
    "name": "vlan--ibm",
    "label": "IBM Cloud® VLAN",
    "path": "32/vlan--ibm.svg"
  },
  {
    "name": "vmdk-disk",
    "label": "VMDK disk",
    "path": "32/vmdk-disk.svg"
  },
  {
    "name": "voice-activate",
    "label": "Voice activate",
    "path": "32/voice-activate.svg"
  },
  {
    "name": "voicemail",
    "label": "Voicemail",
    "path": "32/voicemail.svg"
  },
  {
    "name": "volume--block-storage",
    "label": "Block volume",
    "path": "32/volume--block-storage.svg"
  },
  {
    "name": "volume--down",
    "label": "Volume down",
    "path": "32/volume--down.svg"
  },
  {
    "name": "volume--down--alt",
    "label": "Volume down alt",
    "path": "32/volume--down--alt.svg"
  },
  {
    "name": "volume--down--filled",
    "label": "Volume down filled",
    "path": "32/volume--down--filled.svg"
  },
  {
    "name": "volume--down--filled--alt",
    "label": "Volume down filled alt",
    "path": "32/volume--down--filled--alt.svg"
  },
  {
    "name": "volume--file-storage",
    "label": "File system",
    "path": "32/volume--file-storage.svg"
  },
  {
    "name": "volume--mute",
    "label": "Volume mute",
    "path": "32/volume--mute.svg"
  },
  {
    "name": "volume--mute--filled",
    "label": "Volume mute filled",
    "path": "32/volume--mute--filled.svg"
  },
  {
    "name": "volume--object-storage",
    "label": "Object bucket",
    "path": "32/volume--object-storage.svg"
  },
  {
    "name": "volume--up",
    "label": "Volume up",
    "path": "32/volume--up.svg"
  },
  {
    "name": "volume--up--alt",
    "label": "Volume up alt",
    "path": "32/volume--up--alt.svg"
  },
  {
    "name": "volume--up--filled",
    "label": "Volume up filled",
    "path": "32/volume--up--filled.svg"
  },
  {
    "name": "volume--up--filled--alt",
    "label": "Volume up filled alt",
    "path": "32/volume--up--filled--alt.svg"
  },
  {
    "name": "VPN",
    "label": "VPN",
    "path": "32/VPN.svg"
  },
  {
    "name": "vpn--connection",
    "label": "VPN connection",
    "path": "32/vpn--connection.svg"
  },
  {
    "name": "vpn--policy",
    "label": "VPN policy",
    "path": "32/vpn--policy.svg"
  },
  {
    "name": "wallet",
    "label": "Wallet",
    "path": "32/wallet.svg"
  },
  {
    "name": "warning",
    "label": "Warning",
    "path": "32/warning.svg"
  },
  {
    "name": "warning--alt",
    "label": "Warning alt",
    "path": "32/warning--alt.svg"
  },
  {
    "name": "warning--alt--filled",
    "label": "Warning alt filled",
    "path": "32/warning--alt--filled.svg"
  },
  {
    "name": "warning--alt-inverted",
    "label": "Warning alt inverted",
    "path": "32/warning--alt-inverted.svg"
  },
  {
    "name": "warning--alt-inverted--filled",
    "label": "Warning alt inverted filled",
    "path": "32/warning--alt-inverted--filled.svg"
  },
  {
    "name": "warning--diamond",
    "label": "Warning diamond",
    "path": "32/warning--diamond.svg"
  },
  {
    "name": "warning--filled",
    "label": "Warning filled",
    "path": "32/warning--filled.svg"
  },
  {
    "name": "warning--hex",
    "label": "Warning hex",
    "path": "32/warning--hex.svg"
  },
  {
    "name": "warning--hex--filled",
    "label": "Warning hex filled",
    "path": "32/warning--hex--filled.svg"
  },
  {
    "name": "warning--multiple",
    "label": "Warning multiple",
    "path": "32/warning--multiple.svg"
  },
  {
    "name": "warning--other",
    "label": "Warning other",
    "path": "32/warning--other.svg"
  },
  {
    "name": "warning-square",
    "label": "Warning square",
    "path": "32/warning-square.svg"
  },
  {
    "name": "warning-square--filled",
    "label": "Warning square filled",
    "path": "32/warning-square--filled.svg"
  },
  {
    "name": "watch",
    "label": "Watch",
    "path": "32/watch.svg"
  },
  {
    "name": "watson",
    "label": "Watson™",
    "path": "32/watson.svg"
  },
  {
    "name": "watson--machine-learning",
    "label": "IBM® Machine Learning",
    "path": "32/watson--machine-learning.svg"
  },
  {
    "name": "watsonx",
    "label": "IBM® watsonx™",
    "path": "32/watsonx.svg"
  },
  {
    "name": "watsonx-ai",
    "label": "IBM® watsonx.ai™",
    "path": "32/watsonx-ai.svg"
  },
  {
    "name": "watsonx-data",
    "label": "IBM® watsonx.data™",
    "path": "32/watsonx-data.svg"
  },
  {
    "name": "watsonx-governance",
    "label": "IBM® watsonx.governance™",
    "path": "32/watsonx-governance.svg"
  },
  {
    "name": "wave-direction",
    "label": "Wave direction",
    "path": "32/wave-direction.svg"
  },
  {
    "name": "wave-height",
    "label": "Wave height",
    "path": "32/wave-height.svg"
  },
  {
    "name": "wave-period",
    "label": "Wave period",
    "path": "32/wave-period.svg"
  },
  {
    "name": "weather-front--cold",
    "label": "Weather front cold",
    "path": "32/weather-front--cold.svg"
  },
  {
    "name": "weather-front--stationary",
    "label": "Weather front stationary",
    "path": "32/weather-front--stationary.svg"
  },
  {
    "name": "weather-front--warm",
    "label": "Weather front warm",
    "path": "32/weather-front--warm.svg"
  },
  {
    "name": "weather-station",
    "label": "Weather station",
    "path": "32/weather-station.svg"
  },
  {
    "name": "web-services--cluster",
    "label": "Web services cluster",
    "path": "32/web-services--cluster.svg"
  },
  {
    "name": "web-services--container",
    "label": "Web services container",
    "path": "32/web-services--container.svg"
  },
  {
    "name": "web-services--definition",
    "label": "Web services definition",
    "path": "32/web-services--definition.svg"
  },
  {
    "name": "web-services--service",
    "label": "Web services service",
    "path": "32/web-services--service.svg"
  },
  {
    "name": "web-services--task",
    "label": "Web services task",
    "path": "32/web-services--task.svg"
  },
  {
    "name": "web-services--task-definition-version",
    "label": "Web services task definition version",
    "path": "32/web-services--task-definition-version.svg"
  },
  {
    "name": "webhook",
    "label": "Webhook",
    "path": "32/webhook.svg"
  },
  {
    "name": "websheet",
    "label": "Websheet",
    "path": "32/websheet.svg"
  },
  {
    "name": "wheat",
    "label": "Wheat",
    "path": "32/wheat.svg"
  },
  {
    "name": "white-paper",
    "label": "White paper",
    "path": "32/white-paper.svg"
  },
  {
    "name": "wifi",
    "label": "WiFi",
    "path": "32/wifi.svg"
  },
  {
    "name": "wifi--controller",
    "label": "WiFi controller",
    "path": "32/wifi--controller.svg"
  },
  {
    "name": "wifi--not-secure",
    "label": "WiFi not secure",
    "path": "32/wifi--not-secure.svg"
  },
  {
    "name": "wifi--off",
    "label": "WiFi off",
    "path": "32/wifi--off.svg"
  },
  {
    "name": "wifi--secure",
    "label": "WiFi secure",
    "path": "32/wifi--secure.svg"
  },
  {
    "name": "wifi-bridge",
    "label": "WiFi bridge",
    "path": "32/wifi-bridge.svg"
  },
  {
    "name": "wifi-bridge--alt",
    "label": "WiFi bridge alt",
    "path": "32/wifi-bridge--alt.svg"
  },
  {
    "name": "wikis",
    "label": "Wikis",
    "path": "32/wikis.svg"
  },
  {
    "name": "wind-gusts",
    "label": "Wind gusts",
    "path": "32/wind-gusts.svg"
  },
  {
    "name": "wind-power",
    "label": "Wind power",
    "path": "32/wind-power.svg"
  },
  {
    "name": "wind-stream",
    "label": "Wind stream",
    "path": "32/wind-stream.svg"
  },
  {
    "name": "window--auto",
    "label": "Window auto",
    "path": "32/watson-health/window--auto.svg"
  },
  {
    "name": "window--base",
    "label": "Window base",
    "path": "32/watson-health/window--base.svg"
  },
  {
    "name": "window--black-saturation",
    "label": "Window black saturation",
    "path": "32/watson-health/window--black-saturation.svg"
  },
  {
    "name": "window--overlay",
    "label": "Window overlay",
    "path": "32/watson-health/window--overlay.svg"
  },
  {
    "name": "window--preset",
    "label": "Window preset",
    "path": "32/watson-health/window--preset.svg"
  },
  {
    "name": "windy",
    "label": "Windy",
    "path": "32/windy.svg"
  },
  {
    "name": "windy--dust",
    "label": "Windy dust",
    "path": "32/windy--dust.svg"
  },
  {
    "name": "windy--snow",
    "label": "Windy snow",
    "path": "32/windy--snow.svg"
  },
  {
    "name": "windy--strong",
    "label": "Windy strong",
    "path": "32/windy--strong.svg"
  },
  {
    "name": "winter-warning",
    "label": "Winter warning",
    "path": "32/winter-warning.svg"
  },
  {
    "name": "wintry-mix",
    "label": "Wintry mix",
    "path": "32/wintry-mix.svg"
  },
  {
    "name": "wireless-checkout",
    "label": "Wireless checkout",
    "path": "32/wireless-checkout.svg"
  },
  {
    "name": "WMV",
    "label": "WMV",
    "path": "32/WMV.svg"
  },
  {
    "name": "word-cloud",
    "label": "Word cloud",
    "path": "32/word-cloud.svg"
  },
  {
    "name": "workflow-automation",
    "label": "Workflow automation",
    "path": "32/workflow-automation.svg"
  },
  {
    "name": "workspace",
    "label": "Workspace",
    "path": "32/workspace.svg"
  },
  {
    "name": "workspace--import",
    "label": "Workspace import",
    "path": "32/workspace--import.svg"
  },
  {
    "name": "worship",
    "label": "Worship",
    "path": "32/worship.svg"
  },
  {
    "name": "worship--christian",
    "label": "Worship Christian",
    "path": "32/worship--christian.svg"
  },
  {
    "name": "worship--jewish",
    "label": "Worship Jewish",
    "path": "32/worship--jewish.svg"
  },
  {
    "name": "worship--muslim",
    "label": "Worship Muslim",
    "path": "32/worship--muslim.svg"
  },
  {
    "name": "X",
    "label": "X",
    "path": "32/Q/X.svg"
  },
  {
    "name": "x-axis",
    "label": "X axis",
    "path": "32/x-axis.svg"
  },
  {
    "name": "XLS",
    "label": "XLS",
    "path": "32/XLS.svg"
  },
  {
    "name": "XML",
    "label": "XML",
    "path": "32/XML.svg"
  },
  {
    "name": "Y",
    "label": "Y",
    "path": "32/Q/Y.svg"
  },
  {
    "name": "y-axis",
    "label": "Y axis",
    "path": "32/y-axis.svg"
  },
  {
    "name": "Z",
    "label": "Z",
    "path": "32/Q/Z.svg"
  },
  {
    "name": "z--lpar",
    "label": "IBM Z® LPAR",
    "path": "32/z--lpar.svg"
  },
  {
    "name": "z--systems",
    "label": "IBM Z®",
    "path": "32/z--systems.svg"
  },
  {
    "name": "z-axis",
    "label": "Z axis",
    "path": "32/z-axis.svg"
  },
  {
    "name": "ZIP",
    "label": "ZIP",
    "path": "32/ZIP.svg"
  },
  {
    "name": "ZIP--reference",
    "label": "ZIP reference",
    "path": "32/ZIP--reference.svg"
  },
  {
    "name": "zoom--area",
    "label": "Zoom area",
    "path": "32/zoom--area.svg"
  },
  {
    "name": "zoom--fit",
    "label": "Zoom fit",
    "path": "32/zoom--fit.svg"
  },
  {
    "name": "zoom--in",
    "label": "Zoom in",
    "path": "32/zoom--in.svg"
  },
  {
    "name": "zoom--in-area",
    "label": "Zoom in area",
    "path": "32/zoom--in-area.svg"
  },
  {
    "name": "zoom--out",
    "label": "Zoom out",
    "path": "32/zoom--out.svg"
  },
  {
    "name": "zoom--out-area",
    "label": "Zoom out area",
    "path": "32/zoom--out-area.svg"
  },
  {
    "name": "zoom--reset",
    "label": "Zoom reset",
    "path": "32/zoom--reset.svg"
  },
  {
    "name": "zoom-pan",
    "label": "Zoom pan",
    "path": "32/watson-health/zoom-pan.svg"
  },
  {
    "name": "zos",
    "label": "IBM® z/OS®",
    "path": "32/zos.svg"
  },
  {
    "name": "zos--sysplex",
    "label": "IBM® z/OS® sysplex",
    "path": "32/zos--sysplex.svg"
  }
]